webpackJsonp([231734337648933],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(29),
	    isLength = __webpack_require__(74);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(36),
	    baseAssignValue = __webpack_require__(37);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(58),
	    baseKeys = __webpack_require__(61),
	    isArrayLike = __webpack_require__(11);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(Buffer, process) {
	/**
	 * Cloudinary's JavaScript library - Version 2.5.0
	 * Copyright Cloudinary
	 * see https://github.com/cloudinary/cloudinary_js
	 *
	 */
	var slice = [].slice,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	(function(root, factory) {
	  var factoryWrapper, name, ref, results, value;
	  factoryWrapper = function(assign, cloneDeep, compact, difference, functions, identity, includes, isArray, isElement, isEmpty, isFunction, isPlainObject, isString, merge, trim) {
	    return factory({
	      assign: assign,
	      cloneDeep: cloneDeep,
	      compact: compact,
	      difference: difference,
	      functions: functions,
	      identity: identity,
	      includes: includes,
	      isArray: isArray,
	      isElement: isElement,
	      isEmpty: isEmpty,
	      isFunction: isFunction,
	      isPlainObject: isPlainObject,
	      isString: isString,
	      merge: merge,
	      trim: trim
	    });
	  };
	  if (true) {
	    return !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(192), __webpack_require__(193), __webpack_require__(194), __webpack_require__(196), __webpack_require__(197), __webpack_require__(42), __webpack_require__(198), __webpack_require__(7), __webpack_require__(199), __webpack_require__(200), __webpack_require__(29), __webpack_require__(43), __webpack_require__(75), __webpack_require__(203), __webpack_require__(209)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factoryWrapper), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    return module.exports = factoryWrapper(require('lodash/assign'), require('lodash/cloneDeep'), require('lodash/compact'), require('lodash/difference'), require('lodash/functions'), require('lodash/identity'), require('lodash/includes'), require('lodash/isArray'), require('lodash/isElement'), require('lodash/isEmpty'), require('lodash/isFunction'), require('lodash/isPlainObject'), require('lodash/isString'), require('lodash/merge'), require('lodash/trim'));
	  } else {
	    root.cloudinary || (root.cloudinary = {});
	    ref = factory(_);
	    results = [];
	    for (name in ref) {
	      value = ref[name];
	      results.push(root.cloudinary[name] = value);
	    }
	    return results;
	  }
	})(this, function(_) {
	
	  /*
	   * Includes common utility methods and shims
	   */
	
	  /**
	   * Return true if all items in list are strings
	   * @function Util.allString
	   * @param {Array} list - an array of items
	   */
	  var ArrayParam, BaseUtil, ClientHintsMetaTag, Cloudinary, Condition, Configuration, Expression, ExpressionParam, FetchLayer, HtmlTag, ImageTag, Layer, LayerParam, Param, RangeParam, RawParam, SubtitlesLayer, TextLayer, Transformation, TransformationBase, TransformationParam, Util, VideoTag, addClass, allStrings, augmentWidthOrHeight, base64Encode, base64EncodeURL, camelCase, cloudinary, contains, convertKeys, crc32, cssExpand, cssValue, curCSS, defaults, domStyle, funcTag, getAttribute, getData, getStyles, getWidthOrHeight, hasClass, isFunction, isNumberLike, isObject, m, objToString, objectProto, parameters, pnum, reWords, removeAttribute, rnumnonpx, setAttribute, setAttributes, setData, smartEscape, snakeCase, utf8_encode, width, withCamelCaseKeys, withSnakeCaseKeys, without;
	  allStrings = function(list) {
	    var item, j, len;
	    for (j = 0, len = list.length; j < len; j++) {
	      item = list[j];
	      if (!Util.isString(item)) {
	        return false;
	      }
	    }
	    return true;
	  };
	
	  /**
	  * Creates a new array without the given item.
	  * @function Util.without
	  * @param {Array} array - original array
	  * @param {*} item - the item to exclude from the new array
	  * @return {Array} a new array made of the original array's items except for `item`
	   */
	  without = function(array, item) {
	    var i, length, newArray;
	    newArray = [];
	    i = -1;
	    length = array.length;
	    while (++i < length) {
	      if (array[i] !== item) {
	        newArray.push(array[i]);
	      }
	    }
	    return newArray;
	  };
	
	  /**
	  * Return true is value is a number or a string representation of a number.
	  * @function Util.isNumberLike
	  * @param {*} value
	  * @returns {boolean} true if value is a number
	  * @example
	  *    Util.isNumber(0) // true
	  *    Util.isNumber("1.3") // true
	  *    Util.isNumber("") // false
	  *    Util.isNumber(undefined) // false
	   */
	  isNumberLike = function(value) {
	    return (value != null) && !isNaN(parseFloat(value));
	  };
	
	  /**
	   * Escape all characters matching unsafe in the given string
	   * @function Util.smartEscape
	   * @param {string} string - source string to escape
	   * @param {RegExp} unsafe - characters that must be escaped
	   * @return {string} escaped string
	   */
	  smartEscape = function(string, unsafe) {
	    if (unsafe == null) {
	      unsafe = /([^a-zA-Z0-9_.\-\/:]+)/g;
	    }
	    return string.replace(unsafe, function(match) {
	      return match.split("").map(function(c) {
	        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
	      }).join("");
	    });
	  };
	
	  /**
	   * Assign values from sources if they are not defined in the destination.
	   * Once a value is set it does not change
	   * @function Util.defaults
	   * @param {Object} destination - the object to assign defaults to
	   * @param {...Object} source - the source object(s) to assign defaults from
	   * @return {Object} destination after it was modified
	   */
	  defaults = function() {
	    var destination, sources;
	    destination = arguments[0], sources = 2 <= arguments.length ? slice.call(arguments, 1) : [];
	    return sources.reduce(function(dest, source) {
	      var key, value;
	      for (key in source) {
	        value = source[key];
	        if (dest[key] === void 0) {
	          dest[key] = value;
	        }
	      }
	      return dest;
	    }, destination);
	  };
	
	  /*********** lodash functions */
	  objectProto = Object.prototype;
	
	  /**
	   * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	   * of values.
	   */
	  objToString = objectProto.toString;
	
	  /**
	   * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	   * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	   *
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	   * @example
	   *
	  #isObject({});
	   * // => true
	   *
	  #isObject([1, 2, 3]);
	   * // => true
	   *
	  #isObject(1);
	   * // => false
	   */
	  isObject = function(value) {
	    var type;
	    type = typeof value;
	    return !!value && (type === 'object' || type === 'function');
	  };
	  funcTag = '[object Function]';
	
	  /**
	  * Checks if `value` is classified as a `Function` object.
	  * @function Util.isFunction
	  * @param {*} value The value to check.
	  * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	  * @example
	  *
	  * function Foo(){};  
	  * isFunction(Foo);
	  * // => true
	  *
	  * isFunction(/abc/);
	  * // => false
	   */
	  isFunction = function(value) {
	    return isObject(value) && objToString.call(value) === funcTag;
	  };
	
	  /*********** lodash functions */
	
	  /** Used to match words to create compound words. */
	  reWords = (function() {
	    var lower, upper;
	    upper = '[A-Z]';
	    lower = '[a-z]+';
	    return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper + '+|[0-9]+', 'g');
	  })();
	
	  /**
	  * Convert string to camelCase
	  * @function Util.camelCase
	  * @param {string} string - the string to convert
	  * @return {string} in camelCase format
	   */
	  camelCase = function(source) {
	    var i, word, words;
	    words = source.match(reWords);
	    words = (function() {
	      var j, len, results;
	      results = [];
	      for (i = j = 0, len = words.length; j < len; i = ++j) {
	        word = words[i];
	        word = word.toLocaleLowerCase();
	        if (i) {
	          results.push(word.charAt(0).toLocaleUpperCase() + word.slice(1));
	        } else {
	          results.push(word);
	        }
	      }
	      return results;
	    })();
	    return words.join('');
	  };
	
	  /**
	   * Convert string to snake_case
	   * @function Util.snakeCase
	   * @param {string} string - the string to convert
	   * @return {string} in snake_case format
	   */
	  snakeCase = function(source) {
	    var i, word, words;
	    words = source.match(reWords);
	    words = (function() {
	      var j, len, results;
	      results = [];
	      for (i = j = 0, len = words.length; j < len; i = ++j) {
	        word = words[i];
	        results.push(word.toLocaleLowerCase());
	      }
	      return results;
	    })();
	    return words.join('_');
	  };
	  convertKeys = function(source, converter) {
	    var key, result, value;
	    if (converter == null) {
	      converter = Util.identity;
	    }
	    result = {};
	    for (key in source) {
	      value = source[key];
	      key = converter(key);
	      if (!Util.isEmpty(key)) {
	        result[key] = value;
	      }
	    }
	    return result;
	  };
	
	  /**
	   * Create a copy of the source object with all keys in camelCase
	   * @function Util.withCamelCaseKeys
	   * @param {Object} value - the object to copy
	   * @return {Object} a new object
	   */
	  withCamelCaseKeys = function(source) {
	    return convertKeys(source, Util.camelCase);
	  };
	
	  /**
	   * Create a copy of the source object with all keys in snake_case
	   * @function Util.withSnakeCaseKeys
	   * @param {Object} value - the object to copy
	   * @return {Object} a new object
	   */
	  withSnakeCaseKeys = function(source) {
	    return convertKeys(source, Util.snakeCase);
	  };
	  base64Encode = typeof btoa !== 'undefined' && isFunction(btoa) ? btoa : typeof Buffer !== 'undefined' && isFunction(Buffer) ? function(input) {
	    if (!(input instanceof Buffer)) {
	      input = new Buffer.from(String(input), 'binary');
	    }
	    return input.toString('base64');
	  } : function(input) {
	    throw new Error("No base64 encoding function found");
	  };
	
	  /**
	  * Returns the Base64-decoded version of url.<br>
	  * This method delegates to `btoa` if present. Otherwise it tries `Buffer`.
	  * @function Util.base64EncodeURL
	  * @param {string} url - the url to encode. the value is URIdecoded and then re-encoded before converting to base64 representation
	  * @return {string} the base64 representation of the URL
	   */
	  base64EncodeURL = function(input) {
	    var error1, ignore;
	    try {
	      input = decodeURI(input);
	    } catch (error1) {
	      ignore = error1;
	    }
	    input = encodeURI(input);
	    return base64Encode(input);
	  };
	  BaseUtil = {
	    allStrings: allStrings,
	    camelCase: camelCase,
	    convertKeys: convertKeys,
	    defaults: defaults,
	    snakeCase: snakeCase,
	    without: without,
	    isFunction: isFunction,
	    isNumberLike: isNumberLike,
	    smartEscape: smartEscape,
	    withCamelCaseKeys: withCamelCaseKeys,
	    withSnakeCaseKeys: withSnakeCaseKeys,
	    base64EncodeURL: base64EncodeURL
	  };
	
	  /*
	   * Includes utility methods and lodash / jQuery shims
	   */
	
	  /**
	   * Get data from the DOM element.
	   *
	   * This method will use jQuery's `data()` method if it is available, otherwise it will get the `data-` attribute
	   * @param {Element} element - the element to get the data from
	   * @param {string} name - the name of the data item
	   * @returns the value associated with the `name`
	   * @function Util.getData
	   */
	  getData = function(element, name) {
	    var ref;
	    switch (false) {
	      case !(element == null):
	        return void 0;
	      case !_.isFunction(element.getAttribute):
	        return element.getAttribute("data-" + name);
	      case !_.isFunction(element.getAttr):
	        return element.getAttr("data-" + name);
	      case !_.isFunction(element.data):
	        return element.data(name);
	      case !(_.isFunction(typeof jQuery !== "undefined" && jQuery !== null ? (ref = jQuery.fn) != null ? ref.data : void 0 : void 0) && _.isElement(element)):
	        return jQuery(element).data(name);
	    }
	  };
	
	  /**
	   * Set data in the DOM element.
	   *
	   * This method will use jQuery's `data()` method if it is available, otherwise it will set the `data-` attribute
	   * @function Util.setData
	   * @param {Element} element - the element to set the data in
	   * @param {string} name - the name of the data item
	   * @param {*} value - the value to be set
	   *
	   */
	  setData = function(element, name, value) {
	    var ref;
	    switch (false) {
	      case !(element == null):
	        return void 0;
	      case !_.isFunction(element.setAttribute):
	        return element.setAttribute("data-" + name, value);
	      case !_.isFunction(element.setAttr):
	        return element.setAttr("data-" + name, value);
	      case !_.isFunction(element.data):
	        return element.data(name, value);
	      case !(_.isFunction(typeof jQuery !== "undefined" && jQuery !== null ? (ref = jQuery.fn) != null ? ref.data : void 0 : void 0) && _.isElement(element)):
	        return jQuery(element).data(name, value);
	    }
	  };
	
	  /**
	   * Get attribute from the DOM element.
	   *
	   * @function Util.getAttribute
	   * @param {Element} element - the element to set the attribute for
	   * @param {string} name - the name of the attribute
	   * @returns {*} the value of the attribute
	   *
	   */
	  getAttribute = function(element, name) {
	    switch (false) {
	      case !(element == null):
	        return void 0;
	      case !_.isFunction(element.getAttribute):
	        return element.getAttribute(name);
	      case !_.isFunction(element.attr):
	        return element.attr(name);
	      case !_.isFunction(element.getAttr):
	        return element.getAttr(name);
	    }
	  };
	
	  /**
	   * Set attribute in the DOM element.
	   *
	   * @function Util.setAttribute
	   * @param {Element} element - the element to set the attribute for
	   * @param {string} name - the name of the attribute
	   * @param {*} value - the value to be set
	   */
	  setAttribute = function(element, name, value) {
	    switch (false) {
	      case !(element == null):
	        return void 0;
	      case !_.isFunction(element.setAttribute):
	        return element.setAttribute(name, value);
	      case !_.isFunction(element.attr):
	        return element.attr(name, value);
	      case !_.isFunction(element.setAttr):
	        return element.setAttr(name, value);
	    }
	  };
	
	  /**
	   * Remove an attribute in the DOM element.
	   *
	   * @function Util.removeAttribute
	   * @param {Element} element - the element to set the attribute for
	   * @param {string} name - the name of the attribute
	   */
	  removeAttribute = function(element, name) {
	    switch (false) {
	      case !(element == null):
	        return void 0;
	      case !_.isFunction(element.removeAttribute):
	        return element.removeAttribute(name);
	      default:
	        return setAttribute(element, void 0);
	    }
	  };
	
	  /**
	    * Set a group of attributes to the element
	    * @function Util.setAttributes
	    * @param {Element} element - the element to set the attributes for
	    * @param {Object} attributes - a hash of attribute names and values
	   */
	  setAttributes = function(element, attributes) {
	    var name, results, value;
	    results = [];
	    for (name in attributes) {
	      value = attributes[name];
	      if (value != null) {
	        results.push(setAttribute(element, name, value));
	      } else {
	        results.push(removeAttribute(element, name));
	      }
	    }
	    return results;
	  };
	
	  /**
	    * Checks if element has a css class
	    * @function Util.hasClass
	    * @param {Element} element - the element to check
	    * @param {string} name - the class name
	    @returns {boolean} true if the element has the class
	   */
	  hasClass = function(element, name) {
	    if (_.isElement(element)) {
	      return element.className.match(new RegExp("\\b" + name + "\\b"));
	    }
	  };
	
	  /**
	    * Add class to the element
	    * @function Util.addClass
	    * @param {Element} element - the element
	    * @param {string} name - the class name to add
	   */
	  addClass = function(element, name) {
	    if (!element.className.match(new RegExp("\\b" + name + "\\b"))) {
	      return element.className = _.trim(element.className + " " + name);
	    }
	  };
	  getStyles = function(elem) {
	    if (elem.ownerDocument.defaultView.opener) {
	      return elem.ownerDocument.defaultView.getComputedStyle(elem, null);
	    }
	    return window.getComputedStyle(elem, null);
	  };
	  cssExpand = ["Top", "Right", "Bottom", "Left"];
	  contains = function(a, b) {
	    var adown, bup;
	    adown = (a.nodeType === 9 ? a.documentElement : a);
	    bup = b && b.parentNode;
	    return a === bup || !!(bup && bup.nodeType === 1 && adown.contains(bup));
	  };
	  domStyle = function(elem, name) {
	    if (!(!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style)) {
	      return elem.style[name];
	    }
	  };
	  curCSS = function(elem, name, computed) {
	    var maxWidth, minWidth, ret, rmargin, style, width;
	    rmargin = /^margin/;
	    width = void 0;
	    minWidth = void 0;
	    maxWidth = void 0;
	    ret = void 0;
	    style = elem.style;
	    computed = computed || getStyles(elem);
	    if (computed) {
	      ret = computed.getPropertyValue(name) || computed[name];
	    }
	    if (computed) {
	      if (ret === "" && !contains(elem.ownerDocument, elem)) {
	        ret = domStyle(elem, name);
	      }
	      if (rnumnonpx.test(ret) && rmargin.test(name)) {
	        width = style.width;
	        minWidth = style.minWidth;
	        maxWidth = style.maxWidth;
	        style.minWidth = style.maxWidth = style.width = ret;
	        ret = computed.width;
	        style.width = width;
	        style.minWidth = minWidth;
	        style.maxWidth = maxWidth;
	      }
	    }
	    if (ret !== undefined) {
	      return ret + "";
	    } else {
	      return ret;
	    }
	  };
	  cssValue = function(elem, name, convert, styles) {
	    var val;
	    val = curCSS(elem, name, styles);
	    if (convert) {
	      return parseFloat(val);
	    } else {
	      return val;
	    }
	  };
	  augmentWidthOrHeight = function(elem, name, extra, isBorderBox, styles) {
	    var j, len, side, sides, val;
	    if (extra === (isBorderBox ? "border" : "content")) {
	      return 0;
	    } else {
	      sides = name === "width" ? ["Right", "Left"] : ["Top", "Bottom"];
	      val = 0;
	      for (j = 0, len = sides.length; j < len; j++) {
	        side = sides[j];
	        if (extra === "margin") {
	          val += cssValue(elem, extra + side, true, styles);
	        }
	        if (isBorderBox) {
	          if (extra === "content") {
	            val -= cssValue(elem, "padding" + side, true, styles);
	          }
	          if (extra !== "margin") {
	            val -= cssValue(elem, "border" + side + "Width", true, styles);
	          }
	        } else {
	          val += cssValue(elem, "padding" + side, true, styles);
	          if (extra !== "padding") {
	            val += cssValue(elem, "border" + side + "Width", true, styles);
	          }
	        }
	      }
	      return val;
	    }
	  };
	  pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
	  rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
	  getWidthOrHeight = function(elem, name, extra) {
	    var isBorderBox, styles, val, valueIsBorderBox;
	    valueIsBorderBox = true;
	    val = (name === "width" ? elem.offsetWidth : elem.offsetHeight);
	    styles = getStyles(elem);
	    isBorderBox = cssValue(elem, "boxSizing", false, styles) === "border-box";
	    if (val <= 0 || (val == null)) {
	      val = curCSS(elem, name, styles);
	      if (val < 0 || (val == null)) {
	        val = elem.style[name];
	      }
	      if (rnumnonpx.test(val)) {
	        return val;
	      }
	      valueIsBorderBox = isBorderBox && (val === elem.style[name]);
	      val = parseFloat(val) || 0;
	    }
	    return val + augmentWidthOrHeight(elem, name, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles);
	  };
	  width = function(element) {
	    return getWidthOrHeight(element, "width", "content");
	  };
	
	  /**
	   * @class Util
	   */
	  Util = _.assign(BaseUtil, {
	    hasClass: hasClass,
	    addClass: addClass,
	    getAttribute: getAttribute,
	    setAttribute: setAttribute,
	    removeAttribute: removeAttribute,
	    setAttributes: setAttributes,
	    getData: getData,
	    setData: setData,
	    width: width,
	
	    /**
	     * Returns true if item is a string
	     * @function Util.isString
	     * @param item
	     * @returns {boolean} true if item is a string
	     */
	    isString: _.isString,
	    isArray: _.isArray,
	
	    /**
	     * Returns true if item is empty:
	     * <ul>
	     *   <li>item is null or undefined</li>
	     *   <li>item is an array or string of length 0</li>
	     *   <li>item is an object with no keys</li>
	     * </ul>
	     * @function Util.isEmpty
	     * @param item
	     * @returns {boolean} true if item is empty
	     */
	    isEmpty: _.isEmpty,
	
	    /**
	     * Assign source properties to destination.
	     * If the property is an object it is assigned as a whole, overriding the destination object.
	     * @function Util.assign
	     * @param {Object} destination - the object to assign to
	     */
	    assign: _.assign,
	
	    /**
	     * Recursively assign source properties to destination
	     * @function Util.merge
	     * @param {Object} destination - the object to assign to
	     * @param {...Object} [sources] The source objects.
	     */
	    merge: _.merge,
	
	    /**
	     * Create a new copy of the given object, including all internal objects.
	     * @function Util.cloneDeep
	     * @param {Object} value - the object to clone
	     * @return {Object} a new deep copy of the object
	     */
	    cloneDeep: _.cloneDeep,
	
	    /**
	     * Creates a new array from the parameter with "falsey" values removed
	     * @function Util.compact
	     * @param {Array} array - the array to remove values from
	     * @return {Array} a new array without falsey values
	     */
	    compact: _.compact,
	
	    /**
	     * Check if a given item is included in the given array
	     * @function Util.contains
	     * @param {Array} array - the array to search in
	     * @param {*} item - the item to search for
	     * @return {boolean} true if the item is included in the array
	     */
	    contains: _.includes,
	
	    /**
	     * Returns values in the given array that are not included in the other array
	     * @function Util.difference
	     * @param {Array} arr - the array to select from
	     * @param {Array} values - values to filter from arr
	     * @return {Array} the filtered values
	     */
	    difference: _.difference,
	
	    /**
	     * Returns a list of all the function names in obj
	     * @function Util.functions
	     * @param {Object} object - the object to inspect
	     * @return {Array} a list of functions of object
	     */
	    functions: _.functions,
	
	    /**
	     * Returns the provided value. This functions is used as a default predicate function.
	     * @function Util.identity
	     * @param {*} value
	     * @return {*} the provided value
	     */
	    identity: _.identity,
	    isPlainObject: _.isPlainObject,
	
	    /**
	     * Remove leading or trailing spaces from text
	     * @function Util.trim
	     * @param {string} text
	     * @return {string} the `text` without leading or trailing spaces
	     */
	    trim: _.trim
	  });
	
	  /**
	   * UTF8 encoder
	   *
	   */
	  utf8_encode = function(argString) {
	    var c1, enc, end, n, start, string, stringl, utftext;
	    if (argString === null || typeof argString === 'undefined') {
	      return '';
	    }
	    string = argString + '';
	    utftext = '';
	    start = void 0;
	    end = void 0;
	    stringl = 0;
	    start = end = 0;
	    stringl = string.length;
	    n = 0;
	    while (n < stringl) {
	      c1 = string.charCodeAt(n);
	      enc = null;
	      if (c1 < 128) {
	        end++;
	      } else if (c1 > 127 && c1 < 2048) {
	        enc = String.fromCharCode(c1 >> 6 | 192, c1 & 63 | 128);
	      } else {
	        enc = String.fromCharCode(c1 >> 12 | 224, c1 >> 6 & 63 | 128, c1 & 63 | 128);
	      }
	      if (enc !== null) {
	        if (end > start) {
	          utftext += string.slice(start, end);
	        }
	        utftext += enc;
	        start = end = n + 1;
	      }
	      n++;
	    }
	    if (end > start) {
	      utftext += string.slice(start, stringl);
	    }
	    return utftext;
	  };
	
	  /**
	   * CRC32 calculator
	   * Depends on 'utf8_encode'
	   */
	  crc32 = function(str) {
	    var crc, i, iTop, table, x, y;
	    str = utf8_encode(str);
	    table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
	    crc = 0;
	    x = 0;
	    y = 0;
	    crc = crc ^ -1;
	    i = 0;
	    iTop = str.length;
	    while (i < iTop) {
	      y = (crc ^ str.charCodeAt(i)) & 0xFF;
	      x = '0x' + table.substr(y * 9, 8);
	      crc = crc >>> 8 ^ x;
	      i++;
	    }
	    crc = crc ^ -1;
	    if (crc < 0) {
	      crc += 4294967296;
	    }
	    return crc;
	  };
	  Layer = (function() {
	
	    /**
	     * Layer
	     * @constructor Layer
	     * @param {Object} options - layer parameters
	     */
	    function Layer(options) {
	      this.options = {};
	      if (options != null) {
	        ["resourceType", "type", "publicId", "format"].forEach((function(_this) {
	          return function(key) {
	            var ref;
	            return _this.options[key] = (ref = options[key]) != null ? ref : options[Util.snakeCase(key)];
	          };
	        })(this));
	      }
	    }
	
	    Layer.prototype.resourceType = function(value) {
	      this.options.resourceType = value;
	      return this;
	    };
	
	    Layer.prototype.type = function(value) {
	      this.options.type = value;
	      return this;
	    };
	
	    Layer.prototype.publicId = function(value) {
	      this.options.publicId = value;
	      return this;
	    };
	
	
	    /**
	     * Get the public ID, formatted for layer parameter
	     * @function Layer#getPublicId
	     * @return {String} public ID
	     */
	
	    Layer.prototype.getPublicId = function() {
	      var ref;
	      return (ref = this.options.publicId) != null ? ref.replace(/\//g, ":") : void 0;
	    };
	
	
	    /**
	     * Get the public ID, with format if present
	     * @function Layer#getFullPublicId
	     * @return {String} public ID
	     */
	
	    Layer.prototype.getFullPublicId = function() {
	      if (this.options.format != null) {
	        return this.getPublicId() + "." + this.options.format;
	      } else {
	        return this.getPublicId();
	      }
	    };
	
	    Layer.prototype.format = function(value) {
	      this.options.format = value;
	      return this;
	    };
	
	
	    /**
	     * generate the string representation of the layer
	     * @function Layer#toString
	     */
	
	    Layer.prototype.toString = function() {
	      var components;
	      components = [];
	      if (this.options.publicId == null) {
	        throw "Must supply publicId";
	      }
	      if (!(this.options.resourceType === "image")) {
	        components.push(this.options.resourceType);
	      }
	      if (!(this.options.type === "upload")) {
	        components.push(this.options.type);
	      }
	      components.push(this.getFullPublicId());
	      return Util.compact(components).join(":");
	    };
	
	    return Layer;
	
	  })();
	  FetchLayer = (function(superClass) {
	    extend(FetchLayer, superClass);
	
	
	    /**
	     * @constructor FetchLayer
	     * @param {Object|string} options - layer parameters or a url
	     * @param {string} options.url the url of the image to fetch
	     */
	
	    function FetchLayer(options) {
	      FetchLayer.__super__.constructor.call(this, options);
	      if (Util.isString(options)) {
	        this.options.url = options;
	      } else if (options != null ? options.url : void 0) {
	        this.options.url = options.url;
	      }
	    }
	
	    FetchLayer.prototype.url = function(url) {
	      this.options.url = url;
	      return this;
	    };
	
	
	    /**
	     * generate the string representation of the layer
	     * @function FetchLayer#toString
	     * @return {String}
	     */
	
	    FetchLayer.prototype.toString = function() {
	      return "fetch:" + (cloudinary.Util.base64EncodeURL(this.options.url));
	    };
	
	    return FetchLayer;
	
	  })(Layer);
	  TextLayer = (function(superClass) {
	    extend(TextLayer, superClass);
	
	
	    /**
	     * @constructor TextLayer
	     * @param {Object} options - layer parameters
	     */
	
	    function TextLayer(options) {
	      var keys;
	      TextLayer.__super__.constructor.call(this, options);
	      keys = ["resourceType", "resourceType", "fontFamily", "fontSize", "fontWeight", "fontStyle", "textDecoration", "textAlign", "stroke", "letterSpacing", "lineSpacing", "text"];
	      if (options != null) {
	        keys.forEach((function(_this) {
	          return function(key) {
	            var ref;
	            return _this.options[key] = (ref = options[key]) != null ? ref : options[Util.snakeCase(key)];
	          };
	        })(this));
	      }
	      this.options.resourceType = "text";
	    }
	
	    TextLayer.prototype.resourceType = function(resourceType) {
	      throw "Cannot modify resourceType for text layers";
	    };
	
	    TextLayer.prototype.type = function(type) {
	      throw "Cannot modify type for text layers";
	    };
	
	    TextLayer.prototype.format = function(format) {
	      throw "Cannot modify format for text layers";
	    };
	
	    TextLayer.prototype.fontFamily = function(fontFamily) {
	      this.options.fontFamily = fontFamily;
	      return this;
	    };
	
	    TextLayer.prototype.fontSize = function(fontSize) {
	      this.options.fontSize = fontSize;
	      return this;
	    };
	
	    TextLayer.prototype.fontWeight = function(fontWeight) {
	      this.options.fontWeight = fontWeight;
	      return this;
	    };
	
	    TextLayer.prototype.fontStyle = function(fontStyle) {
	      this.options.fontStyle = fontStyle;
	      return this;
	    };
	
	    TextLayer.prototype.textDecoration = function(textDecoration) {
	      this.options.textDecoration = textDecoration;
	      return this;
	    };
	
	    TextLayer.prototype.textAlign = function(textAlign) {
	      this.options.textAlign = textAlign;
	      return this;
	    };
	
	    TextLayer.prototype.stroke = function(stroke) {
	      this.options.stroke = stroke;
	      return this;
	    };
	
	    TextLayer.prototype.letterSpacing = function(letterSpacing) {
	      this.options.letterSpacing = letterSpacing;
	      return this;
	    };
	
	    TextLayer.prototype.lineSpacing = function(lineSpacing) {
	      this.options.lineSpacing = lineSpacing;
	      return this;
	    };
	
	    TextLayer.prototype.text = function(text) {
	      this.options.text = text;
	      return this;
	    };
	
	
	    /**
	     * generate the string representation of the layer
	     * @function TextLayer#toString
	     * @return {String}
	     */
	
	    TextLayer.prototype.toString = function() {
	      var components, hasPublicId, hasStyle, publicId, re, res, start, style, text, textSource;
	      style = this.textStyleIdentifier();
	      if (this.options.publicId != null) {
	        publicId = this.getFullPublicId();
	      }
	      if (this.options.text != null) {
	        hasPublicId = !Util.isEmpty(publicId);
	        hasStyle = !Util.isEmpty(style);
	        if (hasPublicId && hasStyle || !hasPublicId && !hasStyle) {
	          throw "Must supply either style parameters or a public_id when providing text parameter in a text overlay/underlay, but not both!";
	        }
	        re = /\$\([a-zA-Z]\w*\)/g;
	        start = 0;
	        textSource = Util.smartEscape(this.options.text, /[,\/]/g);
	        text = "";
	        while (res = re.exec(textSource)) {
	          text += Util.smartEscape(textSource.slice(start, res.index));
	          text += res[0];
	          start = res.index + res[0].length;
	        }
	        text += Util.smartEscape(textSource.slice(start));
	      }
	      components = [this.options.resourceType, style, publicId, text];
	      return Util.compact(components).join(":");
	    };
	
	    TextLayer.prototype.textStyleIdentifier = function() {
	      var components;
	      components = [];
	      if (this.options.fontWeight !== "normal") {
	        components.push(this.options.fontWeight);
	      }
	      if (this.options.fontStyle !== "normal") {
	        components.push(this.options.fontStyle);
	      }
	      if (this.options.textDecoration !== "none") {
	        components.push(this.options.textDecoration);
	      }
	      components.push(this.options.textAlign);
	      if (this.options.stroke !== "none") {
	        components.push(this.options.stroke);
	      }
	      if (!(Util.isEmpty(this.options.letterSpacing) && !Util.isNumberLike(this.options.letterSpacing))) {
	        components.push("letter_spacing_" + this.options.letterSpacing);
	      }
	      if (!(Util.isEmpty(this.options.lineSpacing) && !Util.isNumberLike(this.options.lineSpacing))) {
	        components.push("line_spacing_" + this.options.lineSpacing);
	      }
	      if (!Util.isEmpty(Util.compact(components))) {
	        if (Util.isEmpty(this.options.fontFamily)) {
	          throw "Must supply fontFamily. " + components;
	        }
	        if (Util.isEmpty(this.options.fontSize) && !Util.isNumberLike(this.options.fontSize)) {
	          throw "Must supply fontSize.";
	        }
	      }
	      components.unshift(this.options.fontFamily, this.options.fontSize);
	      components = Util.compact(components).join("_");
	      return components;
	    };
	
	    return TextLayer;
	
	  })(Layer);
	  SubtitlesLayer = (function(superClass) {
	    extend(SubtitlesLayer, superClass);
	
	
	    /**
	     * Represent a subtitles layer
	     * @constructor SubtitlesLayer
	     * @param {Object} options - layer parameters
	     */
	
	    function SubtitlesLayer(options) {
	      SubtitlesLayer.__super__.constructor.call(this, options);
	      this.options.resourceType = "subtitles";
	    }
	
	    return SubtitlesLayer;
	
	  })(TextLayer);
	
	  /**
	   * Transformation parameters
	   * Depends on 'util', 'transformation'
	   */
	  Param = (function() {
	
	    /**
	     * Represents a single parameter
	     * @class Param
	     * @param {string} name - The name of the parameter in snake_case
	     * @param {string} shortName - The name of the serialized form of the parameter.
	     *                         If a value is not provided, the parameter will not be serialized.
	     * @param {function} [process=cloudinary.Util.identity ] - Manipulate origValue when value is called
	     * @ignore
	     */
	    function Param(name, shortName, process) {
	      if (process == null) {
	        process = cloudinary.Util.identity;
	      }
	
	      /**
	       * The name of the parameter in snake_case
	       * @member {string} Param#name
	       */
	      this.name = name;
	
	      /**
	       * The name of the serialized form of the parameter
	       * @member {string} Param#shortName
	       */
	      this.shortName = shortName;
	
	      /**
	       * Manipulate origValue when value is called
	       * @member {function} Param#process
	       */
	      this.process = process;
	    }
	
	
	    /**
	     * Set a (unprocessed) value for this parameter
	     * @function Param#set
	     * @param {*} origValue - the value of the parameter
	     * @return {Param} self for chaining
	     */
	
	    Param.prototype.set = function(origValue) {
	      this.origValue = origValue;
	      return this;
	    };
	
	
	    /**
	     * Generate the serialized form of the parameter
	     * @function Param#serialize
	     * @return {string} the serialized form of the parameter
	     */
	
	    Param.prototype.serialize = function() {
	      var val, valid;
	      val = this.value();
	      valid = cloudinary.Util.isArray(val) || cloudinary.Util.isPlainObject(val) || cloudinary.Util.isString(val) ? !cloudinary.Util.isEmpty(val) : val != null;
	      if ((this.shortName != null) && valid) {
	        return this.shortName + "_" + val;
	      } else {
	        return '';
	      }
	    };
	
	
	    /**
	     * Return the processed value of the parameter
	     * @function Param#value
	     */
	
	    Param.prototype.value = function() {
	      return this.process(this.origValue);
	    };
	
	    Param.norm_color = function(value) {
	      return value != null ? value.replace(/^#/, 'rgb:') : void 0;
	    };
	
	    Param.prototype.build_array = function(arg) {
	      if (arg == null) {
	        arg = [];
	      }
	      if (cloudinary.Util.isArray(arg)) {
	        return arg;
	      } else {
	        return [arg];
	      }
	    };
	
	
	    /**
	    * Covert value to video codec string.
	    *
	    * If the parameter is an object,
	    * @param {(string|Object)} param - the video codec as either a String or a Hash
	    * @return {string} the video codec string in the format codec:profile:level
	    * @example
	    * vc_[ :profile : [level]]
	    * or
	      { codec: 'h264', profile: 'basic', level: '3.1' }
	    * @ignore
	     */
	
	    Param.process_video_params = function(param) {
	      var video;
	      switch (param.constructor) {
	        case Object:
	          video = "";
	          if ('codec' in param) {
	            video = param['codec'];
	            if ('profile' in param) {
	              video += ":" + param['profile'];
	              if ('level' in param) {
	                video += ":" + param['level'];
	              }
	            }
	          }
	          return video;
	        case String:
	          return param;
	        default:
	          return null;
	      }
	    };
	
	    return Param;
	
	  })();
	  ArrayParam = (function(superClass) {
	    extend(ArrayParam, superClass);
	
	
	    /**
	     * A parameter that represents an array
	     * @param {string} name - The name of the parameter in snake_case
	     * @param {string} shortName - The name of the serialized form of the parameter
	     *                         If a value is not provided, the parameter will not be serialized.
	     * @param {string} [sep='.'] - The separator to use when joining the array elements together
	     * @param {function} [process=cloudinary.Util.identity ] - Manipulate origValue when value is called
	     * @class ArrayParam
	     * @extends Param
	     * @ignore
	     */
	
	    function ArrayParam(name, shortName, sep, process) {
	      if (sep == null) {
	        sep = '.';
	      }
	      this.sep = sep;
	      ArrayParam.__super__.constructor.call(this, name, shortName, process);
	    }
	
	    ArrayParam.prototype.serialize = function() {
	      var arrayValue, flat, t;
	      if (this.shortName != null) {
	        arrayValue = this.value();
	        if (cloudinary.Util.isEmpty(arrayValue)) {
	          return '';
	        } else if (cloudinary.Util.isString(arrayValue)) {
	          return this.shortName + "_" + arrayValue;
	        } else {
	          flat = (function() {
	            var j, len, results;
	            results = [];
	            for (j = 0, len = arrayValue.length; j < len; j++) {
	              t = arrayValue[j];
	              if (cloudinary.Util.isFunction(t.serialize)) {
	                results.push(t.serialize());
	              } else {
	                results.push(t);
	              }
	            }
	            return results;
	          })();
	          return this.shortName + "_" + (flat.join(this.sep));
	        }
	      } else {
	        return '';
	      }
	    };
	
	    ArrayParam.prototype.value = function() {
	      var j, len, ref, results, v;
	      if (cloudinary.Util.isArray(this.origValue)) {
	        ref = this.origValue;
	        results = [];
	        for (j = 0, len = ref.length; j < len; j++) {
	          v = ref[j];
	          results.push(this.process(v));
	        }
	        return results;
	      } else {
	        return this.process(this.origValue);
	      }
	    };
	
	    ArrayParam.prototype.set = function(origValue) {
	      if ((origValue == null) || cloudinary.Util.isArray(origValue)) {
	        return ArrayParam.__super__.set.call(this, origValue);
	      } else {
	        return ArrayParam.__super__.set.call(this, [origValue]);
	      }
	    };
	
	    return ArrayParam;
	
	  })(Param);
	  TransformationParam = (function(superClass) {
	    extend(TransformationParam, superClass);
	
	
	    /**
	     * A parameter that represents a transformation
	     * @param {string} name - The name of the parameter in snake_case
	     * @param {string} [shortName='t'] - The name of the serialized form of the parameter
	     * @param {string} [sep='.'] - The separator to use when joining the array elements together
	     * @param {function} [process=cloudinary.Util.identity ] - Manipulate origValue when value is called
	     * @class TransformationParam
	     * @extends Param
	     * @ignore
	     */
	
	    function TransformationParam(name, shortName, sep, process) {
	      if (shortName == null) {
	        shortName = "t";
	      }
	      if (sep == null) {
	        sep = '.';
	      }
	      this.sep = sep;
	      TransformationParam.__super__.constructor.call(this, name, shortName, process);
	    }
	
	    TransformationParam.prototype.serialize = function() {
	      var joined, result, t;
	      if (cloudinary.Util.isEmpty(this.value())) {
	        return '';
	      } else if (cloudinary.Util.allStrings(this.value())) {
	        joined = this.value().join(this.sep);
	        if (!cloudinary.Util.isEmpty(joined)) {
	          return this.shortName + "_" + joined;
	        } else {
	          return '';
	        }
	      } else {
	        result = (function() {
	          var j, len, ref, results;
	          ref = this.value();
	          results = [];
	          for (j = 0, len = ref.length; j < len; j++) {
	            t = ref[j];
	            if (t != null) {
	              if (cloudinary.Util.isString(t) && !cloudinary.Util.isEmpty(t)) {
	                results.push(this.shortName + "_" + t);
	              } else if (cloudinary.Util.isFunction(t.serialize)) {
	                results.push(t.serialize());
	              } else if (cloudinary.Util.isPlainObject(t) && !cloudinary.Util.isEmpty(t)) {
	                results.push(new Transformation(t).serialize());
	              } else {
	                results.push(void 0);
	              }
	            }
	          }
	          return results;
	        }).call(this);
	        return cloudinary.Util.compact(result);
	      }
	    };
	
	    TransformationParam.prototype.set = function(origValue1) {
	      this.origValue = origValue1;
	      if (cloudinary.Util.isArray(this.origValue)) {
	        return TransformationParam.__super__.set.call(this, this.origValue);
	      } else {
	        return TransformationParam.__super__.set.call(this, [this.origValue]);
	      }
	    };
	
	    return TransformationParam;
	
	  })(Param);
	  RangeParam = (function(superClass) {
	    extend(RangeParam, superClass);
	
	
	    /**
	     * A parameter that represents a range
	     * @param {string} name - The name of the parameter in snake_case
	     * @param {string} shortName - The name of the serialized form of the parameter
	     *                         If a value is not provided, the parameter will not be serialized.
	     * @param {function} [process=norm_range_value ] - Manipulate origValue when value is called
	     * @class RangeParam
	     * @extends Param
	     * @ignore
	     */
	
	    function RangeParam(name, shortName, process) {
	      if (process == null) {
	        process = this.norm_range_value;
	      }
	      RangeParam.__super__.constructor.call(this, name, shortName, process);
	    }
	
	    RangeParam.norm_range_value = function(value) {
	      var modifier, offset;
	      offset = String(value).match(new RegExp('^' + offset_any_pattern + '$'));
	      if (offset) {
	        modifier = offset[5] != null ? 'p' : '';
	        value = (offset[1] || offset[4]) + modifier;
	      }
	      return value;
	    };
	
	    return RangeParam;
	
	  })(Param);
	  RawParam = (function(superClass) {
	    extend(RawParam, superClass);
	
	    function RawParam(name, shortName, process) {
	      if (process == null) {
	        process = cloudinary.Util.identity;
	      }
	      RawParam.__super__.constructor.call(this, name, shortName, process);
	    }
	
	    RawParam.prototype.serialize = function() {
	      return this.value();
	    };
	
	    return RawParam;
	
	  })(Param);
	  LayerParam = (function(superClass) {
	    var LAYER_KEYWORD_PARAMS;
	
	    extend(LayerParam, superClass);
	
	    function LayerParam() {
	      return LayerParam.__super__.constructor.apply(this, arguments);
	    }
	
	    LayerParam.prototype.value = function() {
	      var layerOptions, result;
	      layerOptions = this.origValue;
	      if (cloudinary.Util.isPlainObject(layerOptions)) {
	        layerOptions = Util.withCamelCaseKeys(layerOptions);
	        if (layerOptions.resourceType === "text" || (layerOptions.text != null)) {
	          result = new cloudinary.TextLayer(layerOptions).toString();
	        } else if (layerOptions.resourceType === "subtitles") {
	          result = new cloudinary.SubtitlesLayer(layerOptions).toString();
	        } else if (layerOptions.resourceType === "fetch" || (layerOptions.url != null)) {
	          result = new cloudinary.FetchLayer(layerOptions).toString();
	        } else {
	          result = new cloudinary.Layer(layerOptions).toString();
	        }
	      } else if (/^fetch:.+/.test(layerOptions)) {
	        result = new FetchLayer(layerOptions.substr(6)).toString();
	      } else {
	        result = layerOptions;
	      }
	      return result;
	    };
	
	    LAYER_KEYWORD_PARAMS = [["font_weight", "normal"], ["font_style", "normal"], ["text_decoration", "none"], ["text_align", null], ["stroke", "none"], ["letter_spacing", null], ["line_spacing", null]];
	
	    LayerParam.prototype.textStyle = function(layer) {
	      return (new cloudinary.TextLayer(layer)).textStyleIdentifier();
	    };
	
	    return LayerParam;
	
	  })(Param);
	  ExpressionParam = (function(superClass) {
	    extend(ExpressionParam, superClass);
	
	    function ExpressionParam() {
	      return ExpressionParam.__super__.constructor.apply(this, arguments);
	    }
	
	    ExpressionParam.prototype.serialize = function() {
	      return Expression.normalize(ExpressionParam.__super__.serialize.call(this));
	    };
	
	    return ExpressionParam;
	
	  })(Param);
	  parameters = {};
	  parameters.Param = Param;
	  parameters.ArrayParam = ArrayParam;
	  parameters.RangeParam = RangeParam;
	  parameters.RawParam = RawParam;
	  parameters.TransformationParam = TransformationParam;
	  parameters.LayerParam = LayerParam;
	  parameters.ExpressionParam = ExpressionParam;
	  Expression = (function() {
	
	    /**
	     * @internal
	     */
	    var faceCount;
	
	    Expression.OPERATORS = {
	      "=": 'eq',
	      "!=": 'ne',
	      "<": 'lt',
	      ">": 'gt',
	      "<=": 'lte',
	      ">=": 'gte',
	      "&&": 'and',
	      "||": 'or',
	      "*": "mul",
	      "/": "div",
	      "+": "add",
	      "-": "sub"
	    };
	
	
	    /**
	     * @internal
	     */
	
	    Expression.PREDEFINED_VARS = {
	      "aspect_ratio": "ar",
	      "aspectRatio": "ar",
	      "current_page": "cp",
	      "currentPage": "cp",
	      "face_count": "fc",
	      "faceCount": "fc",
	      "height": "h",
	      "initial_aspect_ratio": "iar",
	      "initial_height": "ih",
	      "initial_width": "iw",
	      "initialAspectRatio": "iar",
	      "initialHeight": "ih",
	      "initialWidth": "iw",
	      "page_count": "pc",
	      "page_x": "px",
	      "page_y": "py",
	      "pageCount": "pc",
	      "pageX": "px",
	      "pageY": "py",
	      "tags": "tags",
	      "width": "w"
	    };
	
	
	    /**
	     * @internal
	     */
	
	    Expression.BOUNDRY = "[ _]+";
	
	
	    /**
	     * Represents a transformation expression
	     * @param {string} expressionStr - a expression in string format
	     * @class Expression
	     *
	     */
	
	    function Expression(expressionStr) {
	
	      /**
	        * @protected
	        * @inner Expression-expressions
	       */
	      this.expressions = [];
	      if (expressionStr != null) {
	        this.expressions.push(Expression.normalize(expressionStr));
	      }
	    }
	
	
	    /**
	     * Convenience constructor method
	     * @function Expression.new
	     */
	
	    Expression["new"] = function(expressionStr) {
	      return new this(expressionStr);
	    };
	
	
	    /**
	     * Normalize a string expression
	     * @function Cloudinary#normalize
	     * @param {string} expression a expression, e.g. "w gt 100", "width_gt_100", "width > 100"
	     * @return {string} the normalized form of the value expression, e.g. "w_gt_100"
	     */
	
	    Expression.normalize = function(expression) {
	      var operators, pattern, replaceRE;
	      if (expression == null) {
	        return expression;
	      }
	      expression = String(expression);
	      operators = "\\|\\||>=|<=|&&|!=|>|=|<|/|-|\\+|\\*";
	      pattern = "((" + operators + ")(?=[ _])|" + Object.keys(Expression.PREDEFINED_VARS).join("|") + ")";
	      replaceRE = new RegExp(pattern, "g");
	      expression = expression.replace(replaceRE, function(match) {
	        return Expression.OPERATORS[match] || Expression.PREDEFINED_VARS[match];
	      });
	      return expression.replace(/[ _]+/g, '_');
	    };
	
	
	    /**
	     * Serialize the expression
	     * @return {string} the expression as a string
	     */
	
	    Expression.prototype.serialize = function() {
	      return Expression.normalize(this.expressions.join("_"));
	    };
	
	    Expression.prototype.toString = function() {
	      return this.serialize();
	    };
	
	
	    /**
	     * Get the parent transformation of this expression
	     * @return Transformation
	     */
	
	    Expression.prototype.getParent = function() {
	      return this.parent;
	    };
	
	
	    /**
	     * Set the parent transformation of this expression
	     * @param {Transformation} the parent transformation
	     * @return {Expression} this expression
	     */
	
	    Expression.prototype.setParent = function(parent) {
	      this.parent = parent;
	      return this;
	    };
	
	
	    /**
	     * Add a expression
	     * @function Expression#predicate
	     * @internal
	     */
	
	    Expression.prototype.predicate = function(name, operator, value) {
	      if (Expression.OPERATORS[operator] != null) {
	        operator = Expression.OPERATORS[operator];
	      }
	      this.expressions.push(name + "_" + operator + "_" + value);
	      return this;
	    };
	
	
	    /**
	     * @function Expression#and
	     */
	
	    Expression.prototype.and = function() {
	      this.expressions.push("and");
	      return this;
	    };
	
	
	    /**
	     * @function Expression#or
	     */
	
	    Expression.prototype.or = function() {
	      this.expressions.push("or");
	      return this;
	    };
	
	
	    /**
	     * Conclude expression
	     * @function Expression#then
	     * @return {Transformation} the transformation this expression is defined for
	     */
	
	    Expression.prototype.then = function() {
	      return this.getParent()["if"](this.toString());
	    };
	
	
	    /**
	     * @function Expression#height
	     * @param {string} operator the comparison operator (e.g. "<", "lt")
	     * @param {string|number} value the right hand side value
	     * @return {Expression} this expression
	     */
	
	    Expression.prototype.height = function(operator, value) {
	      return this.predicate("h", operator, value);
	    };
	
	
	    /**
	     * @function Expression#width
	     * @param {string} operator the comparison operator (e.g. "<", "lt")
	     * @param {string|number} value the right hand side value
	     * @return {Expression} this expression
	     */
	
	    Expression.prototype.width = function(operator, value) {
	      return this.predicate("w", operator, value);
	    };
	
	
	    /**
	     * @function Expression#aspectRatio
	     * @param {string} operator the comparison operator (e.g. "<", "lt")
	     * @param {string|number} value the right hand side value
	     * @return {Expression} this expression
	     */
	
	    Expression.prototype.aspectRatio = function(operator, value) {
	      return this.predicate("ar", operator, value);
	    };
	
	
	    /**
	     * @function Expression#pages
	     * @param {string} operator the comparison operator (e.g. "<", "lt")
	     * @param {string|number} value the right hand side value
	     * @return {Expression} this expression
	     */
	
	    Expression.prototype.pageCount = function(operator, value) {
	      return this.predicate("pc", operator, value);
	    };
	
	
	    /**
	     * @function Expression#faces
	     * @param {string} operator the comparison operator (e.g. "<", "lt")
	     * @param {string|number} value the right hand side value
	     * @return {Expression} this expression
	     */
	
	    Expression.prototype.faceCount = function(operator, value) {
	      return this.predicate("fc", operator, value);
	    };
	
	    Expression.prototype.value = function(value) {
	      this.expressions.push(value);
	      return this;
	    };
	
	
	    /**
	     */
	
	    Expression.variable = function(name, value) {
	      return new this(name).value(value);
	    };
	
	
	    /**
	      * @returns a new expression with the predefined variable "width"
	      * @function Expression.width
	     */
	
	    Expression.width = function() {
	      return new this("width");
	    };
	
	
	    /**
	      * @returns a new expression with the predefined variable "height"
	      * @function Expression.height
	     */
	
	    Expression.height = function() {
	      return new this("height");
	    };
	
	
	    /**
	      * @returns a new expression with the predefined variable "initialWidth"
	      * @function Expression.initialWidth
	     */
	
	    Expression.initialWidth = function() {
	      return new this("initialWidth");
	    };
	
	
	    /**
	      * @returns a new expression with the predefined variable "initialHeight"
	      * @function Expression.initialHeight
	     */
	
	    Expression.initialHeight = function() {
	      return new this("initialHeight");
	    };
	
	
	    /**
	      * @returns a new expression with the predefined variable "aspectRatio"
	      * @function Expression.aspectRatio
	     */
	
	    Expression.aspectRatio = function() {
	      return new this("aspectRatio");
	    };
	
	
	    /**
	      * @returns a new expression with the predefined variable "initialAspectRatio"
	      * @function Expression.initialAspectRatio
	     */
	
	    Expression.initialAspectRatio = function() {
	      return new this("initialAspectRatio");
	    };
	
	
	    /**
	      * @returns a new expression with the predefined variable "pageCount"
	      * @function Expression.pageCount
	     */
	
	    Expression.pageCount = function() {
	      return new this("pageCount");
	    };
	
	
	    /**
	      * @returns a new expression with the predefined variable "faceCount"
	      * @function Expression.faceCount
	     */
	
	    faceCount = function() {
	      return new this("faceCount");
	    };
	
	
	    /**
	      * @returns a new expression with the predefined variable "currentPage"
	      * @function Expression.currentPage
	     */
	
	    Expression.currentPage = function() {
	      return new this("currentPage");
	    };
	
	
	    /**
	      * @returns a new expression with the predefined variable "tags"
	      * @function Expression.tags
	     */
	
	    Expression.tags = function() {
	      return new this("tags");
	    };
	
	
	    /**
	      * @returns a new expression with the predefined variable "pageX"
	      * @function Expression.pageX
	     */
	
	    Expression.pageX = function() {
	      return new this("pageX");
	    };
	
	
	    /**
	      * @returns a new expression with the predefined variable "pageY"
	      * @function Expression.pageY
	     */
	
	    Expression.pageY = function() {
	      return new this("pageY");
	    };
	
	    return Expression;
	
	  })();
	  Condition = (function(superClass) {
	    extend(Condition, superClass);
	
	
	    /**
	     * Represents a transformation condition
	     * @param {string} conditionStr - a condition in string format
	     * @class Condition
	     * @example
	     * // normally this class is not instantiated directly
	     * var tr = cloudinary.Transformation.new()
	     *    .if().width( ">", 1000).and().aspectRatio("<", "3:4").then()
	     *      .width(1000)
	     *      .crop("scale")
	     *    .else()
	     *      .width(500)
	     *      .crop("scale")
	     *
	     * var tr = cloudinary.Transformation.new()
	     *    .if("w > 1000 and aspectRatio < 3:4")
	     *      .width(1000)
	     *      .crop("scale")
	     *    .else()
	     *      .width(500)
	     *      .crop("scale")
	     *
	     */
	
	    function Condition(conditionStr) {
	      Condition.__super__.constructor.call(this, conditionStr);
	    }
	
	
	    /**
	     * @function Condition#height
	     * @param {string} operator the comparison operator (e.g. "<", "lt")
	     * @param {string|number} value the right hand side value
	     * @return {Condition} this condition
	     */
	
	    Condition.prototype.height = function(operator, value) {
	      return this.predicate("h", operator, value);
	    };
	
	
	    /**
	     * @function Condition#width
	     * @param {string} operator the comparison operator (e.g. "<", "lt")
	     * @param {string|number} value the right hand side value
	     * @return {Condition} this condition
	     */
	
	    Condition.prototype.width = function(operator, value) {
	      return this.predicate("w", operator, value);
	    };
	
	
	    /**
	     * @function Condition#aspectRatio
	     * @param {string} operator the comparison operator (e.g. "<", "lt")
	     * @param {string|number} value the right hand side value
	     * @return {Condition} this condition
	     */
	
	    Condition.prototype.aspectRatio = function(operator, value) {
	      return this.predicate("ar", operator, value);
	    };
	
	
	    /**
	     * @function Condition#pages
	     * @param {string} operator the comparison operator (e.g. "<", "lt")
	     * @param {string|number} value the right hand side value
	     * @return {Condition} this condition
	     */
	
	    Condition.prototype.pageCount = function(operator, value) {
	      return this.predicate("pc", operator, value);
	    };
	
	
	    /**
	     * @function Condition#faces
	     * @param {string} operator the comparison operator (e.g. "<", "lt")
	     * @param {string|number} value the right hand side value
	     * @return {Condition} this condition
	     */
	
	    Condition.prototype.faceCount = function(operator, value) {
	      return this.predicate("fc", operator, value);
	    };
	
	    return Condition;
	
	  })(Expression);
	
	  /**
	   * Cloudinary configuration class
	   * Depends on 'utils'
	   */
	  Configuration = (function() {
	
	    /**
	     * Defaults configuration.
	     */
	    var DEFAULT_CONFIGURATION_PARAMS, ref;
	
	    DEFAULT_CONFIGURATION_PARAMS = {
	      responsive_class: 'cld-responsive',
	      responsive_use_breakpoints: true,
	      round_dpr: true,
	      secure: (typeof window !== "undefined" && window !== null ? (ref = window.location) != null ? ref.protocol : void 0 : void 0) === 'https:'
	    };
	
	    Configuration.CONFIG_PARAMS = ["api_key", "api_secret", "callback", "cdn_subdomain", "cloud_name", "cname", "private_cdn", "protocol", "resource_type", "responsive", "responsive_class", "responsive_use_breakpoints", "responsive_width", "round_dpr", "secure", "secure_cdn_subdomain", "secure_distribution", "shorten", "type", "upload_preset", "url_suffix", "use_root_path", "version"];
	
	
	    /**
	     * Cloudinary configuration class
	     * @constructor Configuration
	     * @param {Object} options - configuration parameters
	     */
	
	    function Configuration(options) {
	      if (options == null) {
	        options = {};
	      }
	      this.configuration = Util.cloneDeep(options);
	      Util.defaults(this.configuration, DEFAULT_CONFIGURATION_PARAMS);
	    }
	
	
	    /**
	     * Initialize the configuration.
	     * The function first tries to retrieve the configuration form the environment and then from the document.
	     * @function Configuration#init
	     * @return {Configuration} returns this for chaining
	     * @see fromDocument
	     * @see fromEnvironment
	     */
	
	    Configuration.prototype.init = function() {
	      this.fromEnvironment();
	      this.fromDocument();
	      return this;
	    };
	
	
	    /**
	     * Set a new configuration item
	     * @function Configuration#set
	     * @param {string} name - the name of the item to set
	     * @param {*} value - the value to be set
	     * @return {Configuration}
	     *
	     */
	
	    Configuration.prototype.set = function(name, value) {
	      this.configuration[name] = value;
	      return this;
	    };
	
	
	    /**
	     * Get the value of a configuration item
	     * @function Configuration#get
	     * @param {string} name - the name of the item to set
	     * @return {*} the configuration item
	     */
	
	    Configuration.prototype.get = function(name) {
	      return this.configuration[name];
	    };
	
	    Configuration.prototype.merge = function(config) {
	      if (config == null) {
	        config = {};
	      }
	      Util.assign(this.configuration, Util.cloneDeep(config));
	      return this;
	    };
	
	
	    /**
	     * Initialize Cloudinary from HTML meta tags.
	     * @function Configuration#fromDocument
	     * @return {Configuration}
	     * @example <meta name="cloudinary_cloud_name" content="mycloud">
	     *
	     */
	
	    Configuration.prototype.fromDocument = function() {
	      var el, j, len, meta_elements;
	      meta_elements = typeof document !== "undefined" && document !== null ? document.querySelectorAll('meta[name^="cloudinary_"]') : void 0;
	      if (meta_elements) {
	        for (j = 0, len = meta_elements.length; j < len; j++) {
	          el = meta_elements[j];
	          this.configuration[el.getAttribute('name').replace('cloudinary_', '')] = el.getAttribute('content');
	        }
	      }
	      return this;
	    };
	
	
	    /**
	     * Initialize Cloudinary from the `CLOUDINARY_URL` environment variable.
	     *
	     * This function will only run under Node.js environment.
	     * @function Configuration#fromEnvironment
	     * @requires Node.js
	     */
	
	    Configuration.prototype.fromEnvironment = function() {
	      var cloudinary_url, j, k, len, query, ref1, ref2, ref3, uri, uriRegex, v, value;
	      cloudinary_url = typeof process !== "undefined" && process !== null ? (ref1 = ({"NODE_ENV":"production","PUBLIC_DIR":"/Users/goose/Documents/Goose/htdocs/Goose/bc-landing-page-production/public"})) != null ? ref1.CLOUDINARY_URL : void 0 : void 0;
	      if (cloudinary_url != null) {
	        uriRegex = /cloudinary:\/\/(?:(\w+)(?:\:([\w-]+))?@)?([\w\.-]+)(?:\/([^?]*))?(?:\?(.+))?/;
	        uri = uriRegex.exec(cloudinary_url);
	        if (uri) {
	          if (uri[3] != null) {
	            this.configuration['cloud_name'] = uri[3];
	          }
	          if (uri[1] != null) {
	            this.configuration['api_key'] = uri[1];
	          }
	          if (uri[2] != null) {
	            this.configuration['api_secret'] = uri[2];
	          }
	          if (uri[4] != null) {
	            this.configuration['private_cdn'] = uri[4] != null;
	          }
	          if (uri[4] != null) {
	            this.configuration['secure_distribution'] = uri[4];
	          }
	          query = uri[5];
	          if (query != null) {
	            ref2 = query.split('&');
	            for (j = 0, len = ref2.length; j < len; j++) {
	              value = ref2[j];
	              ref3 = value.split('='), k = ref3[0], v = ref3[1];
	              if (v == null) {
	                v = true;
	              }
	              this.configuration[k] = v;
	            }
	          }
	        }
	      }
	      return this;
	    };
	
	
	    /**
	     * Create or modify the Cloudinary client configuration
	     *
	     * Warning: `config()` returns the actual internal configuration object. modifying it will change the configuration.
	     *
	     * This is a backward compatibility method. For new code, use get(), merge() etc.
	     * @function Configuration#config
	     * @param {hash|string|boolean} new_config
	     * @param {string} new_value
	     * @returns {*} configuration, or value
	     *
	     * @see {@link fromEnvironment} for initialization using environment variables
	     * @see {@link fromDocument} for initialization using HTML meta tags
	     */
	
	    Configuration.prototype.config = function(new_config, new_value) {
	      switch (false) {
	        case new_value === void 0:
	          this.set(new_config, new_value);
	          return this.configuration;
	        case !Util.isString(new_config):
	          return this.get(new_config);
	        case !Util.isPlainObject(new_config):
	          this.merge(new_config);
	          return this.configuration;
	        default:
	          return this.configuration;
	      }
	    };
	
	
	    /**
	     * Returns a copy of the configuration parameters
	     * @function Configuration#toOptions
	     * @returns {Object} a key:value collection of the configuration parameters
	     */
	
	    Configuration.prototype.toOptions = function() {
	      return Util.cloneDeep(this.configuration);
	    };
	
	    return Configuration;
	
	  })();
	
	  /**
	   * TransformationBase
	   * Depends on 'configuration', 'parameters','util'
	   * @internal
	   */
	  TransformationBase = (function() {
	    var VAR_NAME_RE, lastArgCallback, processVar;
	
	    VAR_NAME_RE = /^\$[a-zA-Z0-9]+$/;
	
	    TransformationBase.prototype.trans_separator = '/';
	
	    TransformationBase.prototype.param_separator = ',';
	
	    lastArgCallback = function(args) {
	      var callback;
	      callback = args != null ? args[args.length - 1] : void 0;
	      if (Util.isFunction(callback)) {
	        return callback;
	      } else {
	        return void 0;
	      }
	    };
	
	
	    /**
	     * The base class for transformations.
	     * Members of this class are documented as belonging to the {@link Transformation} class for convenience.
	     * @class TransformationBase
	     */
	
	    function TransformationBase(options) {
	      var parent, trans;
	      if (options == null) {
	        options = {};
	      }
	
	      /** @private */
	      parent = void 0;
	
	      /** @private */
	      trans = {};
	
	      /**
	       * Return an options object that can be used to create an identical Transformation
	       * @function Transformation#toOptions
	       * @return {Object} Returns a plain object representing this transformation
	       */
	      this.toOptions || (this.toOptions = function(withChain) {
	        var key, list, opt, ref, ref1, tr, value;
	        if (withChain == null) {
	          withChain = true;
	        }
	        opt = {};
	        for (key in trans) {
	          value = trans[key];
	          opt[key] = value.origValue;
	        }
	        ref = this.otherOptions;
	        for (key in ref) {
	          value = ref[key];
	          if (value !== void 0) {
	            opt[key] = value;
	          }
	        }
	        if (withChain && !Util.isEmpty(this.chained)) {
	          list = (function() {
	            var j, len, ref1, results;
	            ref1 = this.chained;
	            results = [];
	            for (j = 0, len = ref1.length; j < len; j++) {
	              tr = ref1[j];
	              results.push(tr.toOptions());
	            }
	            return results;
	          }).call(this);
	          list.push(opt);
	          opt = {};
	          ref1 = this.otherOptions;
	          for (key in ref1) {
	            value = ref1[key];
	            if (value !== void 0) {
	              opt[key] = value;
	            }
	          }
	          opt.transformation = list;
	        }
	        return opt;
	      });
	
	      /**
	       * Set a parent for this object for chaining purposes.
	       *
	       * @function Transformation#setParent
	       * @param {Object} object - the parent to be assigned to
	       * @returns {Transformation} Returns this instance for chaining purposes.
	       */
	      this.setParent || (this.setParent = function(object) {
	        parent = object;
	        if (object != null) {
	          this.fromOptions(typeof object.toOptions === "function" ? object.toOptions() : void 0);
	        }
	        return this;
	      });
	
	      /**
	       * Returns the parent of this object in the chain
	       * @function Transformation#getParent
	       * @protected
	       * @return {Object} Returns the parent of this object if there is any
	       */
	      this.getParent || (this.getParent = function() {
	        return parent;
	      });
	
	      /** @protected */
	      this.param || (this.param = function(value, name, abbr, defaultValue, process) {
	        if (process == null) {
	          if (Util.isFunction(defaultValue)) {
	            process = defaultValue;
	          } else {
	            process = Util.identity;
	          }
	        }
	        trans[name] = new Param(name, abbr, process).set(value);
	        return this;
	      });
	
	      /** @protected */
	      this.rawParam || (this.rawParam = function(value, name, abbr, defaultValue, process) {
	        if (process == null) {
	          process = Util.identity;
	        }
	        process = lastArgCallback(arguments);
	        trans[name] = new RawParam(name, abbr, process).set(value);
	        return this;
	      });
	
	      /** @protected */
	      this.rangeParam || (this.rangeParam = function(value, name, abbr, defaultValue, process) {
	        if (process == null) {
	          process = Util.identity;
	        }
	        process = lastArgCallback(arguments);
	        trans[name] = new RangeParam(name, abbr, process).set(value);
	        return this;
	      });
	
	      /** @protected */
	      this.arrayParam || (this.arrayParam = function(value, name, abbr, sep, defaultValue, process) {
	        if (sep == null) {
	          sep = ":";
	        }
	        if (defaultValue == null) {
	          defaultValue = [];
	        }
	        if (process == null) {
	          process = Util.identity;
	        }
	        process = lastArgCallback(arguments);
	        trans[name] = new ArrayParam(name, abbr, sep, process).set(value);
	        return this;
	      });
	
	      /** @protected */
	      this.transformationParam || (this.transformationParam = function(value, name, abbr, sep, defaultValue, process) {
	        if (sep == null) {
	          sep = ".";
	        }
	        if (process == null) {
	          process = Util.identity;
	        }
	        process = lastArgCallback(arguments);
	        trans[name] = new TransformationParam(name, abbr, sep, process).set(value);
	        return this;
	      });
	      this.layerParam || (this.layerParam = function(value, name, abbr) {
	        trans[name] = new LayerParam(name, abbr).set(value);
	        return this;
	      });
	
	      /**
	       * Get the value associated with the given name.
	       * @function Transformation#getValue
	       * @param {string} name - the name of the parameter
	       * @return {*} the processed value associated with the given name
	       * @description Use {@link get}.origValue for the value originally provided for the parameter
	       */
	      this.getValue || (this.getValue = function(name) {
	        var ref, ref1;
	        return (ref = (ref1 = trans[name]) != null ? ref1.value() : void 0) != null ? ref : this.otherOptions[name];
	      });
	
	      /**
	       * Get the parameter object for the given parameter name
	       * @function Transformation#get
	       * @param {string} name the name of the transformation parameter
	       * @returns {Param} the param object for the given name, or undefined
	       */
	      this.get || (this.get = function(name) {
	        return trans[name];
	      });
	
	      /**
	       * Remove a transformation option from the transformation.
	       * @function Transformation#remove
	       * @param {string} name - the name of the option to remove
	       * @return {*} Returns the option that was removed or null if no option by that name was found. The type of the
	       *              returned value depends on the value.
	       */
	      this.remove || (this.remove = function(name) {
	        var temp;
	        switch (false) {
	          case trans[name] == null:
	            temp = trans[name];
	            delete trans[name];
	            return temp.origValue;
	          case this.otherOptions[name] == null:
	            temp = this.otherOptions[name];
	            delete this.otherOptions[name];
	            return temp;
	          default:
	            return null;
	        }
	      });
	
	      /**
	       * Return an array of all the keys (option names) in the transformation.
	       * @return {Array<string>} the keys in snakeCase format
	       */
	      this.keys || (this.keys = function() {
	        var key;
	        return ((function() {
	          var results;
	          results = [];
	          for (key in trans) {
	            if (key != null) {
	              results.push(key.match(VAR_NAME_RE) ? key : Util.snakeCase(key));
	            }
	          }
	          return results;
	        })()).sort();
	      });
	
	      /**
	       * Returns a plain object representation of the transformation. Values are processed.
	       * @function Transformation#toPlainObject
	       * @return {Object} the transformation options as plain object
	       */
	      this.toPlainObject || (this.toPlainObject = function() {
	        var hash, key, list, tr;
	        hash = {};
	        for (key in trans) {
	          hash[key] = trans[key].value();
	          if (Util.isPlainObject(hash[key])) {
	            hash[key] = Util.cloneDeep(hash[key]);
	          }
	        }
	        if (!Util.isEmpty(this.chained)) {
	          list = (function() {
	            var j, len, ref, results;
	            ref = this.chained;
	            results = [];
	            for (j = 0, len = ref.length; j < len; j++) {
	              tr = ref[j];
	              results.push(tr.toPlainObject());
	            }
	            return results;
	          }).call(this);
	          list.push(hash);
	          hash = {
	            transformation: list
	          };
	        }
	        return hash;
	      });
	
	      /**
	       * Complete the current transformation and chain to a new one.
	       * In the URL, transformations are chained together by slashes.
	       * @function Transformation#chain
	       * @return {Transformation} Returns this transformation for chaining
	       * @example
	       * var tr = cloudinary.Transformation.new();
	       * tr.width(10).crop('fit').chain().angle(15).serialize()
	       * // produces "c_fit,w_10/a_15"
	       */
	      this.chain || (this.chain = function() {
	        var names, tr;
	        names = Object.getOwnPropertyNames(trans);
	        if (names.length !== 0) {
	          tr = new this.constructor(this.toOptions(false));
	          this.resetTransformations();
	          this.chained.push(tr);
	        }
	        return this;
	      });
	      this.resetTransformations || (this.resetTransformations = function() {
	        trans = {};
	        return this;
	      });
	      this.otherOptions || (this.otherOptions = {});
	      this.chained = [];
	      if (!Util.isEmpty(options)) {
	        this.fromOptions(options);
	      }
	    }
	
	
	    /**
	     * Merge the provided options with own's options
	     * @param {Object} [options={}] key-value list of options
	     * @returns {Transformation} Returns this instance for chaining
	     */
	
	    TransformationBase.prototype.fromOptions = function(options) {
	      var key, opt;
	      if (options instanceof TransformationBase) {
	        this.fromTransformation(options);
	      } else {
	        options || (options = {});
	        if (Util.isString(options) || Util.isArray(options)) {
	          options = {
	            transformation: options
	          };
	        }
	        options = Util.cloneDeep(options, function(value) {
	          if (value instanceof TransformationBase) {
	            return new value.constructor(value.toOptions());
	          }
	        });
	        if (options["if"]) {
	          this.set("if", options["if"]);
	          delete options["if"];
	        }
	        for (key in options) {
	          opt = options[key];
	          if (key.match(VAR_NAME_RE)) {
	            if (key !== '$attr') {
	              this.set('variable', key, opt);
	            }
	          } else {
	            this.set(key, opt);
	          }
	        }
	      }
	      return this;
	    };
	
	    TransformationBase.prototype.fromTransformation = function(other) {
	      var j, key, len, ref;
	      if (other instanceof TransformationBase) {
	        ref = other.keys();
	        for (j = 0, len = ref.length; j < len; j++) {
	          key = ref[j];
	          this.set(key, other.get(key).origValue);
	        }
	      }
	      return this;
	    };
	
	
	    /**
	     * Set a parameter.
	     * The parameter name `key` is converted to
	     * @param {string} key - the name of the parameter
	     * @param {*} value - the value of the parameter
	     * @returns {Transformation} Returns this instance for chaining
	     */
	
	    TransformationBase.prototype.set = function() {
	      var camelKey, key, values;
	      key = arguments[0], values = 2 <= arguments.length ? slice.call(arguments, 1) : [];
	      camelKey = Util.camelCase(key);
	      if (Util.contains(Transformation.methods, camelKey)) {
	        this[camelKey].apply(this, values);
	      } else {
	        this.otherOptions[key] = values[0];
	      }
	      return this;
	    };
	
	    TransformationBase.prototype.hasLayer = function() {
	      return this.getValue("overlay") || this.getValue("underlay");
	    };
	
	
	    /**
	     * Generate a string representation of the transformation.
	     * @function Transformation#serialize
	     * @return {string} Returns the transformation as a string
	     */
	
	    TransformationBase.prototype.serialize = function() {
	      var ifParam, j, len, paramList, ref, ref1, ref2, ref3, ref4, resultArray, t, tr, transformationList, transformationString, transformations, value, variables, vars;
	      resultArray = (function() {
	        var j, len, ref, results;
	        ref = this.chained;
	        results = [];
	        for (j = 0, len = ref.length; j < len; j++) {
	          tr = ref[j];
	          results.push(tr.serialize());
	        }
	        return results;
	      }).call(this);
	      paramList = this.keys();
	      transformations = (ref = this.get("transformation")) != null ? ref.serialize() : void 0;
	      ifParam = (ref1 = this.get("if")) != null ? ref1.serialize() : void 0;
	      variables = processVar((ref2 = this.get("variables")) != null ? ref2.value() : void 0);
	      paramList = Util.difference(paramList, ["transformation", "if", "variables"]);
	      vars = [];
	      transformationList = [];
	      for (j = 0, len = paramList.length; j < len; j++) {
	        t = paramList[j];
	        if (t.match(VAR_NAME_RE)) {
	          vars.push(t + "_" + Expression.normalize((ref3 = this.get(t)) != null ? ref3.value() : void 0));
	        } else {
	          transformationList.push((ref4 = this.get(t)) != null ? ref4.serialize() : void 0);
	        }
	      }
	      switch (false) {
	        case !Util.isString(transformations):
	          transformationList.push(transformations);
	          break;
	        case !Util.isArray(transformations):
	          resultArray = resultArray.concat(transformations);
	      }
	      transformationList = (function() {
	        var l, len1, results;
	        results = [];
	        for (l = 0, len1 = transformationList.length; l < len1; l++) {
	          value = transformationList[l];
	          if (Util.isArray(value) && !Util.isEmpty(value) || !Util.isArray(value) && value) {
	            results.push(value);
	          }
	        }
	        return results;
	      })();
	      transformationList = vars.sort().concat(variables).concat(transformationList.sort());
	      if (ifParam === "if_end") {
	        transformationList.push(ifParam);
	      } else if (!Util.isEmpty(ifParam)) {
	        transformationList.unshift(ifParam);
	      }
	      transformationString = Util.compact(transformationList).join(this.param_separator);
	      if (!Util.isEmpty(transformationString)) {
	        resultArray.push(transformationString);
	      }
	      return Util.compact(resultArray).join(this.trans_separator);
	    };
	
	
	    /**
	     * Provide a list of all the valid transformation option names
	     * @function Transformation#listNames
	     * @private
	     * @return {Array<string>} a array of all the valid option names
	     */
	
	    TransformationBase.prototype.listNames = function() {
	      return Transformation.methods;
	    };
	
	
	    /**
	     * Returns attributes for an HTML tag.
	     * @function Cloudinary.toHtmlAttributes
	     * @return PlainObject
	     */
	
	    TransformationBase.prototype.toHtmlAttributes = function() {
	      var attrName, height, j, key, len, options, ref, ref1, ref2, ref3, value;
	      options = {};
	      ref = this.otherOptions;
	      for (key in ref) {
	        value = ref[key];
	        if (!(!Util.contains(Transformation.PARAM_NAMES, Util.snakeCase(key)))) {
	          continue;
	        }
	        attrName = /^html_/.test(key) ? key.slice(5) : key;
	        options[attrName] = value;
	      }
	      ref1 = this.keys();
	      for (j = 0, len = ref1.length; j < len; j++) {
	        key = ref1[j];
	        if (/^html_/.test(key)) {
	          options[Util.camelCase(key.slice(5))] = this.getValue(key);
	        }
	      }
	      if (!(this.hasLayer() || this.getValue("angle") || Util.contains(["fit", "limit", "lfill"], this.getValue("crop")))) {
	        width = (ref2 = this.get("width")) != null ? ref2.origValue : void 0;
	        height = (ref3 = this.get("height")) != null ? ref3.origValue : void 0;
	        if (parseFloat(width) >= 1.0) {
	          if (options['width'] == null) {
	            options['width'] = width;
	          }
	        }
	        if (parseFloat(height) >= 1.0) {
	          if (options['height'] == null) {
	            options['height'] = height;
	          }
	        }
	      }
	      return options;
	    };
	
	    TransformationBase.prototype.isValidParamName = function(name) {
	      return Transformation.methods.indexOf(Util.camelCase(name)) >= 0;
	    };
	
	
	    /**
	     * Delegate to the parent (up the call chain) to produce HTML
	     * @function Transformation#toHtml
	     * @return {string} HTML representation of the parent if possible.
	     * @example
	     * tag = cloudinary.ImageTag.new("sample", {cloud_name: "demo"})
	     * // ImageTag {name: "img", publicId: "sample"}
	     * tag.toHtml()
	     * // <img src="http://res.cloudinary.com/demo/image/upload/sample">
	     * tag.transformation().crop("fit").width(300).toHtml()
	     * // <img src="http://res.cloudinary.com/demo/image/upload/c_fit,w_300/sample">
	     */
	
	    TransformationBase.prototype.toHtml = function() {
	      var ref;
	      return (ref = this.getParent()) != null ? typeof ref.toHtml === "function" ? ref.toHtml() : void 0 : void 0;
	    };
	
	    TransformationBase.prototype.toString = function() {
	      return this.serialize();
	    };
	
	    processVar = function(varArray) {
	      var j, len, name, ref, results, v;
	      if (Util.isArray(varArray)) {
	        results = [];
	        for (j = 0, len = varArray.length; j < len; j++) {
	          ref = varArray[j], name = ref[0], v = ref[1];
	          results.push(name + "_" + (Expression.normalize(v)));
	        }
	        return results;
	      } else {
	        return varArray;
	      }
	
	      /**
	       * Transformation Class methods.
	       * This is a list of the parameters defined in Transformation.
	       * Values are camelCased.
	       * @const Transformation.methods
	       * @private
	       * @ignore
	       * @type {Array<string>}
	       */
	
	      /**
	       * Parameters that are filtered out before passing the options to an HTML tag.
	       *
	       * The list of parameters is a combination of `Transformation::methods` and `Configuration::CONFIG_PARAMS`
	       * @const {Array<string>} Transformation.PARAM_NAMES
	       * @private
	       * @ignore
	       * @see toHtmlAttributes
	       */
	    };
	
	    return TransformationBase;
	
	  })();
	  Transformation = (function(superClass) {
	    extend(Transformation, superClass);
	
	
	    /**
	     *  Represents a single transformation.
	     *  @class Transformation
	     *  @example
	     *  t = new cloudinary.Transformation();
	     * t.angle(20).crop("scale").width("auto");
	     *
	     * // or
	     *
	     * t = new cloudinary.Transformation( {angle: 20, crop: "scale", width: "auto"});
	     */
	
	    function Transformation(options) {
	      if (options == null) {
	        options = {};
	      }
	      Transformation.__super__.constructor.call(this, options);
	      this;
	    }
	
	
	    /**
	     * Convenience constructor
	     * @param {Object} options
	     * @return {Transformation}
	     * @example cl = cloudinary.Transformation.new( {angle: 20, crop: "scale", width: "auto"})
	     */
	
	    Transformation["new"] = function(args) {
	      return new Transformation(args);
	    };
	
	
	    /*
	      Transformation Parameters
	     */
	
	    Transformation.prototype.angle = function(value) {
	      return this.arrayParam(value, "angle", "a", ".", Expression.normalize);
	    };
	
	    Transformation.prototype.audioCodec = function(value) {
	      return this.param(value, "audio_codec", "ac");
	    };
	
	    Transformation.prototype.audioFrequency = function(value) {
	      return this.param(value, "audio_frequency", "af");
	    };
	
	    Transformation.prototype.aspectRatio = function(value) {
	      return this.param(value, "aspect_ratio", "ar", Expression.normalize);
	    };
	
	    Transformation.prototype.background = function(value) {
	      return this.param(value, "background", "b", Param.norm_color);
	    };
	
	    Transformation.prototype.bitRate = function(value) {
	      return this.param(value, "bit_rate", "br");
	    };
	
	    Transformation.prototype.border = function(value) {
	      return this.param(value, "border", "bo", function(border) {
	        if (Util.isPlainObject(border)) {
	          border = Util.assign({}, {
	            color: "black",
	            width: 2
	          }, border);
	          return border.width + "px_solid_" + (Param.norm_color(border.color));
	        } else {
	          return border;
	        }
	      });
	    };
	
	    Transformation.prototype.color = function(value) {
	      return this.param(value, "color", "co", Param.norm_color);
	    };
	
	    Transformation.prototype.colorSpace = function(value) {
	      return this.param(value, "color_space", "cs");
	    };
	
	    Transformation.prototype.crop = function(value) {
	      return this.param(value, "crop", "c");
	    };
	
	    Transformation.prototype.defaultImage = function(value) {
	      return this.param(value, "default_image", "d");
	    };
	
	    Transformation.prototype.delay = function(value) {
	      return this.param(value, "delay", "dl");
	    };
	
	    Transformation.prototype.density = function(value) {
	      return this.param(value, "density", "dn");
	    };
	
	    Transformation.prototype.duration = function(value) {
	      return this.rangeParam(value, "duration", "du");
	    };
	
	    Transformation.prototype.dpr = function(value) {
	      return this.param(value, "dpr", "dpr", (function(_this) {
	        return function(dpr) {
	          dpr = dpr.toString();
	          if (dpr != null ? dpr.match(/^\d+$/) : void 0) {
	            return dpr + ".0";
	          } else {
	            return Expression.normalize(dpr);
	          }
	        };
	      })(this));
	    };
	
	    Transformation.prototype.effect = function(value) {
	      return this.arrayParam(value, "effect", "e", ":", Expression.normalize);
	    };
	
	    Transformation.prototype["else"] = function() {
	      return this["if"]('else');
	    };
	
	    Transformation.prototype.endIf = function() {
	      return this["if"]('end');
	    };
	
	    Transformation.prototype.endOffset = function(value) {
	      return this.rangeParam(value, "end_offset", "eo");
	    };
	
	    Transformation.prototype.fallbackContent = function(value) {
	      return this.param(value, "fallback_content");
	    };
	
	    Transformation.prototype.fetchFormat = function(value) {
	      return this.param(value, "fetch_format", "f");
	    };
	
	    Transformation.prototype.format = function(value) {
	      return this.param(value, "format");
	    };
	
	    Transformation.prototype.flags = function(value) {
	      return this.arrayParam(value, "flags", "fl", ".");
	    };
	
	    Transformation.prototype.gravity = function(value) {
	      return this.param(value, "gravity", "g");
	    };
	
	    Transformation.prototype.height = function(value) {
	      return this.param(value, "height", "h", (function(_this) {
	        return function() {
	          if (_this.getValue("crop") || _this.getValue("overlay") || _this.getValue("underlay")) {
	            return Expression.normalize(value);
	          } else {
	            return null;
	          }
	        };
	      })(this));
	    };
	
	    Transformation.prototype.htmlHeight = function(value) {
	      return this.param(value, "html_height");
	    };
	
	    Transformation.prototype.htmlWidth = function(value) {
	      return this.param(value, "html_width");
	    };
	
	    Transformation.prototype["if"] = function(value) {
	      var i, ifVal, j, ref, trIf, trRest;
	      if (value == null) {
	        value = "";
	      }
	      switch (value) {
	        case "else":
	          this.chain();
	          return this.param(value, "if", "if");
	        case "end":
	          this.chain();
	          for (i = j = ref = this.chained.length - 1; j >= 0; i = j += -1) {
	            ifVal = this.chained[i].getValue("if");
	            if (ifVal === "end") {
	              break;
	            } else if (ifVal != null) {
	              trIf = Transformation["new"]()["if"](ifVal);
	              this.chained[i].remove("if");
	              trRest = this.chained[i];
	              this.chained[i] = Transformation["new"]().transformation([trIf, trRest]);
	              if (ifVal !== "else") {
	                break;
	              }
	            }
	          }
	          return this.param(value, "if", "if");
	        case "":
	          return Condition["new"]().setParent(this);
	        default:
	          return this.param(value, "if", "if", function(value) {
	            return Condition["new"](value).toString();
	          });
	      }
	    };
	
	    Transformation.prototype.keyframeInterval = function(value) {
	      return this.param(value, "keyframe_interval", "ki");
	    };
	
	    Transformation.prototype.offset = function(value) {
	      var end_o, ref, start_o;
	      ref = Util.isFunction(value != null ? value.split : void 0) ? value.split('..') : Util.isArray(value) ? value : [null, null], start_o = ref[0], end_o = ref[1];
	      if (start_o != null) {
	        this.startOffset(start_o);
	      }
	      if (end_o != null) {
	        return this.endOffset(end_o);
	      }
	    };
	
	    Transformation.prototype.opacity = function(value) {
	      return this.param(value, "opacity", "o", Expression.normalize);
	    };
	
	    Transformation.prototype.overlay = function(value) {
	      return this.layerParam(value, "overlay", "l");
	    };
	
	    Transformation.prototype.page = function(value) {
	      return this.param(value, "page", "pg");
	    };
	
	    Transformation.prototype.poster = function(value) {
	      return this.param(value, "poster");
	    };
	
	    Transformation.prototype.prefix = function(value) {
	      return this.param(value, "prefix", "p");
	    };
	
	    Transformation.prototype.quality = function(value) {
	      return this.param(value, "quality", "q", Expression.normalize);
	    };
	
	    Transformation.prototype.radius = function(value) {
	      return this.param(value, "radius", "r", Expression.normalize);
	    };
	
	    Transformation.prototype.rawTransformation = function(value) {
	      return this.rawParam(value, "raw_transformation");
	    };
	
	    Transformation.prototype.size = function(value) {
	      var height, ref;
	      if (Util.isFunction(value != null ? value.split : void 0)) {
	        ref = value.split('x'), width = ref[0], height = ref[1];
	        this.width(width);
	        return this.height(height);
	      }
	    };
	
	    Transformation.prototype.sourceTypes = function(value) {
	      return this.param(value, "source_types");
	    };
	
	    Transformation.prototype.sourceTransformation = function(value) {
	      return this.param(value, "source_transformation");
	    };
	
	    Transformation.prototype.startOffset = function(value) {
	      return this.rangeParam(value, "start_offset", "so");
	    };
	
	    Transformation.prototype.streamingProfile = function(value) {
	      return this.param(value, "streaming_profile", "sp");
	    };
	
	    Transformation.prototype.transformation = function(value) {
	      return this.transformationParam(value, "transformation", "t");
	    };
	
	    Transformation.prototype.underlay = function(value) {
	      return this.layerParam(value, "underlay", "u");
	    };
	
	    Transformation.prototype.variable = function(name, value) {
	      return this.param(value, name, name);
	    };
	
	    Transformation.prototype.variables = function(values) {
	      return this.arrayParam(values, "variables");
	    };
	
	    Transformation.prototype.videoCodec = function(value) {
	      return this.param(value, "video_codec", "vc", Param.process_video_params);
	    };
	
	    Transformation.prototype.videoSampling = function(value) {
	      return this.param(value, "video_sampling", "vs");
	    };
	
	    Transformation.prototype.width = function(value) {
	      return this.param(value, "width", "w", (function(_this) {
	        return function() {
	          if (_this.getValue("crop") || _this.getValue("overlay") || _this.getValue("underlay")) {
	            return Expression.normalize(value);
	          } else {
	            return null;
	          }
	        };
	      })(this));
	    };
	
	    Transformation.prototype.x = function(value) {
	      return this.param(value, "x", "x", Expression.normalize);
	    };
	
	    Transformation.prototype.y = function(value) {
	      return this.param(value, "y", "y", Expression.normalize);
	    };
	
	    Transformation.prototype.zoom = function(value) {
	      return this.param(value, "zoom", "z", Expression.normalize);
	    };
	
	    return Transformation;
	
	  })(TransformationBase);
	
	  /**
	   * Transformation Class methods.
	   * This is a list of the parameters defined in Transformation.
	   * Values are camelCased.
	   */
	  Transformation.methods || (Transformation.methods = Util.difference(Util.functions(Transformation.prototype), Util.functions(TransformationBase.prototype)));
	
	  /**
	   * Parameters that are filtered out before passing the options to an HTML tag.
	   *
	   * The list of parameters is a combination of `Transformation::methods` and `Configuration::CONFIG_PARAMS`
	   */
	  Transformation.PARAM_NAMES || (Transformation.PARAM_NAMES = ((function() {
	    var j, len, ref, results;
	    ref = Transformation.methods;
	    results = [];
	    for (j = 0, len = ref.length; j < len; j++) {
	      m = ref[j];
	      results.push(Util.snakeCase(m));
	    }
	    return results;
	  })()).concat(Configuration.CONFIG_PARAMS));
	
	  /**
	   * Generic HTML tag
	   * Depends on 'transformation', 'util'
	   */
	  HtmlTag = (function() {
	
	    /**
	     * Represents an HTML (DOM) tag
	     * @constructor HtmlTag
	     * @param {string} name - the name of the tag
	     * @param {string} [publicId]
	     * @param {Object} options
	     * @example tag = new HtmlTag( 'div', { 'width': 10})
	     */
	    var toAttribute;
	
	    function HtmlTag(name, publicId, options) {
	      var transformation;
	      this.name = name;
	      this.publicId = publicId;
	      if (options == null) {
	        if (Util.isPlainObject(publicId)) {
	          options = publicId;
	          this.publicId = void 0;
	        } else {
	          options = {};
	        }
	      }
	      transformation = new Transformation(options);
	      transformation.setParent(this);
	      this.transformation = function() {
	        return transformation;
	      };
	    }
	
	
	    /**
	     * Convenience constructor
	     * Creates a new instance of an HTML (DOM) tag
	     * @function HtmlTag.new
	     * @param {string} name - the name of the tag
	     * @param {string} [publicId]
	     * @param {Object} options
	     * @return {HtmlTag}
	     * @example tag = HtmlTag.new( 'div', { 'width': 10})
	     */
	
	    HtmlTag["new"] = function(name, publicId, options) {
	      return new this(name, publicId, options);
	    };
	
	
	    /**
	     * Represent the given key and value as an HTML attribute.
	     * @function HtmlTag#toAttribute
	     * @protected
	     * @param {string} key - attribute name
	     * @param {*|boolean} value - the value of the attribute. If the value is boolean `true`, return the key only.
	     * @returns {string} the attribute  
	     *
	     */
	
	    toAttribute = function(key, value) {
	      if (!value) {
	        return void 0;
	      } else if (value === true) {
	        return key;
	      } else {
	        return key + "=\"" + value + "\"";
	      }
	    };
	
	
	    /**
	     * combine key and value from the `attr` to generate an HTML tag attributes string.
	     * `Transformation::toHtmlTagOptions` is used to filter out transformation and configuration keys.
	     * @protected
	     * @param {Object} attrs
	     * @return {string} the attributes in the format `'key1="value1" key2="value2"'`
	     * @ignore
	     */
	
	    HtmlTag.prototype.htmlAttrs = function(attrs) {
	      var key, pairs, value;
	      return pairs = ((function() {
	        var results;
	        results = [];
	        for (key in attrs) {
	          value = attrs[key];
	          if (value) {
	            results.push(toAttribute(key, value));
	          }
	        }
	        return results;
	      })()).sort().join(' ');
	    };
	
	
	    /**
	     * Get all options related to this tag.
	     * @function HtmlTag#getOptions
	     * @returns {Object} the options
	     *
	     */
	
	    HtmlTag.prototype.getOptions = function() {
	      return this.transformation().toOptions();
	    };
	
	
	    /**
	     * Get the value of option `name`
	     * @function HtmlTag#getOption
	     * @param {string} name - the name of the option
	     * @returns {*} Returns the value of the option
	     *
	     */
	
	    HtmlTag.prototype.getOption = function(name) {
	      return this.transformation().getValue(name);
	    };
	
	
	    /**
	     * Get the attributes of the tag.
	     * @function HtmlTag#attributes
	     * @returns {Object} attributes
	     */
	
	    HtmlTag.prototype.attributes = function() {
	      return this.transformation().toHtmlAttributes();
	    };
	
	
	    /**
	     * Set a tag attribute named `name` to `value`
	     * @function HtmlTag#setAttr
	     * @param {string} name - the name of the attribute
	     * @param {string} value - the value of the attribute
	     */
	
	    HtmlTag.prototype.setAttr = function(name, value) {
	      this.transformation().set("html_" + name, value);
	      return this;
	    };
	
	
	    /**
	     * Get the value of the tag attribute `name`
	     * @function HtmlTag#getAttr
	     * @param {string} name - the name of the attribute
	     * @returns {*}
	     */
	
	    HtmlTag.prototype.getAttr = function(name) {
	      return this.attributes()["html_" + name] || this.attributes()[name];
	    };
	
	
	    /**
	     * Remove the tag attributed named `name`
	     * @function HtmlTag#removeAttr
	     * @param {string} name - the name of the attribute
	     * @returns {*}
	     */
	
	    HtmlTag.prototype.removeAttr = function(name) {
	      var ref;
	      return (ref = this.transformation().remove("html_" + name)) != null ? ref : this.transformation().remove(name);
	    };
	
	
	    /**
	     * @function HtmlTag#content
	     * @protected
	     * @ignore
	     */
	
	    HtmlTag.prototype.content = function() {
	      return "";
	    };
	
	
	    /**
	     * @function HtmlTag#openTag
	     * @protected
	     * @ignore
	     */
	
	    HtmlTag.prototype.openTag = function() {
	      return "<" + this.name + " " + (this.htmlAttrs(this.attributes())) + ">";
	    };
	
	
	    /**
	     * @function HtmlTag#closeTag
	     * @protected
	     * @ignore
	     */
	
	    HtmlTag.prototype.closeTag = function() {
	      return "</" + this.name + ">";
	    };
	
	
	    /**
	     * Generates an HTML representation of the tag.
	     * @function HtmlTag#toHtml
	     * @returns {string} Returns HTML in string format
	     */
	
	    HtmlTag.prototype.toHtml = function() {
	      return this.openTag() + this.content() + this.closeTag();
	    };
	
	
	    /**
	     * Creates a DOM object representing the tag.
	     * @function HtmlTag#toDOM
	     * @returns {Element}
	     */
	
	    HtmlTag.prototype.toDOM = function() {
	      var element, name, ref, value;
	      if (!Util.isFunction(typeof document !== "undefined" && document !== null ? document.createElement : void 0)) {
	        throw "Can't create DOM if document is not present!";
	      }
	      element = document.createElement(this.name);
	      ref = this.attributes();
	      for (name in ref) {
	        value = ref[name];
	        element[name] = value;
	      }
	      return element;
	    };
	
	    HtmlTag.isResponsive = function(tag, responsiveClass) {
	      var dataSrc;
	      dataSrc = Util.getData(tag, 'src-cache') || Util.getData(tag, 'src');
	      return Util.hasClass(tag, responsiveClass) && /\bw_auto\b/.exec(dataSrc);
	    };
	
	    return HtmlTag;
	
	  })();
	
	  /**
	   * Image Tag
	   * Depends on 'tags/htmltag', 'cloudinary'
	   */
	  ImageTag = (function(superClass) {
	    extend(ImageTag, superClass);
	
	
	    /**
	     * Creates an HTML (DOM) Image tag using Cloudinary as the source.
	     * @constructor ImageTag
	     * @extends HtmlTag
	     * @param {string} [publicId]
	     * @param {Object} [options]
	     */
	
	    function ImageTag(publicId, options) {
	      if (options == null) {
	        options = {};
	      }
	      ImageTag.__super__.constructor.call(this, "img", publicId, options);
	    }
	
	
	    /** @override */
	
	    ImageTag.prototype.closeTag = function() {
	      return "";
	    };
	
	
	    /** @override */
	
	    ImageTag.prototype.attributes = function() {
	      var attr, options, srcAttribute;
	      attr = ImageTag.__super__.attributes.call(this) || [];
	      options = this.getOptions();
	      srcAttribute = options.responsive && !options.client_hints ? 'data-src' : 'src';
	      if (attr[srcAttribute] == null) {
	        attr[srcAttribute] = new Cloudinary(this.getOptions()).url(this.publicId);
	      }
	      return attr;
	    };
	
	    return ImageTag;
	
	  })(HtmlTag);
	
	  /**
	   * Video Tag
	   * Depends on 'tags/htmltag', 'util', 'cloudinary'
	   */
	  VideoTag = (function(superClass) {
	    var DEFAULT_POSTER_OPTIONS, DEFAULT_VIDEO_SOURCE_TYPES, VIDEO_TAG_PARAMS;
	
	    extend(VideoTag, superClass);
	
	    VIDEO_TAG_PARAMS = ['source_types', 'source_transformation', 'fallback_content', 'poster'];
	
	    DEFAULT_VIDEO_SOURCE_TYPES = ['webm', 'mp4', 'ogv'];
	
	    DEFAULT_POSTER_OPTIONS = {
	      format: 'jpg',
	      resource_type: 'video'
	    };
	
	
	    /**
	     * Creates an HTML (DOM) Video tag using Cloudinary as the source.
	     * @constructor VideoTag
	     * @extends HtmlTag
	     * @param {string} [publicId]
	     * @param {Object} [options]
	     */
	
	    function VideoTag(publicId, options) {
	      if (options == null) {
	        options = {};
	      }
	      options = Util.defaults({}, options, Cloudinary.DEFAULT_VIDEO_PARAMS);
	      VideoTag.__super__.constructor.call(this, "video", publicId.replace(/\.(mp4|ogv|webm)$/, ''), options);
	    }
	
	
	    /**
	     * Set the transformation to apply on each source
	     * @function VideoTag#setSourceTransformation
	     * @param {Object} an object with pairs of source type and source transformation
	     * @returns {VideoTag} Returns this instance for chaining purposes.
	     */
	
	    VideoTag.prototype.setSourceTransformation = function(value) {
	      this.transformation().sourceTransformation(value);
	      return this;
	    };
	
	
	    /**
	     * Set the source types to include in the video tag
	     * @function VideoTag#setSourceTypes
	     * @param {Array<string>} an array of source types
	     * @returns {VideoTag} Returns this instance for chaining purposes.
	     */
	
	    VideoTag.prototype.setSourceTypes = function(value) {
	      this.transformation().sourceTypes(value);
	      return this;
	    };
	
	
	    /**
	     * Set the poster to be used in the video tag
	     * @function VideoTag#setPoster
	     * @param {string|Object} value
	     * - string: a URL to use for the poster
	     * - Object: transformation parameters to apply to the poster. May optionally include a public_id to use instead of the video public_id.
	     * @returns {VideoTag} Returns this instance for chaining purposes.
	     */
	
	    VideoTag.prototype.setPoster = function(value) {
	      this.transformation().poster(value);
	      return this;
	    };
	
	
	    /**
	     * Set the content to use as fallback in the video tag
	     * @function VideoTag#setFallbackContent
	     * @param {string} value - the content to use, in HTML format
	     * @returns {VideoTag} Returns this instance for chaining purposes.
	     */
	
	    VideoTag.prototype.setFallbackContent = function(value) {
	      this.transformation().fallbackContent(value);
	      return this;
	    };
	
	    VideoTag.prototype.content = function() {
	      var cld, fallback, innerTags, mimeType, sourceTransformation, sourceTypes, src, srcType, transformation, videoType;
	      sourceTypes = this.transformation().getValue('source_types');
	      sourceTransformation = this.transformation().getValue('source_transformation');
	      fallback = this.transformation().getValue('fallback_content');
	      if (Util.isArray(sourceTypes)) {
	        cld = new Cloudinary(this.getOptions());
	        innerTags = (function() {
	          var j, len, results;
	          results = [];
	          for (j = 0, len = sourceTypes.length; j < len; j++) {
	            srcType = sourceTypes[j];
	            transformation = sourceTransformation[srcType] || {};
	            src = cld.url("" + this.publicId, Util.defaults({}, transformation, {
	              resource_type: 'video',
	              format: srcType
	            }));
	            videoType = srcType === 'ogv' ? 'ogg' : srcType;
	            mimeType = 'video/' + videoType;
	            results.push("<source " + (this.htmlAttrs({
	              src: src,
	              type: mimeType
	            })) + ">");
	          }
	          return results;
	        }).call(this);
	      } else {
	        innerTags = [];
	      }
	      return innerTags.join('') + fallback;
	    };
	
	    VideoTag.prototype.attributes = function() {
	      var a, attr, j, len, poster, ref, ref1, sourceTypes;
	      sourceTypes = this.getOption('source_types');
	      poster = (ref = this.getOption('poster')) != null ? ref : {};
	      if (Util.isPlainObject(poster)) {
	        defaults = poster.public_id != null ? Cloudinary.DEFAULT_IMAGE_PARAMS : DEFAULT_POSTER_OPTIONS;
	        poster = new Cloudinary(this.getOptions()).url((ref1 = poster.public_id) != null ? ref1 : this.publicId, Util.defaults({}, poster, defaults));
	      }
	      attr = VideoTag.__super__.attributes.call(this) || [];
	      for (j = 0, len = attr.length; j < len; j++) {
	        a = attr[j];
	        if (!Util.contains(VIDEO_TAG_PARAMS)) {
	          attr = a;
	        }
	      }
	      if (!Util.isArray(sourceTypes)) {
	        attr["src"] = new Cloudinary(this.getOptions()).url(this.publicId, {
	          resource_type: 'video',
	          format: sourceTypes
	        });
	      }
	      if (poster != null) {
	        attr["poster"] = poster;
	      }
	      return attr;
	    };
	
	    return VideoTag;
	
	  })(HtmlTag);
	
	  /**
	   * Image Tag
	   * Depends on 'tags/htmltag', 'cloudinary'
	   */
	  ClientHintsMetaTag = (function(superClass) {
	    extend(ClientHintsMetaTag, superClass);
	
	
	    /**
	     * Creates an HTML (DOM) Meta tag that enables client-hints.
	     * @constructor ClientHintsMetaTag
	     * @extends HtmlTag
	     */
	
	    function ClientHintsMetaTag(options) {
	      ClientHintsMetaTag.__super__.constructor.call(this, 'meta', void 0, Util.assign({
	        "http-equiv": "Accept-CH",
	        content: "DPR, Viewport-Width, Width"
	      }, options));
	    }
	
	
	    /** @override */
	
	    ClientHintsMetaTag.prototype.closeTag = function() {
	      return "";
	    };
	
	    return ClientHintsMetaTag;
	
	  })(HtmlTag);
	  Cloudinary = (function() {
	    var AKAMAI_SHARED_CDN, CF_SHARED_CDN, DEFAULT_POSTER_OPTIONS, DEFAULT_VIDEO_SOURCE_TYPES, OLD_AKAMAI_SHARED_CDN, SEO_TYPES, SHARED_CDN, VERSION, absolutize, applyBreakpoints, cdnSubdomainNumber, closestAbove, cloudinaryUrlPrefix, defaultBreakpoints, finalizeResourceType, findContainerWidth, maxWidth, updateDpr;
	
	    VERSION = "2.5.0";
	
	    CF_SHARED_CDN = "d3jpl91pxevbkh.cloudfront.net";
	
	    OLD_AKAMAI_SHARED_CDN = "cloudinary-a.akamaihd.net";
	
	    AKAMAI_SHARED_CDN = "res.cloudinary.com";
	
	    SHARED_CDN = AKAMAI_SHARED_CDN;
	
	    DEFAULT_POSTER_OPTIONS = {
	      format: 'jpg',
	      resource_type: 'video'
	    };
	
	    DEFAULT_VIDEO_SOURCE_TYPES = ['webm', 'mp4', 'ogv'];
	
	    SEO_TYPES = {
	      "image/upload": "images",
	      "image/private": "private_images",
	      "image/authenticated": "authenticated_images",
	      "raw/upload": "files",
	      "video/upload": "videos"
	    };
	
	
	    /**
	    * @const {Object} Cloudinary.DEFAULT_IMAGE_PARAMS
	    * Defaults values for image parameters.
	    *
	    * (Previously defined using option_consume() )
	     */
	
	    Cloudinary.DEFAULT_IMAGE_PARAMS = {
	      resource_type: "image",
	      transformation: [],
	      type: 'upload'
	    };
	
	
	    /**
	    * Defaults values for video parameters.
	    * @const {Object} Cloudinary.DEFAULT_VIDEO_PARAMS
	    * (Previously defined using option_consume() )
	     */
	
	    Cloudinary.DEFAULT_VIDEO_PARAMS = {
	      fallback_content: '',
	      resource_type: "video",
	      source_transformation: {},
	      source_types: DEFAULT_VIDEO_SOURCE_TYPES,
	      transformation: [],
	      type: 'upload'
	    };
	
	
	    /**
	     * Main Cloudinary class
	     * @class Cloudinary
	     * @param {Object} options - options to configure Cloudinary
	     * @see Configuration for more details
	     * @example
	     *    var cl = new cloudinary.Cloudinary( { cloud_name: "mycloud"});
	     *    var imgTag = cl.image("myPicID");
	     */
	
	    function Cloudinary(options) {
	      var configuration;
	      this.devicePixelRatioCache = {};
	      this.responsiveConfig = {};
	      this.responsiveResizeInitialized = false;
	      configuration = new Configuration(options);
	      this.config = function(newConfig, newValue) {
	        return configuration.config(newConfig, newValue);
	      };
	
	      /**
	       * Use \<meta\> tags in the document to configure this Cloudinary instance.
	       * @return {Cloudinary} this for chaining
	       */
	      this.fromDocument = function() {
	        configuration.fromDocument();
	        return this;
	      };
	
	      /**
	       * Use environment variables to configure this Cloudinary instance.
	       * @return {Cloudinary} this for chaining
	       */
	      this.fromEnvironment = function() {
	        configuration.fromEnvironment();
	        return this;
	      };
	
	      /**
	       * Initialize configuration.
	       * @function Cloudinary#init
	       * @see Configuration#init
	       * @return {Cloudinary} this for chaining
	       */
	      this.init = function() {
	        configuration.init();
	        return this;
	      };
	    }
	
	
	    /**
	     * Convenience constructor
	     * @param {Object} options
	     * @return {Cloudinary}
	     * @example cl = cloudinary.Cloudinary.new( { cloud_name: "mycloud"})
	     */
	
	    Cloudinary["new"] = function(options) {
	      return new this(options);
	    };
	
	
	    /**
	     * Return the resource type and action type based on the given configuration
	     * @function Cloudinary#finalizeResourceType
	     * @param {Object|string} resourceType
	     * @param {string} [type='upload']
	     * @param {string} [urlSuffix]
	     * @param {boolean} [useRootPath]
	     * @param {boolean} [shorten]
	     * @returns {string} resource_type/type
	     * @ignore
	     */
	
	    finalizeResourceType = function(resourceType, type, urlSuffix, useRootPath, shorten) {
	      var key, options;
	      if (resourceType == null) {
	        resourceType = "image";
	      }
	      if (type == null) {
	        type = "upload";
	      }
	      if (Util.isPlainObject(resourceType)) {
	        options = resourceType;
	        resourceType = options.resource_type;
	        type = options.type;
	        urlSuffix = options.url_suffix;
	        useRootPath = options.use_root_path;
	        shorten = options.shorten;
	      }
	      if (type == null) {
	        type = 'upload';
	      }
	      if (urlSuffix != null) {
	        resourceType = SEO_TYPES[resourceType + "/" + type];
	        type = null;
	        if (resourceType == null) {
	          throw new Error("URL Suffix only supported for " + (((function() {
	            var results;
	            results = [];
	            for (key in SEO_TYPES) {
	              results.push(key);
	            }
	            return results;
	          })()).join(', ')));
	        }
	      }
	      if (useRootPath) {
	        if (resourceType === 'image' && type === 'upload' || resourceType === "images") {
	          resourceType = null;
	          type = null;
	        } else {
	          throw new Error("Root path only supported for image/upload");
	        }
	      }
	      if (shorten && resourceType === 'image' && type === 'upload') {
	        resourceType = 'iu';
	        type = null;
	      }
	      return [resourceType, type].join("/");
	    };
	
	    absolutize = function(url) {
	      var prefix;
	      if (!url.match(/^https?:\//)) {
	        prefix = document.location.protocol + '//' + document.location.host;
	        if (url[0] === '?') {
	          prefix += document.location.pathname;
	        } else if (url[0] !== '/') {
	          prefix += document.location.pathname.replace(/\/[^\/]*$/, '/');
	        }
	        url = prefix + url;
	      }
	      return url;
	    };
	
	
	    /**
	     * Generate an resource URL.
	     * @function Cloudinary#url
	     * @param {string} publicId - the public ID of the resource
	     * @param {Object} [options] - options for the tag and transformations, possible values include all {@link Transformation} parameters
	     *                          and {@link Configuration} parameters
	     * @param {string} [options.type='upload'] - the classification of the resource
	     * @param {Object} [options.resource_type='image'] - the type of the resource
	     * @return {string} The resource URL
	     */
	
	    Cloudinary.prototype.url = function(publicId, options) {
	      var error, error1, prefix, ref, resourceTypeAndType, transformation, transformationString, url, version;
	      if (options == null) {
	        options = {};
	      }
	      if (!publicId) {
	        return publicId;
	      }
	      if (options instanceof Transformation) {
	        options = options.toOptions();
	      }
	      options = Util.defaults({}, options, this.config(), Cloudinary.DEFAULT_IMAGE_PARAMS);
	      if (options.type === 'fetch') {
	        options.fetch_format = options.fetch_format || options.format;
	        publicId = absolutize(publicId);
	      }
	      transformation = new Transformation(options);
	      transformationString = transformation.serialize();
	      if (!options.cloud_name) {
	        throw 'Unknown cloud_name';
	      }
	      if (publicId.search('/') >= 0 && !publicId.match(/^v[0-9]+/) && !publicId.match(/^https?:\//) && !((ref = options.version) != null ? ref.toString() : void 0)) {
	        options.version = 1;
	      }
	      if (publicId.match(/^https?:/)) {
	        if (options.type === 'upload' || options.type === 'asset') {
	          url = publicId;
	        } else {
	          publicId = encodeURIComponent(publicId).replace(/%3A/g, ':').replace(/%2F/g, '/');
	        }
	      } else {
	        try {
	          publicId = decodeURIComponent(publicId);
	        } catch (error1) {
	          error = error1;
	        }
	        publicId = encodeURIComponent(publicId).replace(/%3A/g, ':').replace(/%2F/g, '/');
	        if (options.url_suffix) {
	          if (options.url_suffix.match(/[\.\/]/)) {
	            throw 'url_suffix should not include . or /';
	          }
	          publicId = publicId + '/' + options.url_suffix;
	        }
	        if (options.format) {
	          if (!options.trust_public_id) {
	            publicId = publicId.replace(/\.(jpg|png|gif|webp)$/, '');
	          }
	          publicId = publicId + '.' + options.format;
	        }
	      }
	      prefix = cloudinaryUrlPrefix(publicId, options);
	      resourceTypeAndType = finalizeResourceType(options.resource_type, options.type, options.url_suffix, options.use_root_path, options.shorten);
	      version = options.version ? 'v' + options.version : '';
	      return url || Util.compact([prefix, resourceTypeAndType, transformationString, version, publicId]).join('/').replace(/([^:])\/+/g, '$1/');
	    };
	
	
	    /**
	     * Generate an video resource URL.
	     * @function Cloudinary#video_url
	     * @param {string} publicId - the public ID of the resource
	     * @param {Object} [options] - options for the tag and transformations, possible values include all {@link Transformation} parameters
	     *                          and {@link Configuration} parameters
	     * @param {string} [options.type='upload'] - the classification of the resource
	     * @return {string} The video URL
	     */
	
	    Cloudinary.prototype.video_url = function(publicId, options) {
	      options = Util.assign({
	        resource_type: 'video'
	      }, options);
	      return this.url(publicId, options);
	    };
	
	
	    /**
	     * Generate an video thumbnail URL.
	     * @function Cloudinary#video_thumbnail_url
	     * @param {string} publicId - the public ID of the resource
	     * @param {Object} [options] - options for the tag and transformations, possible values include all {@link Transformation} parameters
	     *                          and {@link Configuration} parameters
	     * @param {string} [options.type='upload'] - the classification of the resource
	     * @return {string} The video thumbnail URL
	     */
	
	    Cloudinary.prototype.video_thumbnail_url = function(publicId, options) {
	      options = Util.assign({}, DEFAULT_POSTER_OPTIONS, options);
	      return this.url(publicId, options);
	    };
	
	
	    /**
	     * Generate a string representation of the provided transformation options.
	     * @function Cloudinary#transformation_string
	     * @param {Object} options - the transformation options
	     * @returns {string} The transformation string
	     */
	
	    Cloudinary.prototype.transformation_string = function(options) {
	      return new Transformation(options).serialize();
	    };
	
	
	    /**
	     * Generate an image tag.
	     * @function Cloudinary#image
	     * @param {string} publicId - the public ID of the image
	     * @param {Object} [options] - options for the tag and transformations
	     * @return {HTMLImageElement} an image tag element
	     */
	
	    Cloudinary.prototype.image = function(publicId, options) {
	      var client_hints, img, ref, ref1;
	      if (options == null) {
	        options = {};
	      }
	      img = this.imageTag(publicId, options);
	      client_hints = (ref = (ref1 = options.client_hints) != null ? ref1 : this.config('client_hints')) != null ? ref : false;
	      if (!((options.src != null) || client_hints)) {
	        img.setAttr("src", '');
	      }
	      img = img.toDOM();
	      if (!client_hints) {
	        Util.setData(img, 'src-cache', this.url(publicId, options));
	        this.cloudinary_update(img, options);
	      }
	      return img;
	    };
	
	
	    /**
	     * Creates a new ImageTag instance, configured using this own's configuration.
	     * @function Cloudinary#imageTag
	     * @param {string} publicId - the public ID of the resource
	     * @param {Object} options - additional options to pass to the new ImageTag instance
	     * @return {ImageTag} An ImageTag that is attached (chained) to this Cloudinary instance
	     */
	
	    Cloudinary.prototype.imageTag = function(publicId, options) {
	      var tag;
	      tag = new ImageTag(publicId, this.config());
	      tag.transformation().fromOptions(options);
	      return tag;
	    };
	
	
	    /**
	     * Generate an image tag for the video thumbnail.
	     * @function Cloudinary#video_thumbnail
	     * @param {string} publicId - the public ID of the video
	     * @param {Object} [options] - options for the tag and transformations
	     * @return {HTMLImageElement} An image tag element
	     */
	
	    Cloudinary.prototype.video_thumbnail = function(publicId, options) {
	      return this.image(publicId, Util.merge({}, DEFAULT_POSTER_OPTIONS, options));
	    };
	
	
	    /**
	     * @function Cloudinary#facebook_profile_image
	     * @param {string} publicId - the public ID of the image
	     * @param {Object} [options] - options for the tag and transformations
	     * @return {HTMLImageElement} an image tag element
	     */
	
	    Cloudinary.prototype.facebook_profile_image = function(publicId, options) {
	      return this.image(publicId, Util.assign({
	        type: 'facebook'
	      }, options));
	    };
	
	
	    /**
	     * @function Cloudinary#twitter_profile_image
	     * @param {string} publicId - the public ID of the image
	     * @param {Object} [options] - options for the tag and transformations
	     * @return {HTMLImageElement} an image tag element
	     */
	
	    Cloudinary.prototype.twitter_profile_image = function(publicId, options) {
	      return this.image(publicId, Util.assign({
	        type: 'twitter'
	      }, options));
	    };
	
	
	    /**
	     * @function Cloudinary#twitter_name_profile_image
	     * @param {string} publicId - the public ID of the image
	     * @param {Object} [options] - options for the tag and transformations
	     * @return {HTMLImageElement} an image tag element
	     */
	
	    Cloudinary.prototype.twitter_name_profile_image = function(publicId, options) {
	      return this.image(publicId, Util.assign({
	        type: 'twitter_name'
	      }, options));
	    };
	
	
	    /**
	     * @function Cloudinary#gravatar_image
	     * @param {string} publicId - the public ID of the image
	     * @param {Object} [options] - options for the tag and transformations
	     * @return {HTMLImageElement} an image tag element
	     */
	
	    Cloudinary.prototype.gravatar_image = function(publicId, options) {
	      return this.image(publicId, Util.assign({
	        type: 'gravatar'
	      }, options));
	    };
	
	
	    /**
	     * @function Cloudinary#fetch_image
	     * @param {string} publicId - the public ID of the image
	     * @param {Object} [options] - options for the tag and transformations
	     * @return {HTMLImageElement} an image tag element
	     */
	
	    Cloudinary.prototype.fetch_image = function(publicId, options) {
	      return this.image(publicId, Util.assign({
	        type: 'fetch'
	      }, options));
	    };
	
	
	    /**
	     * @function Cloudinary#video
	     * @param {string} publicId - the public ID of the image
	     * @param {Object} [options] - options for the tag and transformations
	     * @return {HTMLImageElement} an image tag element
	     */
	
	    Cloudinary.prototype.video = function(publicId, options) {
	      if (options == null) {
	        options = {};
	      }
	      return this.videoTag(publicId, options).toHtml();
	    };
	
	
	    /**
	     * Creates a new VideoTag instance, configured using this own's configuration.
	     * @function Cloudinary#videoTag
	     * @param {string} publicId - the public ID of the resource
	     * @param {Object} options - additional options to pass to the new VideoTag instance
	     * @return {VideoTag} A VideoTag that is attached (chained) to this Cloudinary instance
	     */
	
	    Cloudinary.prototype.videoTag = function(publicId, options) {
	      options = Util.defaults({}, options, this.config());
	      return new VideoTag(publicId, options);
	    };
	
	
	    /**
	     * Generate the URL of the sprite image
	     * @function Cloudinary#sprite_css
	     * @param {string} publicId - the public ID of the resource
	     * @param {Object} [options] - options for the tag and transformations
	     * @see {@link http://cloudinary.com/documentation/sprite_generation Sprite generation}
	     */
	
	    Cloudinary.prototype.sprite_css = function(publicId, options) {
	      options = Util.assign({
	        type: 'sprite'
	      }, options);
	      if (!publicId.match(/.css$/)) {
	        options.format = 'css';
	      }
	      return this.url(publicId, options);
	    };
	
	
	    /**
	    * Initialize the responsive behaviour.<br>
	    * Calls {@link Cloudinary#cloudinary_update} to modify image tags.
	     * @function Cloudinary#responsive
	    * @param {Object} options
	    * @param {String} [options.responsive_class='cld-responsive'] - provide an alternative class used to locate img tags
	    * @param {number} [options.responsive_debounce=100] - the debounce interval in milliseconds.
	    * @param {boolean} [bootstrap=true] if true processes the img tags by calling cloudinary_update. When false the tags will be processed only after a resize event.
	    * @see {@link Cloudinary#cloudinary_update} for additional configuration parameters
	     */
	
	    Cloudinary.prototype.responsive = function(options, bootstrap) {
	      var ref, ref1, ref2, responsiveClass, responsiveResize, timeout;
	      if (bootstrap == null) {
	        bootstrap = true;
	      }
	      this.responsiveConfig = Util.merge(this.responsiveConfig || {}, options);
	      responsiveClass = (ref = this.responsiveConfig['responsive_class']) != null ? ref : this.config('responsive_class');
	      if (bootstrap) {
	        this.cloudinary_update("img." + responsiveClass + ", img.cld-hidpi", this.responsiveConfig);
	      }
	      responsiveResize = (ref1 = (ref2 = this.responsiveConfig['responsive_resize']) != null ? ref2 : this.config('responsive_resize')) != null ? ref1 : true;
	      if (responsiveResize && !this.responsiveResizeInitialized) {
	        this.responsiveConfig.resizing = this.responsiveResizeInitialized = true;
	        timeout = null;
	        return window.addEventListener('resize', (function(_this) {
	          return function() {
	            var debounce, ref3, ref4, reset, run, wait, waitFunc;
	            debounce = (ref3 = (ref4 = _this.responsiveConfig['responsive_debounce']) != null ? ref4 : _this.config('responsive_debounce')) != null ? ref3 : 100;
	            reset = function() {
	              if (timeout) {
	                clearTimeout(timeout);
	                return timeout = null;
	              }
	            };
	            run = function() {
	              return _this.cloudinary_update("img." + responsiveClass, _this.responsiveConfig);
	            };
	            waitFunc = function() {
	              reset();
	              return run();
	            };
	            wait = function() {
	              reset();
	              return timeout = setTimeout(waitFunc, debounce);
	            };
	            if (debounce) {
	              return wait();
	            } else {
	              return run();
	            }
	          };
	        })(this));
	      }
	    };
	
	
	    /**
	     * @function Cloudinary#calc_breakpoint
	     * @private
	     * @ignore
	     */
	
	    Cloudinary.prototype.calc_breakpoint = function(element, width, steps) {
	      var breakpoints, point;
	      breakpoints = Util.getData(element, 'breakpoints') || Util.getData(element, 'stoppoints') || this.config('breakpoints') || this.config('stoppoints') || defaultBreakpoints;
	      if (Util.isFunction(breakpoints)) {
	        return breakpoints(width, steps);
	      } else {
	        if (Util.isString(breakpoints)) {
	          breakpoints = ((function() {
	            var j, len, ref, results;
	            ref = breakpoints.split(',');
	            results = [];
	            for (j = 0, len = ref.length; j < len; j++) {
	              point = ref[j];
	              results.push(parseInt(point));
	            }
	            return results;
	          })()).sort(function(a, b) {
	            return a - b;
	          });
	        }
	        return closestAbove(breakpoints, width);
	      }
	    };
	
	
	    /**
	     * @function Cloudinary#calc_stoppoint
	     * @deprecated Use {@link calc_breakpoint} instead.
	     * @private
	     * @ignore
	     */
	
	    Cloudinary.prototype.calc_stoppoint = Cloudinary.prototype.calc_breakpoint;
	
	
	    /**
	     * @function Cloudinary#device_pixel_ratio
	     * @private
	     */
	
	    Cloudinary.prototype.device_pixel_ratio = function(roundDpr) {
	      var dpr, dprString;
	      if (roundDpr == null) {
	        roundDpr = true;
	      }
	      dpr = (typeof window !== "undefined" && window !== null ? window.devicePixelRatio : void 0) || 1;
	      if (roundDpr) {
	        dpr = Math.ceil(dpr);
	      }
	      if (dpr <= 0 || dpr === NaN) {
	        dpr = 1;
	      }
	      dprString = dpr.toString();
	      if (dprString.match(/^\d+$/)) {
	        dprString += '.0';
	      }
	      return dprString;
	    };
	
	    defaultBreakpoints = function(width, steps) {
	      if (steps == null) {
	        steps = 100;
	      }
	      return steps * Math.ceil(width / steps);
	    };
	
	    closestAbove = function(list, value) {
	      var i;
	      i = list.length - 2;
	      while (i >= 0 && list[i] >= value) {
	        i--;
	      }
	      return list[i + 1];
	    };
	
	    cdnSubdomainNumber = function(publicId) {
	      return crc32(publicId) % 5 + 1;
	    };
	
	    cloudinaryUrlPrefix = function(publicId, options) {
	      var cdnPart, host, path, protocol, ref, subdomain;
	      if (((ref = options.cloud_name) != null ? ref.indexOf("/") : void 0) === 0) {
	        return '/res' + options.cloud_name;
	      }
	      protocol = "http://";
	      cdnPart = "";
	      subdomain = "res";
	      host = ".cloudinary.com";
	      path = "/" + options.cloud_name;
	      if (options.protocol) {
	        protocol = options.protocol + '//';
	      }
	      if (options.private_cdn) {
	        cdnPart = options.cloud_name + "-";
	        path = "";
	      }
	      if (options.cdn_subdomain) {
	        subdomain = "res-" + cdnSubdomainNumber(publicId);
	      }
	      if (options.secure) {
	        protocol = "https://";
	        if (options.secure_cdn_subdomain === false) {
	          subdomain = "res";
	        }
	        if ((options.secure_distribution != null) && options.secure_distribution !== OLD_AKAMAI_SHARED_CDN && options.secure_distribution !== SHARED_CDN) {
	          cdnPart = "";
	          subdomain = "";
	          host = options.secure_distribution;
	        }
	      } else if (options.cname) {
	        protocol = "http://";
	        cdnPart = "";
	        subdomain = options.cdn_subdomain ? 'a' + ((crc32(publicId) % 5) + 1) + '.' : '';
	        host = options.cname;
	      }
	      return [protocol, cdnPart, subdomain, host, path].join("");
	    };
	
	
	    /**
	    * Finds all `img` tags under each node and sets it up to provide the image through Cloudinary
	    * @param {Element[]} nodes the parent nodes to search for img under
	    * @param {Object} [options={}] options and transformations params
	    * @function Cloudinary#processImageTags
	     */
	
	    Cloudinary.prototype.processImageTags = function(nodes, options) {
	      var images, imgOptions, node, publicId, url;
	      if (options == null) {
	        options = {};
	      }
	      if (Util.isEmpty(nodes)) {
	        return this;
	      }
	      options = Util.defaults({}, options, this.config());
	      images = (function() {
	        var j, len, ref, results;
	        results = [];
	        for (j = 0, len = nodes.length; j < len; j++) {
	          node = nodes[j];
	          if (!(((ref = node.tagName) != null ? ref.toUpperCase() : void 0) === 'IMG')) {
	            continue;
	          }
	          imgOptions = Util.assign({
	            width: node.getAttribute('width'),
	            height: node.getAttribute('height'),
	            src: node.getAttribute('src')
	          }, options);
	          publicId = imgOptions['source'] || imgOptions['src'];
	          delete imgOptions['source'];
	          delete imgOptions['src'];
	          url = this.url(publicId, imgOptions);
	          imgOptions = new Transformation(imgOptions).toHtmlAttributes();
	          Util.setData(node, 'src-cache', url);
	          node.setAttribute('width', imgOptions.width);
	          node.setAttribute('height', imgOptions.height);
	          results.push(node);
	        }
	        return results;
	      }).call(this);
	      this.cloudinary_update(images, options);
	      return this;
	    };
	
	    applyBreakpoints = function(tag, width, steps, options) {
	      var ref, ref1, ref2, responsive_use_breakpoints;
	      responsive_use_breakpoints = (ref = (ref1 = (ref2 = options['responsive_use_breakpoints']) != null ? ref2 : options['responsive_use_stoppoints']) != null ? ref1 : this.config('responsive_use_breakpoints')) != null ? ref : this.config('responsive_use_stoppoints');
	      if ((!responsive_use_breakpoints) || (responsive_use_breakpoints === 'resize' && !options.resizing)) {
	        return width;
	      } else {
	        return this.calc_breakpoint(tag, width, steps);
	      }
	    };
	
	    findContainerWidth = function(element) {
	      var containerWidth, style;
	      containerWidth = 0;
	      while (((element = element != null ? element.parentNode : void 0) instanceof Element) && !containerWidth) {
	        style = window.getComputedStyle(element);
	        if (!/^inline/.test(style.display)) {
	          containerWidth = Util.width(element);
	        }
	      }
	      return containerWidth;
	    };
	
	    updateDpr = function(dataSrc, roundDpr) {
	      return dataSrc.replace(/\bdpr_(1\.0|auto)\b/g, 'dpr_' + this.device_pixel_ratio(roundDpr));
	    };
	
	    maxWidth = function(requiredWidth, tag) {
	      var imageWidth;
	      imageWidth = Util.getData(tag, 'width') || 0;
	      if (requiredWidth > imageWidth) {
	        imageWidth = requiredWidth;
	        Util.setData(tag, 'width', requiredWidth);
	      }
	      return imageWidth;
	    };
	
	
	    /**
	    * Update hidpi (dpr_auto) and responsive (w_auto) fields according to the current container size and the device pixel ratio.
	    * Only images marked with the cld-responsive class have w_auto updated.
	    * @function Cloudinary#cloudinary_update
	    * @param {(Array|string|NodeList)} elements - the elements to modify
	    * @param {Object} options
	    * @param {boolean|string} [options.responsive_use_breakpoints=true]
	    *  - when `true`, always use breakpoints for width
	    * - when `"resize"` use exact width on first render and breakpoints on resize
	    * - when `false` always use exact width
	    * @param {boolean} [options.responsive] - if `true`, enable responsive on this element. Can be done by adding cld-responsive.
	    * @param {boolean} [options.responsive_preserve_height] - if set to true, original css height is preserved.
	    *   Should only be used if the transformation supports different aspect ratios.
	     */
	
	    Cloudinary.prototype.cloudinary_update = function(elements, options) {
	      var containerWidth, dataSrc, j, len, match, ref, ref1, ref2, ref3, ref4, ref5, requiredWidth, responsive, responsiveClass, roundDpr, setUrl, tag;
	      if (options == null) {
	        options = {};
	      }
	      if (elements === null) {
	        return this;
	      }
	      responsive = (ref = (ref1 = options.responsive) != null ? ref1 : this.config('responsive')) != null ? ref : false;
	      elements = (function() {
	        switch (false) {
	          case !Util.isArray(elements):
	            return elements;
	          case elements.constructor.name !== "NodeList":
	            return elements;
	          case !Util.isString(elements):
	            return document.querySelectorAll(elements);
	          default:
	            return [elements];
	        }
	      })();
	      responsiveClass = (ref2 = (ref3 = this.responsiveConfig['responsive_class']) != null ? ref3 : options['responsive_class']) != null ? ref2 : this.config('responsive_class');
	      roundDpr = (ref4 = options['round_dpr']) != null ? ref4 : this.config('round_dpr');
	      for (j = 0, len = elements.length; j < len; j++) {
	        tag = elements[j];
	        if (!((ref5 = tag.tagName) != null ? ref5.match(/img/i) : void 0)) {
	          continue;
	        }
	        setUrl = true;
	        if (responsive) {
	          Util.addClass(tag, responsiveClass);
	        }
	        dataSrc = Util.getData(tag, 'src-cache') || Util.getData(tag, 'src');
	        if (!Util.isEmpty(dataSrc)) {
	          dataSrc = updateDpr.call(this, dataSrc, roundDpr);
	          if (HtmlTag.isResponsive(tag, responsiveClass)) {
	            containerWidth = findContainerWidth(tag);
	            if (containerWidth !== 0) {
	              switch (false) {
	                case !/w_auto:breakpoints/.test(dataSrc):
	                  requiredWidth = maxWidth(containerWidth, tag);
	                  dataSrc = dataSrc.replace(/w_auto:breakpoints([_0-9]*)(:[0-9]+)?/, "w_auto:breakpoints$1:" + requiredWidth);
	                  break;
	                case !(match = /w_auto(:(\d+))?/.exec(dataSrc)):
	                  requiredWidth = applyBreakpoints.call(this, tag, containerWidth, match[2], options);
	                  requiredWidth = maxWidth(requiredWidth, tag);
	                  dataSrc = dataSrc.replace(/w_auto[^,\/]*/g, "w_" + requiredWidth);
	              }
	              Util.removeAttribute(tag, 'width');
	              if (!options.responsive_preserve_height) {
	                Util.removeAttribute(tag, 'height');
	              }
	            } else {
	              setUrl = false;
	            }
	          }
	          if (setUrl) {
	            Util.setAttribute(tag, 'src', dataSrc);
	          }
	        }
	      }
	      return this;
	    };
	
	
	    /**
	     * Provide a transformation object, initialized with own's options, for chaining purposes.
	     * @function Cloudinary#transformation
	     * @param {Object} options
	     * @return {Transformation}
	     */
	
	    Cloudinary.prototype.transformation = function(options) {
	      return Transformation["new"](this.config()).fromOptions(options).setParent(this);
	    };
	
	    return Cloudinary;
	
	  })();
	  cloudinary = {
	    utf8_encode: utf8_encode,
	    crc32: crc32,
	    Util: Util,
	    Condition: Condition,
	    Transformation: Transformation,
	    Configuration: Configuration,
	    HtmlTag: HtmlTag,
	    ImageTag: ImageTag,
	    VideoTag: VideoTag,
	    ClientHintsMetaTag: ClientHintsMetaTag,
	    Layer: Layer,
	    FetchLayer: FetchLayer,
	    TextLayer: TextLayer,
	    SubtitlesLayer: SubtitlesLayer,
	    Cloudinary: Cloudinary,
	    VERSION: "2.5.0"
	  };
	  return cloudinary;
	});
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(109).Buffer, __webpack_require__(100)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(10);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _cloudinaryCore = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var camelCase = _cloudinaryCore.Util.camelCase;
	var snakeCase = _cloudinaryCore.Util.snakeCase;
	
	/**
	 * A base component for Cloudinary components.
	 * @protected
	 */
	
	var CloudinaryComponent = function (_Component) {
	  _inherits(CloudinaryComponent, _Component);
	
	  function CloudinaryComponent(props, context) {
	    _classCallCheck(this, CloudinaryComponent);
	
	    return _possibleConstructorReturn(this, (CloudinaryComponent.__proto__ || Object.getPrototypeOf(CloudinaryComponent)).call(this, props, context));
	  }
	
	  _createClass(CloudinaryComponent, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {};
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }, {
	    key: 'getChildTransformations',
	    value: function getChildTransformations(children) {
	      var _this2 = this;
	
	      if (children === undefined || children === null) return null;
	      var mapped = _react2.default.Children.map(children, function (child) {
	        if (!_react2.default.isValidElement(child)) {
	          // child is not an element (e.g. simple text)
	          return;
	        }
	        var options = {};
	        if (child.type && child.type.exposesProps) {
	          options = CloudinaryComponent.normalizeOptions(child.props, child.context);
	        }
	        var childOptions = _this2.getChildTransformations(child.props.children);
	        if (childOptions !== undefined && childOptions !== null) {
	          options.transformation = childOptions;
	        }
	        return options;
	      });
	      if (mapped != null) {
	        return mapped.filter(function (o) {
	          return !_cloudinaryCore.Util.isEmpty(o);
	        });
	      } else return null;
	    }
	
	    /**
	     * Returns an object with all the transformation parameters based on the context and properties of this element
	     * and any children.
	     * @param options
	     * @returns {object} a hash of transformation and configuration parameters
	     * @protected
	     */
	
	  }, {
	    key: 'getTransformation',
	    value: function getTransformation(options) {
	      var transformation;
	      if (this.props.children !== undefined) {
	        var childrenOptions = this.getChildTransformations(this.props.children);
	        if (!_cloudinaryCore.Util.isEmpty(childrenOptions)) {
	          transformation = childrenOptions;
	          return _extends({}, options, { transformation: transformation });
	        }
	      }
	      return _extends({}, options);
	    }
	
	    /**
	     * Combine properties of all options to create an option Object that can be passed to Cloudinary methods.<br>
	     *   `undefined` and `null` values are filtered out.
	     * @protected
	     * @returns {Object}
	     * @param options one or more options objects
	     */
	
	  }, {
	    key: 'getUrl',
	
	
	    /**
	     * Generate a Cloudinary resource URL based on the options provided and child Transformation elements
	     * @param options
	     * @returns {string} a cloudinary URL
	     * @protected
	     */
	    value: function getUrl(options) {
	      var transformation = this.getTransformation(options);
	      var cl = _cloudinaryCore.Cloudinary.new(_cloudinaryCore.Util.withSnakeCaseKeys(options));
	      return cl.url(options.publicId, transformation);
	    }
	  }], [{
	    key: 'normalizeOptions',
	    value: function normalizeOptions() {
	      for (var _len = arguments.length, options = Array(_len), _key = 0; _key < _len; _key++) {
	        options[_key] = arguments[_key];
	      }
	
	      return options.reduce(function (left, right) {
	        for (var key in right) {
	          var value = right[key];
	          if (value !== null && value !== undefined) {
	            left[key] = value;
	          }
	        }
	        return left;
	      }, {});
	    }
	  }]);
	
	  return CloudinaryComponent;
	}(_react.Component);
	
	CloudinaryComponent.VALID_OPTIONS = _cloudinaryCore.Transformation.PARAM_NAMES.map(camelCase);
	CloudinaryComponent.contextTypes = typesFrom(CloudinaryComponent.VALID_OPTIONS);
	
	CloudinaryComponent.propTypes = CloudinaryComponent.contextTypes;
	CloudinaryComponent.propTypes.publicId = _propTypes2.default.string;
	CloudinaryComponent.propTypes.responsive = _propTypes2.default.bool;
	
	CloudinaryComponent.childContextTypes = {};
	
	/**
	 * Create a React type definition object. All items are PropTypes.string or [string] or object or [object].
	 * @param {Array} configParams a list of parameter names
	 * @returns {Object}
	 * @private
	 */
	function typesFrom(configParams) {
	  configParams = configParams || [];
	  var types = {};
	  for (var i = 0; i < configParams.length; i++) {
	    var key = configParams[i];
	    types[camelCase(key)] = _propTypes2.default.any;
	  }
	  return types;
	}
	
	exports.default = CloudinaryComponent;

/***/ }),
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(144),
	    baseIsNaN = __webpack_require__(150),
	    strictIndexOf = __webpack_require__(189);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ }),
/* 23 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(128),
	    Map = __webpack_require__(82),
	    Promise = __webpack_require__(129),
	    Set = __webpack_require__(130),
	    WeakMap = __webpack_require__(133),
	    baseGetTag = __webpack_require__(16),
	    toSource = __webpack_require__(238);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(148),
	    isObjectLike = __webpack_require__(6);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(8),
	    stubFalse = __webpack_require__(204);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(34)(module)))

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(58),
	    baseKeysIn = __webpack_require__(153),
	    isArrayLike = __webpack_require__(11);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(37),
	    eq = __webpack_require__(48);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(67);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(132);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(71);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(57),
	    stubArray = __webpack_require__(76);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(235);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(34)(module)))

/***/ }),
/* 42 */
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(16),
	    getPrototype = __webpack_require__(39),
	    isObjectLike = __webpack_require__(6);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(152),
	    baseUnary = __webpack_require__(23),
	    nodeUtil = __webpack_require__(41);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(47),
	    stackClear = __webpack_require__(184),
	    stackDelete = __webpack_require__(185),
	    stackGet = __webpack_require__(186),
	    stackHas = __webpack_require__(187),
	    stackSet = __webpack_require__(188);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ }),
/* 57 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(158),
	    isArguments = __webpack_require__(25),
	    isArray = __webpack_require__(7),
	    isBuffer = __webpack_require__(26),
	    isIndex = __webpack_require__(70),
	    isTypedArray = __webpack_require__(44);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(37),
	    eq = __webpack_require__(48);
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignMergeValue;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(35),
	    isArray = __webpack_require__(7);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(18),
	    nativeKeys = __webpack_require__(177);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(42),
	    overRest = __webpack_require__(179),
	    setToString = __webpack_require__(182);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(8);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(34)(module)))

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(38);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ }),
/* 65 */
/***/ (function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(62),
	    isIterateeCall = __webpack_require__(176);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(17);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(35),
	    getPrototype = __webpack_require__(39),
	    getSymbols = __webpack_require__(40),
	    stubArray = __webpack_require__(76);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(142),
	    getPrototype = __webpack_require__(39),
	    isPrototype = __webpack_require__(18);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ }),
/* 70 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),
/* 71 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 72 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key`, unless `key` is "__proto__".
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function safeGet(object, key) {
	  return key == '__proto__'
	    ? undefined
	    : object[key];
	}
	
	module.exports = safeGet;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(11),
	    isObjectLike = __webpack_require__(6);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ }),
/* 74 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(16),
	    isArray = __webpack_require__(7),
	    isObjectLike = __webpack_require__(6);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ }),
/* 76 */
/***/ (function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ }),
/* 77 */,
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.BrowserSpriteSymbol = factory());
	}(this, (function () { 'use strict';
	
	var SpriteSymbol = function SpriteSymbol(ref) {
	  var id = ref.id;
	  var viewBox = ref.viewBox;
	  var content = ref.content;
	
	  this.id = id;
	  this.viewBox = viewBox;
	  this.content = content;
	};
	
	/**
	 * @return {string}
	 */
	SpriteSymbol.prototype.stringify = function stringify () {
	  return this.content;
	};
	
	/**
	 * @return {string}
	 */
	SpriteSymbol.prototype.toString = function toString () {
	  return this.stringify();
	};
	
	SpriteSymbol.prototype.destroy = function destroy () {
	    var this$1 = this;
	
	  ['id', 'viewBox', 'content'].forEach(function (prop) { return delete this$1[prop]; });
	};
	
	/**
	 * @param {string} content
	 * @return {Element}
	 */
	var parse = function (content) {
	  var hasImportNode = !!document.importNode;
	  var doc = new DOMParser().parseFromString(content, 'image/svg+xml').documentElement;
	
	  /**
	   * Fix for browser which are throwing WrongDocumentError
	   * if you insert an element which is not part of the document
	   * @see http://stackoverflow.com/a/7986519/4624403
	   */
	  if (hasImportNode) {
	    return document.importNode(doc, true);
	  }
	
	  return doc;
	};
	
	var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
	
	
	
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	var deepmerge = createCommonjsModule(function (module, exports) {
	(function (root, factory) {
	    if (false) {
	        undefined(factory);
	    } else {
	        module.exports = factory();
	    }
	}(commonjsGlobal, function () {
	
	function isMergeableObject(val) {
	    var nonNullObject = val && typeof val === 'object';
	
	    return nonNullObject
	        && Object.prototype.toString.call(val) !== '[object RegExp]'
	        && Object.prototype.toString.call(val) !== '[object Date]'
	}
	
	function emptyTarget(val) {
	    return Array.isArray(val) ? [] : {}
	}
	
	function cloneIfNecessary(value, optionsArgument) {
	    var clone = optionsArgument && optionsArgument.clone === true;
	    return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value
	}
	
	function defaultArrayMerge(target, source, optionsArgument) {
	    var destination = target.slice();
	    source.forEach(function(e, i) {
	        if (typeof destination[i] === 'undefined') {
	            destination[i] = cloneIfNecessary(e, optionsArgument);
	        } else if (isMergeableObject(e)) {
	            destination[i] = deepmerge(target[i], e, optionsArgument);
	        } else if (target.indexOf(e) === -1) {
	            destination.push(cloneIfNecessary(e, optionsArgument));
	        }
	    });
	    return destination
	}
	
	function mergeObject(target, source, optionsArgument) {
	    var destination = {};
	    if (isMergeableObject(target)) {
	        Object.keys(target).forEach(function (key) {
	            destination[key] = cloneIfNecessary(target[key], optionsArgument);
	        });
	    }
	    Object.keys(source).forEach(function (key) {
	        if (!isMergeableObject(source[key]) || !target[key]) {
	            destination[key] = cloneIfNecessary(source[key], optionsArgument);
	        } else {
	            destination[key] = deepmerge(target[key], source[key], optionsArgument);
	        }
	    });
	    return destination
	}
	
	function deepmerge(target, source, optionsArgument) {
	    var array = Array.isArray(source);
	    var options = optionsArgument || { arrayMerge: defaultArrayMerge };
	    var arrayMerge = options.arrayMerge || defaultArrayMerge;
	
	    if (array) {
	        return Array.isArray(target) ? arrayMerge(target, source, optionsArgument) : cloneIfNecessary(source, optionsArgument)
	    } else {
	        return mergeObject(target, source, optionsArgument)
	    }
	}
	
	deepmerge.all = function deepmergeAll(array, optionsArgument) {
	    if (!Array.isArray(array) || array.length < 2) {
	        throw new Error('first argument should be an array with at least two elements')
	    }
	
	    // we are sure there are at least 2 values, so it is safe to have no initial value
	    return array.reduce(function(prev, next) {
	        return deepmerge(prev, next, optionsArgument)
	    })
	};
	
	return deepmerge
	
	}));
	});
	
	var namespaces_1 = createCommonjsModule(function (module, exports) {
	var namespaces = {
	  svg: {
	    name: 'xmlns',
	    uri: 'http://www.w3.org/2000/svg'
	  },
	  xlink: {
	    name: 'xmlns:xlink',
	    uri: 'http://www.w3.org/1999/xlink'
	  }
	};
	
	exports.default = namespaces;
	module.exports = exports.default;
	});
	
	/**
	 * @param {Object} attrs
	 * @return {string}
	 */
	var objectToAttrsString = function (attrs) {
	  return Object.keys(attrs).map(function (attr) {
	    var value = attrs[attr].toString().replace(/"/g, '&quot;');
	    return (attr + "=\"" + value + "\"");
	  }).join(' ');
	};
	
	var svg = namespaces_1.svg;
	var xlink = namespaces_1.xlink;
	
	var defaultAttrs = {};
	defaultAttrs[svg.name] = svg.uri;
	defaultAttrs[xlink.name] = xlink.uri;
	
	/**
	 * @param {string} [content]
	 * @param {Object} [attributes]
	 * @return {string}
	 */
	var wrapInSvgString = function (content, attributes) {
	  if ( content === void 0 ) content = '';
	
	  var attrs = deepmerge(defaultAttrs, attributes || {});
	  var attrsRendered = objectToAttrsString(attrs);
	  return ("<svg " + attrsRendered + ">" + content + "</svg>");
	};
	
	var BrowserSpriteSymbol = (function (SpriteSymbol$$1) {
	  function BrowserSpriteSymbol () {
	    SpriteSymbol$$1.apply(this, arguments);
	  }
	
	  if ( SpriteSymbol$$1 ) BrowserSpriteSymbol.__proto__ = SpriteSymbol$$1;
	  BrowserSpriteSymbol.prototype = Object.create( SpriteSymbol$$1 && SpriteSymbol$$1.prototype );
	  BrowserSpriteSymbol.prototype.constructor = BrowserSpriteSymbol;
	
	  var prototypeAccessors = { isMounted: {} };
	
	  prototypeAccessors.isMounted.get = function () {
	    return !!this.node;
	  };
	
	  /**
	   * @param {Element} node
	   * @return {BrowserSpriteSymbol}
	   */
	  BrowserSpriteSymbol.createFromExistingNode = function createFromExistingNode (node) {
	    return new BrowserSpriteSymbol({
	      id: node.getAttribute('id'),
	      viewBox: node.getAttribute('viewBox'),
	      content: node.outerHTML
	    });
	  };
	
	  BrowserSpriteSymbol.prototype.destroy = function destroy () {
	    if (this.isMounted) {
	      this.unmount();
	    }
	    SpriteSymbol$$1.prototype.destroy.call(this);
	  };
	
	  /**
	   * @param {Element|string} target
	   * @return {Element}
	   */
	  BrowserSpriteSymbol.prototype.mount = function mount (target) {
	    if (this.isMounted) {
	      return this.node;
	    }
	
	    var mountTarget = typeof target === 'string' ? document.querySelector(target) : target;
	    var node = this.render();
	    this.node = node;
	
	    mountTarget.appendChild(node);
	
	    return node;
	  };
	
	  /**
	   * @return {Element}
	   */
	  BrowserSpriteSymbol.prototype.render = function render () {
	    var content = this.stringify();
	    return parse(wrapInSvgString(content)).childNodes[0];
	  };
	
	  BrowserSpriteSymbol.prototype.unmount = function unmount () {
	    this.node.parentNode.removeChild(this.node);
	  };
	
	  Object.defineProperties( BrowserSpriteSymbol.prototype, prototypeAccessors );
	
	  return BrowserSpriteSymbol;
	}(SpriteSymbol));
	
	return BrowserSpriteSymbol;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.BrowserSprite = factory());
	}(this, (function () { 'use strict';
	
	var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
	
	
	
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	var deepmerge = createCommonjsModule(function (module, exports) {
	(function (root, factory) {
	    if (false) {
	        undefined(factory);
	    } else {
	        module.exports = factory();
	    }
	}(commonjsGlobal, function () {
	
	function isMergeableObject(val) {
	    var nonNullObject = val && typeof val === 'object';
	
	    return nonNullObject
	        && Object.prototype.toString.call(val) !== '[object RegExp]'
	        && Object.prototype.toString.call(val) !== '[object Date]'
	}
	
	function emptyTarget(val) {
	    return Array.isArray(val) ? [] : {}
	}
	
	function cloneIfNecessary(value, optionsArgument) {
	    var clone = optionsArgument && optionsArgument.clone === true;
	    return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value
	}
	
	function defaultArrayMerge(target, source, optionsArgument) {
	    var destination = target.slice();
	    source.forEach(function(e, i) {
	        if (typeof destination[i] === 'undefined') {
	            destination[i] = cloneIfNecessary(e, optionsArgument);
	        } else if (isMergeableObject(e)) {
	            destination[i] = deepmerge(target[i], e, optionsArgument);
	        } else if (target.indexOf(e) === -1) {
	            destination.push(cloneIfNecessary(e, optionsArgument));
	        }
	    });
	    return destination
	}
	
	function mergeObject(target, source, optionsArgument) {
	    var destination = {};
	    if (isMergeableObject(target)) {
	        Object.keys(target).forEach(function (key) {
	            destination[key] = cloneIfNecessary(target[key], optionsArgument);
	        });
	    }
	    Object.keys(source).forEach(function (key) {
	        if (!isMergeableObject(source[key]) || !target[key]) {
	            destination[key] = cloneIfNecessary(source[key], optionsArgument);
	        } else {
	            destination[key] = deepmerge(target[key], source[key], optionsArgument);
	        }
	    });
	    return destination
	}
	
	function deepmerge(target, source, optionsArgument) {
	    var array = Array.isArray(source);
	    var options = optionsArgument || { arrayMerge: defaultArrayMerge };
	    var arrayMerge = options.arrayMerge || defaultArrayMerge;
	
	    if (array) {
	        return Array.isArray(target) ? arrayMerge(target, source, optionsArgument) : cloneIfNecessary(source, optionsArgument)
	    } else {
	        return mergeObject(target, source, optionsArgument)
	    }
	}
	
	deepmerge.all = function deepmergeAll(array, optionsArgument) {
	    if (!Array.isArray(array) || array.length < 2) {
	        throw new Error('first argument should be an array with at least two elements')
	    }
	
	    // we are sure there are at least 2 values, so it is safe to have no initial value
	    return array.reduce(function(prev, next) {
	        return deepmerge(prev, next, optionsArgument)
	    })
	};
	
	return deepmerge
	
	}));
	});
	
	//      
	// An event handler can take an optional event argument
	// and should not return a value
	                                          
	// An array of all currently registered event handlers for a type
	                                            
	// A map of event types and their corresponding event handlers.
	                        
	                                   
	  
	
	/** Mitt: Tiny (~200b) functional event emitter / pubsub.
	 *  @name mitt
	 *  @returns {Mitt}
	 */
	function mitt(all                 ) {
		all = all || Object.create(null);
	
		return {
			/**
			 * Register an event handler for the given type.
			 *
			 * @param  {String} type	Type of event to listen for, or `"*"` for all events
			 * @param  {Function} handler Function to call in response to given event
			 * @memberOf mitt
			 */
			on: function on(type        , handler              ) {
				(all[type] || (all[type] = [])).push(handler);
			},
	
			/**
			 * Remove an event handler for the given type.
			 *
			 * @param  {String} type	Type of event to unregister `handler` from, or `"*"`
			 * @param  {Function} handler Handler function to remove
			 * @memberOf mitt
			 */
			off: function off(type        , handler              ) {
				if (all[type]) {
					all[type].splice(all[type].indexOf(handler) >>> 0, 1);
				}
			},
	
			/**
			 * Invoke all handlers for the given type.
			 * If present, `"*"` handlers are invoked after type-matched handlers.
			 *
			 * @param {String} type  The event type to invoke
			 * @param {Any} [evt]  Any value (object is recommended and powerful), passed to each handler
			 * @memberof mitt
			 */
			emit: function emit(type        , evt     ) {
				(all[type] || []).map(function (handler) { handler(evt); });
				(all['*'] || []).map(function (handler) { handler(type, evt); });
			}
		};
	}
	
	var namespaces_1 = createCommonjsModule(function (module, exports) {
	var namespaces = {
	  svg: {
	    name: 'xmlns',
	    uri: 'http://www.w3.org/2000/svg'
	  },
	  xlink: {
	    name: 'xmlns:xlink',
	    uri: 'http://www.w3.org/1999/xlink'
	  }
	};
	
	exports.default = namespaces;
	module.exports = exports.default;
	});
	
	/**
	 * @param {Object} attrs
	 * @return {string}
	 */
	var objectToAttrsString = function (attrs) {
	  return Object.keys(attrs).map(function (attr) {
	    var value = attrs[attr].toString().replace(/"/g, '&quot;');
	    return (attr + "=\"" + value + "\"");
	  }).join(' ');
	};
	
	var svg = namespaces_1.svg;
	var xlink = namespaces_1.xlink;
	
	var defaultAttrs = {};
	defaultAttrs[svg.name] = svg.uri;
	defaultAttrs[xlink.name] = xlink.uri;
	
	/**
	 * @param {string} [content]
	 * @param {Object} [attributes]
	 * @return {string}
	 */
	var wrapInSvgString = function (content, attributes) {
	  if ( content === void 0 ) content = '';
	
	  var attrs = deepmerge(defaultAttrs, attributes || {});
	  var attrsRendered = objectToAttrsString(attrs);
	  return ("<svg " + attrsRendered + ">" + content + "</svg>");
	};
	
	var svg$1 = namespaces_1.svg;
	var xlink$1 = namespaces_1.xlink;
	
	var defaultConfig = {
	  attrs: ( obj = {
	    style: ['position: absolute', 'width: 0', 'height: 0'].join('; ')
	  }, obj[svg$1.name] = svg$1.uri, obj[xlink$1.name] = xlink$1.uri, obj )
	};
	var obj;
	
	var Sprite = function Sprite(config) {
	  this.config = deepmerge(defaultConfig, config || {});
	  this.symbols = [];
	};
	
	/**
	 * Add new symbol. If symbol with the same id exists it will be replaced.
	 * @param {SpriteSymbol} symbol
	 * @return {boolean} `true` - symbol was added, `false` - replaced
	 */
	Sprite.prototype.add = function add (symbol) {
	  var ref = this;
	    var symbols = ref.symbols;
	  var existing = this.find(symbol.id);
	
	  if (existing) {
	    symbols[symbols.indexOf(existing)] = symbol;
	    return false;
	  }
	
	  symbols.push(symbol);
	  return true;
	};
	
	/**
	 * Remove symbol & destroy it
	 * @param {string} id
	 * @return {boolean} `true` - symbol was found & successfully destroyed, `false` - otherwise
	 */
	Sprite.prototype.remove = function remove (id) {
	  var ref = this;
	    var symbols = ref.symbols;
	  var symbol = this.find(id);
	
	  if (symbol) {
	    symbols.splice(symbols.indexOf(symbol), 1);
	    symbol.destroy();
	    return true;
	  }
	
	  return false;
	};
	
	/**
	 * @param {string} id
	 * @return {SpriteSymbol|null}
	 */
	Sprite.prototype.find = function find (id) {
	  return this.symbols.filter(function (s) { return s.id === id; })[0] || null;
	};
	
	/**
	 * @param {string} id
	 * @return {boolean}
	 */
	Sprite.prototype.has = function has (id) {
	  return this.find(id) !== null;
	};
	
	/**
	 * @return {string}
	 */
	Sprite.prototype.stringify = function stringify () {
	  var ref = this.config;
	    var attrs = ref.attrs;
	  var stringifiedSymbols = this.symbols.map(function (s) { return s.stringify(); }).join('');
	  return wrapInSvgString(stringifiedSymbols, attrs);
	};
	
	/**
	 * @return {string}
	 */
	Sprite.prototype.toString = function toString () {
	  return this.stringify();
	};
	
	Sprite.prototype.destroy = function destroy () {
	  this.symbols.forEach(function (s) { return s.destroy(); });
	};
	
	var SpriteSymbol = function SpriteSymbol(ref) {
	  var id = ref.id;
	  var viewBox = ref.viewBox;
	  var content = ref.content;
	
	  this.id = id;
	  this.viewBox = viewBox;
	  this.content = content;
	};
	
	/**
	 * @return {string}
	 */
	SpriteSymbol.prototype.stringify = function stringify () {
	  return this.content;
	};
	
	/**
	 * @return {string}
	 */
	SpriteSymbol.prototype.toString = function toString () {
	  return this.stringify();
	};
	
	SpriteSymbol.prototype.destroy = function destroy () {
	    var this$1 = this;
	
	  ['id', 'viewBox', 'content'].forEach(function (prop) { return delete this$1[prop]; });
	};
	
	/**
	 * @param {string} content
	 * @return {Element}
	 */
	var parse = function (content) {
	  var hasImportNode = !!document.importNode;
	  var doc = new DOMParser().parseFromString(content, 'image/svg+xml').documentElement;
	
	  /**
	   * Fix for browser which are throwing WrongDocumentError
	   * if you insert an element which is not part of the document
	   * @see http://stackoverflow.com/a/7986519/4624403
	   */
	  if (hasImportNode) {
	    return document.importNode(doc, true);
	  }
	
	  return doc;
	};
	
	var BrowserSpriteSymbol = (function (SpriteSymbol$$1) {
	  function BrowserSpriteSymbol () {
	    SpriteSymbol$$1.apply(this, arguments);
	  }
	
	  if ( SpriteSymbol$$1 ) BrowserSpriteSymbol.__proto__ = SpriteSymbol$$1;
	  BrowserSpriteSymbol.prototype = Object.create( SpriteSymbol$$1 && SpriteSymbol$$1.prototype );
	  BrowserSpriteSymbol.prototype.constructor = BrowserSpriteSymbol;
	
	  var prototypeAccessors = { isMounted: {} };
	
	  prototypeAccessors.isMounted.get = function () {
	    return !!this.node;
	  };
	
	  /**
	   * @param {Element} node
	   * @return {BrowserSpriteSymbol}
	   */
	  BrowserSpriteSymbol.createFromExistingNode = function createFromExistingNode (node) {
	    return new BrowserSpriteSymbol({
	      id: node.getAttribute('id'),
	      viewBox: node.getAttribute('viewBox'),
	      content: node.outerHTML
	    });
	  };
	
	  BrowserSpriteSymbol.prototype.destroy = function destroy () {
	    if (this.isMounted) {
	      this.unmount();
	    }
	    SpriteSymbol$$1.prototype.destroy.call(this);
	  };
	
	  /**
	   * @param {Element|string} target
	   * @return {Element}
	   */
	  BrowserSpriteSymbol.prototype.mount = function mount (target) {
	    if (this.isMounted) {
	      return this.node;
	    }
	
	    var mountTarget = typeof target === 'string' ? document.querySelector(target) : target;
	    var node = this.render();
	    this.node = node;
	
	    mountTarget.appendChild(node);
	
	    return node;
	  };
	
	  /**
	   * @return {Element}
	   */
	  BrowserSpriteSymbol.prototype.render = function render () {
	    var content = this.stringify();
	    return parse(wrapInSvgString(content)).childNodes[0];
	  };
	
	  BrowserSpriteSymbol.prototype.unmount = function unmount () {
	    this.node.parentNode.removeChild(this.node);
	  };
	
	  Object.defineProperties( BrowserSpriteSymbol.prototype, prototypeAccessors );
	
	  return BrowserSpriteSymbol;
	}(SpriteSymbol));
	
	var defaultConfig$1 = {
	  /**
	   * Should following options be automatically configured:
	   * - `syncUrlsWithBaseTag`
	   * - `locationChangeAngularEmitter`
	   * - `moveGradientsOutsideSymbol`
	   * @type {boolean}
	   */
	  autoConfigure: true,
	
	  /**
	   * Default mounting selector
	   * @type {string}
	   */
	  mountTo: 'body',
	
	  /**
	   * Fix disappearing SVG elements when <base href> exists.
	   * Executes when sprite mounted.
	   * @see http://stackoverflow.com/a/18265336/796152
	   * @see https://github.com/everdimension/angular-svg-base-fix
	   * @see https://github.com/angular/angular.js/issues/8934#issuecomment-56568466
	   * @type {boolean}
	   */
	  syncUrlsWithBaseTag: false,
	
	  /**
	   * Should sprite listen custom location change event
	   * @type {boolean}
	   */
	  listenLocationChangeEvent: true,
	
	  /**
	   * Custom window event name which should be emitted to update sprite urls
	   * @type {string}
	   */
	  locationChangeEvent: 'locationChange',
	
	  /**
	   * Emit location change event in Angular automatically
	   * @type {boolean}
	   */
	  locationChangeAngularEmitter: false,
	
	  /**
	   * Selector to find symbols usages when updating sprite urls
	   * @type {string}
	   */
	  usagesToUpdate: 'use[*|href]',
	
	  /**
	   * Fix Firefox bug when gradients and patterns don't work if they are within a symbol.
	   * Executes when sprite is rendered, but not mounted.
	   * @see https://bugzilla.mozilla.org/show_bug.cgi?id=306674
	   * @see https://bugzilla.mozilla.org/show_bug.cgi?id=353575
	   * @see https://bugzilla.mozilla.org/show_bug.cgi?id=1235364
	   * @type {boolean}
	   */
	  moveGradientsOutsideSymbol: false
	};
	
	/**
	 * @param {*} arrayLike
	 * @return {Array}
	 */
	var arrayFrom = function (arrayLike) {
	  return Array.prototype.slice.call(arrayLike, 0);
	};
	
	var ua = navigator.userAgent;
	
	var browser = {
	  isChrome: /chrome/i.test(ua),
	  isFirefox: /firefox/i.test(ua),
	
	  // https://msdn.microsoft.com/en-us/library/ms537503(v=vs.85).aspx
	  isIE: /msie/i.test(ua) || /trident/i.test(ua),
	  isEdge: /edge/i.test(ua)
	};
	
	/**
	 * @param {string} name
	 * @param {*} data
	 */
	var dispatchEvent = function (name, data) {
	  var event = document.createEvent('CustomEvent');
	  event.initCustomEvent(name, false, false, data);
	  window.dispatchEvent(event);
	};
	
	/**
	 * IE doesn't evaluate <style> tags in SVGs that are dynamically added to the page.
	 * This trick will trigger IE to read and use any existing SVG <style> tags.
	 * @see https://github.com/iconic/SVGInjector/issues/23
	 * @see https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/10898469/
	 *
	 * @param {Element} node DOM Element to search <style> tags in
	 * @return {Array<HTMLStyleElement>}
	 */
	var evalStylesIEWorkaround = function (node) {
	  var updatedNodes = [];
	
	  arrayFrom(node.querySelectorAll('style'))
	    .forEach(function (style) {
	      style.textContent += '';
	      updatedNodes.push(style);
	    });
	
	  return updatedNodes;
	};
	
	/**
	 * @param {string} [url] If not provided - current URL will be used
	 * @return {string}
	 */
	var getUrlWithoutFragment = function (url) {
	  return (url || window.location.href).split('#')[0];
	};
	
	/* global angular */
	/**
	 * @param {string} eventName
	 */
	var locationChangeAngularEmitter = function (eventName) {
	  angular.module('ng').run(['$rootScope', function ($rootScope) {
	    $rootScope.$on('$locationChangeSuccess', function (e, newUrl, oldUrl) {
	      dispatchEvent(eventName, { oldUrl: oldUrl, newUrl: newUrl });
	    });
	  }]);
	};
	
	var defaultSelector = 'linearGradient, radialGradient, pattern';
	
	/**
	 * @param {Element} svg
	 * @param {string} [selector]
	 * @return {Element}
	 */
	var moveGradientsOutsideSymbol = function (svg, selector) {
	  if ( selector === void 0 ) selector = defaultSelector;
	
	  arrayFrom(svg.querySelectorAll('symbol')).forEach(function (symbol) {
	    arrayFrom(symbol.querySelectorAll(selector)).forEach(function (node) {
	      symbol.parentNode.insertBefore(node, symbol);
	    });
	  });
	  return svg;
	};
	
	/**
	 * @param {NodeList} nodes
	 * @param {Function} [matcher]
	 * @return {Attr[]}
	 */
	function selectAttributes(nodes, matcher) {
	  var attrs = arrayFrom(nodes).reduce(function (acc, node) {
	    if (!node.attributes) {
	      return acc;
	    }
	
	    var arrayfied = arrayFrom(node.attributes);
	    var matched = matcher ? arrayfied.filter(matcher) : arrayfied;
	    return acc.concat(matched);
	  }, []);
	
	  return attrs;
	}
	
	/**
	 * @param {NodeList|Node} nodes
	 * @param {boolean} [clone=true]
	 * @return {string}
	 */
	
	var xLinkNS = namespaces_1.xlink.uri;
	var xLinkAttrName = 'xlink:href';
	
	// eslint-disable-next-line no-useless-escape
	var specialUrlCharsPattern = /[{}|\\\^\[\]`"<>]/g;
	
	function encoder(url) {
	  return url.replace(specialUrlCharsPattern, function (match) {
	    return ("%" + (match[0].charCodeAt(0).toString(16).toUpperCase()));
	  });
	}
	
	/**
	 * @param {NodeList} nodes
	 * @param {string} startsWith
	 * @param {string} replaceWith
	 * @return {NodeList}
	 */
	function updateReferences(nodes, startsWith, replaceWith) {
	  arrayFrom(nodes).forEach(function (node) {
	    var href = node.getAttribute(xLinkAttrName);
	    if (href && href.indexOf(startsWith) === 0) {
	      var newUrl = href.replace(startsWith, replaceWith);
	      node.setAttributeNS(xLinkNS, xLinkAttrName, newUrl);
	    }
	  });
	
	  return nodes;
	}
	
	/**
	 * List of SVG attributes to update url() target in them
	 */
	var attList = [
	  'clipPath',
	  'colorProfile',
	  'src',
	  'cursor',
	  'fill',
	  'filter',
	  'marker',
	  'markerStart',
	  'markerMid',
	  'markerEnd',
	  'mask',
	  'stroke',
	  'style'
	];
	
	var attSelector = attList.map(function (attr) { return ("[" + attr + "]"); }).join(',');
	
	/**
	 * Update URLs in svg image (like `fill="url(...)"`) and update referencing elements
	 * @param {Element} svg
	 * @param {NodeList} references
	 * @param {string|RegExp} startsWith
	 * @param {string} replaceWith
	 * @return {void}
	 *
	 * @example
	 * const sprite = document.querySelector('svg.sprite');
	 * const usages = document.querySelectorAll('use');
	 * updateUrls(sprite, usages, '#', 'prefix#');
	 */
	var updateUrls = function (svg, references, startsWith, replaceWith) {
	  var startsWithEncoded = encoder(startsWith);
	  var replaceWithEncoded = encoder(replaceWith);
	
	  var nodes = svg.querySelectorAll(attSelector);
	  var attrs = selectAttributes(nodes, function (ref) {
	    var localName = ref.localName;
	    var value = ref.value;
	
	    return attList.indexOf(localName) !== -1 && value.indexOf(("url(" + startsWithEncoded)) !== -1;
	  });
	
	  attrs.forEach(function (attr) { return attr.value = attr.value.replace(startsWithEncoded, replaceWithEncoded); });
	  updateReferences(references, startsWithEncoded, replaceWithEncoded);
	};
	
	/**
	 * Internal emitter events
	 * @enum
	 * @private
	 */
	var Events = {
	  MOUNT: 'mount',
	  SYMBOL_MOUNT: 'symbol_mount'
	};
	
	var BrowserSprite = (function (Sprite$$1) {
	  function BrowserSprite(cfg) {
	    var this$1 = this;
	    if ( cfg === void 0 ) cfg = {};
	
	    Sprite$$1.call(this, deepmerge(defaultConfig$1, cfg));
	
	    var emitter = mitt();
	    this._emitter = emitter;
	    this.node = null;
	
	    var ref = this;
	    var config = ref.config;
	
	    if (config.autoConfigure) {
	      this._autoConfigure(cfg);
	    }
	
	    if (config.syncUrlsWithBaseTag) {
	      var baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
	      emitter.on(Events.MOUNT, function () { return this$1.updateUrls('#', baseUrl); });
	    }
	
	    var handleLocationChange = this._handleLocationChange.bind(this);
	    this._handleLocationChange = handleLocationChange;
	
	    // Provide way to update sprite urls externally via dispatching custom window event
	    if (config.listenLocationChangeEvent) {
	      window.addEventListener(config.locationChangeEvent, handleLocationChange);
	    }
	
	    // Emit location change event in Angular automatically
	    if (config.locationChangeAngularEmitter) {
	      locationChangeAngularEmitter(config.locationChangeEvent);
	    }
	
	    // After sprite mounted
	    emitter.on(Events.MOUNT, function (spriteNode) {
	      if (config.moveGradientsOutsideSymbol) {
	        moveGradientsOutsideSymbol(spriteNode);
	      }
	    });
	
	    // After symbol mounted into sprite
	    emitter.on(Events.SYMBOL_MOUNT, function (symbolNode) {
	      if (config.moveGradientsOutsideSymbol) {
	        moveGradientsOutsideSymbol(symbolNode.parentNode);
	      }
	
	      if (browser.isIE || browser.isEdge) {
	        evalStylesIEWorkaround(symbolNode);
	      }
	    });
	  }
	
	  if ( Sprite$$1 ) BrowserSprite.__proto__ = Sprite$$1;
	  BrowserSprite.prototype = Object.create( Sprite$$1 && Sprite$$1.prototype );
	  BrowserSprite.prototype.constructor = BrowserSprite;
	
	  var prototypeAccessors = { isMounted: {} };
	
	  /**
	   * @return {boolean}
	   */
	  prototypeAccessors.isMounted.get = function () {
	    return !!this.node;
	  };
	
	  /**
	   * Automatically configure following options
	   * - `syncUrlsWithBaseTag`
	   * - `locationChangeAngularEmitter`
	   * - `moveGradientsOutsideSymbol`
	   * @param {Object} cfg
	   * @private
	   */
	  BrowserSprite.prototype._autoConfigure = function _autoConfigure (cfg) {
	    var ref = this;
	    var config = ref.config;
	
	    if (typeof cfg.syncUrlsWithBaseTag === 'undefined') {
	      config.syncUrlsWithBaseTag = typeof document.getElementsByTagName('base')[0] !== 'undefined';
	    }
	
	    if (typeof cfg.locationChangeAngularEmitter === 'undefined') {
	      config.locationChangeAngularEmitter = 'angular' in window;
	    }
	
	    if (typeof cfg.moveGradientsOutsideSymbol === 'undefined') {
	      config.moveGradientsOutsideSymbol = browser.isFirefox;
	    }
	  };
	
	  /**
	   * @param {Event} event
	   * @param {Object} event.detail
	   * @param {string} event.detail.oldUrl
	   * @param {string} event.detail.newUrl
	   * @private
	   */
	  BrowserSprite.prototype._handleLocationChange = function _handleLocationChange (event) {
	    var ref = event.detail;
	    var oldUrl = ref.oldUrl;
	    var newUrl = ref.newUrl;
	    this.updateUrls(oldUrl, newUrl);
	  };
	
	  /**
	   * Add new symbol. If symbol with the same id exists it will be replaced.
	   * If sprite already mounted - `symbol.mount(sprite.node)` will be called.
	   * @fires Events#SYMBOL_MOUNT
	   * @param {BrowserSpriteSymbol} symbol
	   * @return {boolean} `true` - symbol was added, `false` - replaced
	   */
	  BrowserSprite.prototype.add = function add (symbol) {
	    var sprite = this;
	    var isNewSymbol = Sprite$$1.prototype.add.call(this, symbol);
	
	    if (this.isMounted && isNewSymbol) {
	      symbol.mount(sprite.node);
	      this._emitter.emit(Events.SYMBOL_MOUNT, symbol.node);
	    }
	
	    return isNewSymbol;
	  };
	
	  /**
	   * Attach to existing DOM node
	   * @param {string|Element} target
	   * @return {Element|null} attached DOM Element. null if node to attach not found.
	   */
	  BrowserSprite.prototype.attach = function attach (target) {
	    var this$1 = this;
	
	    var sprite = this;
	
	    if (sprite.isMounted) {
	      return sprite.node;
	    }
	
	    /** @type Element */
	    var node = typeof target === 'string' ? document.querySelector(target) : target;
	    sprite.node = node;
	
	    // Already added symbols needs to be mounted
	    this.symbols.forEach(function (symbol) {
	      symbol.mount(sprite.node);
	      this$1._emitter.emit(Events.SYMBOL_MOUNT, symbol.node);
	    });
	
	    // Create symbols from existing DOM nodes, add and mount them
	    arrayFrom(node.querySelectorAll('symbol'))
	      .forEach(function (symbolNode) {
	        var symbol = BrowserSpriteSymbol.createFromExistingNode(symbolNode);
	        symbol.node = symbolNode; // hack to prevent symbol mounting to sprite when adding
	        sprite.add(symbol);
	      });
	
	    this._emitter.emit(Events.MOUNT, node);
	
	    return node;
	  };
	
	  BrowserSprite.prototype.destroy = function destroy () {
	    var ref = this;
	    var config = ref.config;
	    var symbols = ref.symbols;
	    var _emitter = ref._emitter;
	
	    symbols.forEach(function (s) { return s.destroy(); });
	
	    _emitter.off('*');
	    window.removeEventListener(config.locationChangeEvent, this._handleLocationChange);
	
	    if (this.isMounted) {
	      this.unmount();
	    }
	  };
	
	  /**
	   * @fires Events#MOUNT
	   * @param {string|Element} [target]
	   * @param {boolean} [prepend=false]
	   * @return {Element|null} rendered sprite node. null if mount node not found.
	   */
	  BrowserSprite.prototype.mount = function mount (target, prepend) {
	    if ( target === void 0 ) target = this.config.mountTo;
	    if ( prepend === void 0 ) prepend = false;
	
	    var sprite = this;
	
	    if (sprite.isMounted) {
	      return sprite.node;
	    }
	
	    var mountNode = typeof target === 'string' ? document.querySelector(target) : target;
	    var node = sprite.render();
	    this.node = node;
	
	    if (prepend && mountNode.childNodes[0]) {
	      mountNode.insertBefore(node, mountNode.childNodes[0]);
	    } else {
	      mountNode.appendChild(node);
	    }
	
	    this._emitter.emit(Events.MOUNT, node);
	
	    return node;
	  };
	
	  /**
	   * @return {Element}
	   */
	  BrowserSprite.prototype.render = function render () {
	    return parse(this.stringify());
	  };
	
	  /**
	   * Detach sprite from the DOM
	   */
	  BrowserSprite.prototype.unmount = function unmount () {
	    this.node.parentNode.removeChild(this.node);
	  };
	
	  /**
	   * Update URLs in sprite and usage elements
	   * @param {string} oldUrl
	   * @param {string} newUrl
	   * @return {boolean} `true` - URLs was updated, `false` - sprite is not mounted
	   */
	  BrowserSprite.prototype.updateUrls = function updateUrls$1 (oldUrl, newUrl) {
	    if (!this.isMounted) {
	      return false;
	    }
	
	    var usages = document.querySelectorAll(this.config.usagesToUpdate);
	
	    updateUrls(
	      this.node,
	      usages,
	      ((getUrlWithoutFragment(oldUrl)) + "#"),
	      ((getUrlWithoutFragment(newUrl)) + "#")
	    );
	
	    return true;
	  };
	
	  Object.defineProperties( BrowserSprite.prototype, prototypeAccessors );
	
	  return BrowserSprite;
	}(Sprite));
	
	var ready$1 = createCommonjsModule(function (module) {
	/*!
	  * domready (c) Dustin Diaz 2014 - License MIT
	  */
	!function (name, definition) {
	
	  { module.exports = definition(); }
	
	}('domready', function () {
	
	  var fns = [], listener
	    , doc = document
	    , hack = doc.documentElement.doScroll
	    , domContentLoaded = 'DOMContentLoaded'
	    , loaded = (hack ? /^loaded|^c/ : /^loaded|^i|^c/).test(doc.readyState);
	
	
	  if (!loaded)
	  { doc.addEventListener(domContentLoaded, listener = function () {
	    doc.removeEventListener(domContentLoaded, listener);
	    loaded = 1;
	    while (listener = fns.shift()) { listener(); }
	  }); }
	
	  return function (fn) {
	    loaded ? setTimeout(fn, 0) : fns.push(fn);
	  }
	
	});
	});
	
	var spriteNodeId = '__SVG_SPRITE_NODE__';
	var spriteGlobalVarName = '__SVG_SPRITE__';
	var isSpriteExists = !!window[spriteGlobalVarName];
	
	// eslint-disable-next-line import/no-mutable-exports
	var sprite;
	
	if (isSpriteExists) {
	  sprite = window[spriteGlobalVarName];
	} else {
	  sprite = new BrowserSprite({ attrs: { id: spriteNodeId } });
	  window[spriteGlobalVarName] = sprite;
	}
	
	var loadSprite = function () {
	  /**
	   * Check for page already contains sprite node
	   * If found - attach to and reuse it's content
	   * If not - render and mount the new sprite
	   */
	  var existing = document.getElementById(spriteNodeId);
	
	  if (existing) {
	    sprite.attach(existing);
	  } else {
	    sprite.mount(document.body, true);
	  }
	};
	
	if (document.body) {
	  loadSprite();
	} else {
	  ready$1(loadSprite);
	}
	
	var sprite$1 = sprite;
	
	return sprite$1;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(33);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import './style.scss';
	
	var ContactModel = function (_React$Component) {
	  _inherits(ContactModel, _React$Component);
	
	  function ContactModel() {
	    _classCallCheck(this, ContactModel);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ContactModel.prototype.render = function render() {
	    var _props = this.props,
	        ContactModelStatus = _props.ContactModelStatus,
	        toggleContactModel = _props.toggleContactModel,
	        siteMeta = _props.siteMeta;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'c-contactModel', style: { visibility: ContactModelStatus ? 'visible' : 'hidden' }, 'data-active': ContactModelStatus ? 'on' : 'off' },
	      _react2.default.createElement(
	        'div',
	        { className: 'c-contactModel__content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'c-contactModel__content__col1 l-contactModel__content_col1' },
	          _react2.default.createElement(
	            'div',
	            { className: 'c-contactModel__content__header' },
	            _react2.default.createElement(
	              'span',
	              { className: 'u-epic' },
	              'Gutsiest Move ',
	              _react2.default.createElement('br', null),
	              'I Ever Saw, ',
	              _react2.default.createElement('br', null),
	              'Mav.'
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'o-tgQuote' },
	              '- Hollywood'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'c-contactDetails' },
	            _react2.default.createElement(
	              'div',
	              { className: 'c-contactDetails__detail' },
	              _react2.default.createElement(
	                'div',
	                { className: 'c-contatcDetails__detail__header' },
	                _react2.default.createElement(
	                  'h6',
	                  null,
	                  'Say Hello'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'c-contatcDetails__detail__body' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'tel:' + siteMeta.contactNumber },
	                    siteMeta.contactNumber
	                  )
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'mailto:' + siteMeta.contactEmail },
	                    siteMeta.contactEmail
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'c-contactDetails__detail' },
	              _react2.default.createElement(
	                'div',
	                { className: 'c-contatcDetails__detail__header' },
	                _react2.default.createElement(
	                  'h6',
	                  null,
	                  'Visit Us'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'c-contatcDetails__detail__body' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'https://goo.gl/maps/NtaLYxzJgAw24G8T6' },
	                    'GridAKL/John Lysaght - 101 Pakenham St W,',
	                    _react2.default.createElement('br', null),
	                    ' Wynyard Quarter, ',
	                    _react2.default.createElement('br', null),
	                    'Auckland 1010'
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'c-contactModel__content__form' },
	          _react2.default.createElement(
	            'div',
	            { className: 'c-contactModel__content__form__header' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Great! Let\'s get Started...'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'We\'ll be in  touch faster than you can say ',
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'span',
	                { className: 'o-tgQuote' },
	                '"Great balls of fire!" - Goose'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'c-form c-form--large' },
	            _react2.default.createElement(
	              'form',
	              {
	                name: 'contact',
	                method: 'post',
	                action: '/thanks/',
	                'data-netlify': 'true',
	                'data-netlify-honeypot': 'bot-field'
	              },
	              _react2.default.createElement('input', { type: 'hidden', name: 'form-name', value: 'contact' }),
	              _react2.default.createElement(
	                'p',
	                { hidden: true },
	                ' ',
	                _react2.default.createElement(
	                  'label',
	                  null,
	                  ' Don\u2019t fill this out:',
	                  ' ',
	                  ' ',
	                  _react2.default.createElement('input', { name: 'bot-field' })
	                )
	              ),
	              _react2.default.createElement('input', { type: 'text', name: 'name', required: true, placeholder: 'Your Name' }),
	              _react2.default.createElement('input', { type: 'email', name: 'email', required: true, placeholder: 'Email Address' }),
	              _react2.default.createElement('input', { type: 'telNo', name: 'phone', placeholder: 'Telephone' }),
	              _react2.default.createElement(
	                'button',
	                { type: 'submit' },
	                'Send'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'c-contactDetails' },
	            _react2.default.createElement(
	              'div',
	              { className: 'c-contactDetails__detail' },
	              _react2.default.createElement(
	                'div',
	                { className: 'c-contatcDetails__detail__header' },
	                _react2.default.createElement(
	                  'h6',
	                  null,
	                  'Say Hello'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'c-contatcDetails__detail__body' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'tel:' + siteMeta.contactNumber },
	                    siteMeta.contactNumber
	                  )
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'mailto:' + siteMeta.contactEmail },
	                    siteMeta.contactEmail
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'c-contactDetails__detail' },
	              _react2.default.createElement(
	                'div',
	                { className: 'c-contatcDetails__detail__header' },
	                _react2.default.createElement(
	                  'h6',
	                  null,
	                  'Visit Us'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'c-contatcDetails__detail__body' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'https://www.google.co.nz/maps/dir/\'\'/Goose+Level+1,+8%2F75+Ellice+Road,+Wairau+Valley+Auckland+0629/data=!4m5!4m4!1m0!1m2!1m1!1s0x6d0d392edebbd675:0xd699e15da42d675f?sa=X&ved=0ahUKEwjWrvTUlarbAhWFebwKHehJCDwQ9RcIdjAL' },
	                    '8/75 Ellice Road, ',
	                    _react2.default.createElement('br', null),
	                    'Wairau Valley, Auckland'
	                  )
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'c-contactModel__close' },
	        _react2.default.createElement(
	          'div',
	          { role: 'button', tabIndex: 0, onKeyPress: toggleContactModel, onClick: toggleContactModel, className: 'o-cross' },
	          _react2.default.createElement('span', null),
	          _react2.default.createElement('span', null)
	        )
	      )
	    );
	  };
	
	  return ContactModel;
	}(_react2.default.Component);
	
	exports.default = ContactModel;
	module.exports = exports['default'];

/***/ }),
/* 107 */,
/* 108 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  for (var i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(
	      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
	    ))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(108)
	var ieee754 = __webpack_require__(127)
	var isArray = __webpack_require__(232)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isElement = exports.cancelAnimationFrame = exports.requestAnimationFrame = exports.closestAbove = exports.firstDefined = exports.debounce = undefined;
	
	var _requestAnimationFrame = __webpack_require__(115);
	
	Object.defineProperty(exports, 'requestAnimationFrame', {
	  enumerable: true,
	  get: function get() {
	    return _requestAnimationFrame.requestAnimationFrame;
	  }
	});
	Object.defineProperty(exports, 'cancelAnimationFrame', {
	  enumerable: true,
	  get: function get() {
	    return _requestAnimationFrame.cancelAnimationFrame;
	  }
	});
	
	var _debounce2 = __webpack_require__(112);
	
	var _debounce3 = _interopRequireDefault(_debounce2);
	
	var _firstDefined2 = __webpack_require__(113);
	
	var _firstDefined3 = _interopRequireDefault(_firstDefined2);
	
	var _closestAbove2 = __webpack_require__(111);
	
	var _closestAbove3 = _interopRequireDefault(_closestAbove2);
	
	var _isElement2 = __webpack_require__(114);
	
	var _isElement3 = _interopRequireDefault(_isElement2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.debounce = _debounce3.default;
	exports.firstDefined = _firstDefined3.default;
	exports.closestAbove = _closestAbove3.default;
	exports.isElement = _isElement3.default;

/***/ }),
/* 111 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = closestAbove;
	/**
	 * Returns the first item in list that is greater or equal to the given value.
	 * @param {Array} list a sorted array of items
	 * @param {*} value
	 * @returns {*}
	 * @protected
	 */
	function closestAbove(list, value) {
	  return list.reduce(function (last, next) {
	    return value <= last ? last : next;
	  }, undefined);
	}

/***/ }),
/* 112 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = debounce;
	/**
	 * Delay execution of func until wait milliseconds have passed since the last invocation of the returned debounced function.
	 * @param {function} func the function to execute
	 * @param {number} wait waiting time in milliseconds
	 * @param {boolean=false} immediate if true execute func at the beginning of the wait period
	 * @returns {function()} debounced function
	 * @protected
	 */
	function debounce(func, wait, immediate) {
	  var _this = this,
	      _arguments = arguments;
	
	  var timeout = null;
	  var debounced = function debounced() {
	    var context = _this;
	    var args = _arguments;
	    var callNow = immediate && !timeout;
	    if (timeout) {
	      clearTimeout(timeout);
	    }
	    var later = function later() {
	      timeout = null;
	      if (!immediate) {
	        func.apply(context, args);
	      }
	    };
	
	    timeout = setTimeout(later, wait);
	    if (callNow) {
	      func.apply(context, args);
	    }
	  };
	
	  debounced.cancel = function () {
	    clearTimeout(timeout);
	    timeout = null;
	  };
	  return debounced;
	}

/***/ }),
/* 113 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = firstDefined;
	/**
	 * Returns the first argument that is not undefined
	 * @param {...*} values a list of arguments of any type
	 * @returns {*}
	 * @protected
	 */
	function firstDefined() {
	  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
	    values[_key] = arguments[_key];
	  }
	
	  for (var i = 0; i < values.length; i++) {
	    if (values[i] !== undefined) return values[i];
	  }
	  return undefined;
	}

/***/ }),
/* 114 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isElement;
	// Originally from lodash
	
	/**
	 * Checks if `value` is a DOM element.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	 * @protected
	 * @example
	 *
	 * _.isElement(document.body);
	 * // => true
	 *
	 * _.isElement('<body>');
	 * // => false
	 */
	function isElement(value) {
	  return value != null && value.nodeType === 1 && isObjectLike(value);
	}
	
	function isObjectLike(value) {
	  return value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object';
	}

/***/ }),
/* 115 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
	// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
	// https://gist.github.com/paulirish/1579671
	// requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel
	
	// MIT license
	
	var lastTime = 0;
	var vendors = ['ms', 'moz', 'webkit', 'o'];
	var requestAnimationFrame;
	var cancelAnimationFrame;
	
	if (typeof window != "undefined") {
	  exports.requestAnimationFrame = requestAnimationFrame = window.requestAnimationFrame;
	  exports.cancelAnimationFrame = cancelAnimationFrame = window.cancelAnimationFrame;
	  for (var x = 0; x < vendors.length && !requestAnimationFrame; ++x) {
	    exports.requestAnimationFrame = requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
	    exports.cancelAnimationFrame = cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
	  }
	}
	if (!requestAnimationFrame) exports.requestAnimationFrame = requestAnimationFrame = function requestAnimationFrame(callback, element) {
	  var currTime = new Date().getTime();
	  var timeToCall = Math.max(0, 16 - (currTime - lastTime));
	  var id = setTimeout(function () {
	    callback(currTime + timeToCall);
	  }, timeToCall);
	  lastTime = currTime + timeToCall;
	  return id;
	};
	
	if (!cancelAnimationFrame) exports.cancelAnimationFrame = cancelAnimationFrame = function cancelAnimationFrame(id) {
	  clearTimeout(id);
	};
	
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.cancelAnimationFrame = cancelAnimationFrame;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CloudinaryComponent2 = __webpack_require__(20);
	
	var _CloudinaryComponent3 = _interopRequireDefault(_CloudinaryComponent2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Provides a container for Cloudinary components. Any option set in CloudinaryContext will be passed to the children.
	 * 
	 * @example
	 *<CloudinaryContext cloudName="mycloud" dpr="auto">
	 *    <!-- other tags -->
	 *    <Image publicId={id}/>
	 *</CloudinaryContext>
	 *
	 */
	var CloudinaryContext = function (_CloudinaryComponent) {
	  _inherits(CloudinaryContext, _CloudinaryComponent);
	
	  function CloudinaryContext(props, context) {
	    _classCallCheck(this, CloudinaryContext);
	
	    var _this = _possibleConstructorReturn(this, (CloudinaryContext.__proto__ || Object.getPrototypeOf(CloudinaryContext)).call(this, props, context));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(CloudinaryContext, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var _this2 = this;
	
	      var context = {};
	      // only pass valid Cloudinary options
	      _CloudinaryComponent3.default.VALID_OPTIONS.forEach(function (key) {
	        var val = _this2.props[key] || _this2.context[key];
	        if (val !== undefined && val !== null) {
	          context[key] = val;
	        }
	      });
	      return context;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      // Remove Cloudinary custom props that don't belong to div
	      var nonCloudinaryProps = Object.keys(this.props).filter(function (propName) {
	        return !CloudinaryContext.CLOUDINARY_PROPS[propName];
	      }).reduce(function (allowedProps, currentProp) {
	        allowedProps[currentProp] = _this3.props[currentProp];
	        return allowedProps;
	      }, {});
	      return _react2.default.createElement(
	        'div',
	        nonCloudinaryProps,
	        this.props.children
	      );
	    }
	  }]);
	
	  return CloudinaryContext;
	}(_CloudinaryComponent3.default);
	
	// Map Cloudinary props from array to object for efficient lookup
	
	
	CloudinaryContext.CLOUDINARY_PROPS = _CloudinaryComponent3.default.VALID_OPTIONS.reduce(function (accumulator, cloudinaryPropName) {
	  accumulator[cloudinaryPropName] = true;
	  return accumulator;
	}, {});
	
	CloudinaryContext.propTypes = _CloudinaryComponent3.default.propTypes;
	CloudinaryContext.defaultProps = {};
	CloudinaryContext.childContextTypes = _CloudinaryComponent3.default.contextTypes;
	
	exports.default = CloudinaryContext;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _cloudinaryCore = __webpack_require__(19);
	
	var _cloudinaryCore2 = _interopRequireDefault(_cloudinaryCore);
	
	var _CloudinaryComponent2 = __webpack_require__(20);
	
	var _CloudinaryComponent3 = _interopRequireDefault(_CloudinaryComponent2);
	
	var _Util = __webpack_require__(110);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A component representing a Cloudinary served image
	 */
	var Image = function (_CloudinaryComponent) {
	  _inherits(Image, _CloudinaryComponent);
	
	  function Image(props, context) {
	    _classCallCheck(this, Image);
	
	    function defaultBreakpoints(width) {
	      var steps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
	
	      return steps * Math.ceil(width / steps);
	    }
	
	    var _this = _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).call(this, props, context));
	
	    _this.handleResize = _this.handleResize.bind(_this);
	
	    var state = { responsive: false, url: "", breakpoints: defaultBreakpoints };
	    _this.state = Object.assign(state, _this.prepareState(props, context));
	    return _this;
	  }
	
	  /**
	   * Retrieve the window or default view of the current element
	   * @returns {DocumentView|*}
	   * @private
	   */
	
	
	  _createClass(Image, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps, nextContext) {
	      var state = this.prepareState(nextProps, nextContext);
	      this.setState(state);
	    }
	
	    /**
	     * Generate update state of this element
	     * @param {Object} [props=this.props]
	     * @param {Object} [context=this.context]
	     * @returns {Object} state updates
	     * @private
	     */
	
	  }, {
	    key: 'prepareState',
	    value: function prepareState() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.context;
	
	      var options = _CloudinaryComponent3.default.normalizeOptions(context, props);
	      var url = this.getUrl(options);
	      var state = {};
	      if (options.breakpoints !== undefined) {
	        state.breakpoints = options.breakpoints;
	      }
	      if (options.responsive) {
	        state.responsive = true;
	        url = this.cloudinary_update(url, state);
	      }
	
	      var currentState = this.state || {};
	      if (!_cloudinaryCore.Util.isEmpty(url) && url !== currentState.url) {
	        state.url = url;
	      }
	      return state;
	    }
	  }, {
	    key: 'handleResize',
	    value: function handleResize(e) {
	      var _this2 = this;
	
	      if (this.rqf) return;
	      this.rqf = (0, _Util.requestAnimationFrame)(function () {
	        _this2.rqf = null;
	        var newState = _this2.prepareState();
	        if (!_cloudinaryCore.Util.isEmpty(newState.url)) {
	          _this2.setState(newState);
	        }
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // now that we have a this.element, we need to calculate the URL
	      this.handleResize();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.element = undefined;
	      if (this.listener) {
	        this.listener.cancel();
	        this.window && this.window.removeEventListener('resize', this.listener);
	      }
	      this.listener = undefined;
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState, nextContext) {
	      if (nextState.responsive) {
	        var wait = (0, _Util.firstDefined)(nextProps.responsiveDebounce, nextContext.responsiveDebounce, 100);
	        if (this.listener) {
	          this.window && this.window.removeEventListener('resize', this.listener);
	        }
	        this.listener = (0, _Util.debounce)(this.handleResize, wait);
	        this.window && this.window.addEventListener('resize', this.listener);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _CloudinaryComponent$ = _CloudinaryComponent3.default.normalizeOptions(this.props, this.context),
	          publicId = _CloudinaryComponent$.publicId,
	          responsive = _CloudinaryComponent$.responsive,
	          responsiveDebounce = _CloudinaryComponent$.responsiveDebounce,
	          children = _CloudinaryComponent$.children,
	          options = _objectWithoutProperties(_CloudinaryComponent$, ['publicId', 'responsive', 'responsiveDebounce', 'children']);
	
	      var attributes = _cloudinaryCore2.default.Transformation.new(options).toHtmlAttributes();
	      return _react2.default.createElement('img', _extends({}, attributes, { src: this.state.url, ref: function ref(e) {
	          _this3.element = e;
	        } }));
	    }
	
	    // Methods from cloudinary_js
	
	  }, {
	    key: 'findContainerWidth',
	    value: function findContainerWidth() {
	      var containerWidth, style;
	      containerWidth = 0;
	      var element = this.element;
	      while ((0, _Util.isElement)(element = element != null ? element.parentNode : void 0) && !containerWidth) {
	        style = this.window ? this.window.getComputedStyle(element) : '';
	        if (!/^inline/.test(style.display)) {
	          containerWidth = _cloudinaryCore.Util.width(element);
	        }
	      }
	      return containerWidth;
	    }
	  }, {
	    key: 'applyBreakpoints',
	    value: function applyBreakpoints(width, steps, options) {
	      var responsive_use_breakpoints;
	      options = _CloudinaryComponent3.default.normalizeOptions(this.context, this.props, options);
	      responsive_use_breakpoints = options.responsive_use_breakpoints;
	      if (!responsive_use_breakpoints || responsive_use_breakpoints === 'resize' && !options.resizing) {
	        return width;
	      } else {
	        return this.calc_breakpoint(width, steps);
	      }
	    }
	  }, {
	    key: 'calc_breakpoint',
	    value: function calc_breakpoint(width, steps) {
	      var breakpoints, point;
	      breakpoints = this.state.breakpoints || defaultBreakpoints;
	      if (_cloudinaryCore.Util.isFunction(breakpoints)) {
	        return breakpoints(width, steps);
	      } else {
	        if (_cloudinaryCore.Util.isString(breakpoints)) {
	          breakpoints = function () {
	            var j, len, ref, results;
	            ref = breakpoints.split(',');
	            results = [];
	            for (j = 0, len = ref.length; j < len; j++) {
	              point = ref[j];
	              results.push(parseInt(point));
	            }
	            return results;
	          }().sort(function (a, b) {
	            return a - b;
	          });
	        }
	        return (0, _Util.closestAbove)(breakpoints, width);
	      }
	    }
	  }, {
	    key: 'device_pixel_ratio',
	    value: function device_pixel_ratio() {
	      var roundDpr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      var dpr, dprString;
	      dpr = (typeof this.window !== "undefined" && this.window !== null ? this.window.devicePixelRatio : void 0) || 1;
	      if (roundDpr) {
	        dpr = Math.ceil(dpr);
	      }
	      if (dpr <= 0 || isNaN(dpr)) {
	        dpr = 1;
	      }
	      dprString = dpr.toString();
	      if (dprString.match(/^\d+$/)) {
	        dprString += '.0';
	      }
	      return dprString;
	    }
	  }, {
	    key: 'updateDpr',
	    value: function updateDpr(dataSrc, roundDpr) {
	      return dataSrc.replace(/\bdpr_(1\.0|auto)\b/g, 'dpr_' + this.device_pixel_ratio(roundDpr));
	    }
	  }, {
	    key: 'maxWidth',
	    value: function maxWidth(requiredWidth) {
	      var imageWidth;
	      imageWidth = this.state.width || 0;
	      if (requiredWidth > imageWidth) {
	        imageWidth = requiredWidth;
	        this.setState({ width: requiredWidth });
	      }
	      return imageWidth;
	    }
	  }, {
	    key: 'cloudinary_update',
	    value: function cloudinary_update(url) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var requiredWidth;
	      var match;
	      var resultUrl = this.updateDpr(url, options.roundDpr);
	      if (options.responsive || this.state && this.state.responsive) {
	        var containerWidth = this.findContainerWidth();
	        if (containerWidth !== 0) {
	          if (/w_auto:breakpoints/.test(resultUrl)) {
	            requiredWidth = this.maxWidth(containerWidth, this.element);
	            resultUrl = resultUrl.replace(/w_auto:breakpoints([_0-9]*)(:[0-9]+)?/, "w_auto:breakpoints$1:" + requiredWidth);
	          } else if (match = /w_auto(:(\d+))?/.exec(resultUrl)) {
	            requiredWidth = this.applyBreakpoints(containerWidth, match[2], options);
	            requiredWidth = this.maxWidth(requiredWidth, this.element);
	            resultUrl = resultUrl.replace(/w_auto[^,\/]*/g, "w_" + requiredWidth);
	          }
	        } else {
	          resultUrl = "";
	        }
	      }
	      return resultUrl;
	    }
	  }, {
	    key: 'window',
	    get: function get() {
	      var windowRef = null;
	      if (typeof window !== "undefined") {
	        windowRef = window;
	      }
	      return this.element && this.element.ownerDocument ? this.element.ownerDocument.defaultView || windowRef : windowRef;
	    }
	  }]);
	
	  return Image;
	}(_CloudinaryComponent3.default);
	
	Image.defaultProps = {};
	Image.contextTypes = _CloudinaryComponent3.default.contextTypes;
	Image.propTypes = _CloudinaryComponent3.default.propTypes;
	
	exports.default = Image;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CloudinaryComponent2 = __webpack_require__(20);
	
	var _CloudinaryComponent3 = _interopRequireDefault(_CloudinaryComponent2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Define a transformation that is applied to the parent tag.
	 */
	var Transformation = function (_CloudinaryComponent) {
	  _inherits(Transformation, _CloudinaryComponent);
	
	  function Transformation(props) {
	    _classCallCheck(this, Transformation);
	
	    return _possibleConstructorReturn(this, (Transformation.__proto__ || Object.getPrototypeOf(Transformation)).call(this, props));
	  }
	
	  _createClass(Transformation, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return Transformation;
	}(_CloudinaryComponent3.default);
	
	Transformation.propTypes = _CloudinaryComponent3.default.propTypes;
	Transformation.defaultProps = {};
	Transformation.contextTypes = {};
	Transformation.exposesProps = true;
	
	exports.default = Transformation;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(10);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _cloudinaryCore = __webpack_require__(19);
	
	var _CloudinaryComponent2 = __webpack_require__(20);
	
	var _CloudinaryComponent3 = _interopRequireDefault(_CloudinaryComponent2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_POSTER_OPTIONS = {
	  format: 'jpg',
	  resource_type: 'video'
	};
	
	/**
	 * A component representing a Cloudinary served video
	 */
	
	var Video = function (_CloudinaryComponent) {
	  _inherits(Video, _CloudinaryComponent);
	
	  function Video(props) {
	    _classCallCheck(this, Video);
	
	    var _this = _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Video, [{
	    key: 'render',
	    value: function render() {
	      var _Object$assign = Object.assign({}, this.context, this.props),
	          publicId = _Object$assign.publicId,
	          poster = _Object$assign.poster,
	          sourceTypes = _Object$assign.sourceTypes,
	          fallback = _Object$assign.fallback,
	          sourceTransformations = _Object$assign.sourceTransformation,
	          options = _objectWithoutProperties(_Object$assign, ['publicId', 'poster', 'sourceTypes', 'fallback', 'sourceTransformation']);
	
	      sourceTransformations = sourceTransformations || {};
	      sourceTypes = sourceTypes || _cloudinaryCore.Cloudinary.DEFAULT_VIDEO_PARAMS.source_types;
	      options = _CloudinaryComponent3.default.normalizeOptions(options, {});
	      var cld = _cloudinaryCore.Cloudinary.new(_cloudinaryCore.Util.withSnakeCaseKeys(options));
	      var sources = [];
	      var tagAttributes = _cloudinaryCore.Transformation.new(options).toHtmlAttributes();
	      var childTransformations = this.getTransformation(options);
	      if (_cloudinaryCore.Util.isPlainObject(poster)) {
	        var defaults = poster.publicId !== undefined && poster.publicId !== null ? _cloudinaryCore.Cloudinary.DEFAULT_IMAGE_PARAMS : DEFAULT_POSTER_OPTIONS;
	        poster = cld.url(poster.publicId || publicId, _cloudinaryCore.Util.defaults({}, _cloudinaryCore.Util.withSnakeCaseKeys(poster), defaults));
	      }
	      if (!_cloudinaryCore.Util.isEmpty(poster)) {
	        tagAttributes.poster = poster;
	      }
	      if (!_cloudinaryCore.Util.isEmpty(this.state.poster)) {
	        tagAttributes.poster = this.state.poster;
	      }
	
	      if (_cloudinaryCore.Util.isArray(sourceTypes)) {
	        sources = sourceTypes.map(function (srcType) {
	          var sourceTransformation = sourceTransformations[srcType] || {};
	          var src = cld.url(publicId, _cloudinaryCore.Util.defaults({}, sourceTransformation, childTransformations, { resource_type: 'video', format: srcType }));
	          var mimeType = 'video/' + (srcType === 'ogv' ? 'ogg' : srcType);
	          return _react2.default.createElement('source', { key: mimeType, src: src, type: mimeType });
	        });
	      } else {
	        var sourceTransformation = sourceTransformations[sourceTypes] || {};
	        tagAttributes.src = cld.url(publicId, _cloudinaryCore.Util.defaults({}, sourceTransformation, childTransformations, { resource_type: 'video', format: sourceTypes }));
	      }
	
	      return _react2.default.createElement(
	        'video',
	        tagAttributes,
	        sources,
	        fallback,
	        this.props.children
	      );
	    }
	  }]);
	
	  return Video;
	}(_CloudinaryComponent3.default);
	
	Video.propTypes = { publicId: _propTypes2.default.string };
	Video.defaultProps = {};
	Video.contextTypes = _CloudinaryComponent3.default.contextTypes;
	
	exports.default = Video;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Video = exports.Transformation = exports.Image = exports.CloudinaryContext = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CloudinaryContext = __webpack_require__(116);
	
	var _CloudinaryContext2 = _interopRequireDefault(_CloudinaryContext);
	
	var _Image = __webpack_require__(117);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Transformation = __webpack_require__(118);
	
	var _Transformation2 = _interopRequireDefault(_Transformation);
	
	var _Video = __webpack_require__(119);
	
	var _Video2 = _interopRequireDefault(_Video);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CloudinaryContext = _CloudinaryContext2.default;
	exports.Image = _Image2.default;
	exports.Transformation = _Transformation2.default;
	exports.Video = _Video2.default;

/***/ }),
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */
/***/ (function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(17),
	    root = __webpack_require__(8);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(17),
	    root = __webpack_require__(8);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(17),
	    root = __webpack_require__(8);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(83),
	    setCacheAdd = __webpack_require__(180),
	    setCacheHas = __webpack_require__(181);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(8);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(17),
	    root = __webpack_require__(8);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ }),
/* 134 */
/***/ (function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ }),
/* 135 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(22);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ }),
/* 137 */
/***/ (function(module, exports) {

	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ }),
/* 138 */
/***/ (function(module, exports) {

	/**
	 * Converts an ASCII `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function asciiToArray(string) {
	  return string.split('');
	}
	
	module.exports = asciiToArray;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(14),
	    keys = __webpack_require__(15);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(14),
	    keysIn = __webpack_require__(27);
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(56),
	    arrayEach = __webpack_require__(135),
	    assignValue = __webpack_require__(36),
	    baseAssign = __webpack_require__(139),
	    baseAssignIn = __webpack_require__(140),
	    cloneBuffer = __webpack_require__(63),
	    copyArray = __webpack_require__(65),
	    copySymbols = __webpack_require__(167),
	    copySymbolsIn = __webpack_require__(168),
	    getAllKeys = __webpack_require__(170),
	    getAllKeysIn = __webpack_require__(171),
	    getTag = __webpack_require__(24),
	    initCloneArray = __webpack_require__(173),
	    initCloneByTag = __webpack_require__(174),
	    initCloneObject = __webpack_require__(69),
	    isArray = __webpack_require__(7),
	    isBuffer = __webpack_require__(26),
	    isMap = __webpack_require__(201),
	    isObject = __webpack_require__(12),
	    isSet = __webpack_require__(202),
	    keys = __webpack_require__(15);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (isSet(value)) {
	    value.forEach(function(subValue) {
	      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	    });
	
	    return result;
	  }
	
	  if (isMap(value)) {
	    value.forEach(function(subValue, key) {
	      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	    });
	
	    return result;
	  }
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(12);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(131),
	    arrayIncludes = __webpack_require__(136),
	    arrayIncludesWith = __webpack_require__(137),
	    arrayMap = __webpack_require__(84),
	    baseUnary = __webpack_require__(23),
	    cacheHas = __webpack_require__(160);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of methods like `_.difference` without support
	 * for excluding multiple arrays or iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      isCommon = true,
	      length = array.length,
	      result = [],
	      valuesLength = values.length;
	
	  if (!length) {
	    return result;
	  }
	  if (iteratee) {
	    values = arrayMap(values, baseUnary(iteratee));
	  }
	  if (comparator) {
	    includes = arrayIncludesWith;
	    isCommon = false;
	  }
	  else if (values.length >= LARGE_ARRAY_SIZE) {
	    includes = cacheHas;
	    isCommon = false;
	    values = new SetCache(values);
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee == null ? value : iteratee(value);
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === computed) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (!includes(values, computed, comparator)) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseDifference;


/***/ }),
/* 144 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(35),
	    isFlattenable = __webpack_require__(175);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(169);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(57),
	    isFunction = __webpack_require__(29);
	
	/**
	 * The base implementation of `_.functions` which creates an array of
	 * `object` function property names filtered from `props`.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Array} props The property names to filter.
	 * @returns {Array} Returns the function names.
	 */
	function baseFunctions(object, props) {
	  return arrayFilter(props, function(key) {
	    return isFunction(object[key]);
	  });
	}
	
	module.exports = baseFunctions;


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(16),
	    isObjectLike = __webpack_require__(6);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(24),
	    isObjectLike = __webpack_require__(6);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]';
	
	/**
	 * The base implementation of `_.isMap` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 */
	function baseIsMap(value) {
	  return isObjectLike(value) && getTag(value) == mapTag;
	}
	
	module.exports = baseIsMap;


/***/ }),
/* 150 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(24),
	    isObjectLike = __webpack_require__(6);
	
	/** `Object#toString` result references. */
	var setTag = '[object Set]';
	
	/**
	 * The base implementation of `_.isSet` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 */
	function baseIsSet(value) {
	  return isObjectLike(value) && getTag(value) == setTag;
	}
	
	module.exports = baseIsSet;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(16),
	    isLength = __webpack_require__(74),
	    isObjectLike = __webpack_require__(6);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(12),
	    isPrototype = __webpack_require__(18),
	    nativeKeysIn = __webpack_require__(178);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(56),
	    assignMergeValue = __webpack_require__(59),
	    baseFor = __webpack_require__(146),
	    baseMergeDeep = __webpack_require__(155),
	    isObject = __webpack_require__(12),
	    keysIn = __webpack_require__(27),
	    safeGet = __webpack_require__(72);
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor(source, function(srcValue, key) {
	    if (isObject(srcValue)) {
	      stack || (stack = new Stack);
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}
	
	module.exports = baseMerge;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	var assignMergeValue = __webpack_require__(59),
	    cloneBuffer = __webpack_require__(63),
	    cloneTypedArray = __webpack_require__(64),
	    copyArray = __webpack_require__(65),
	    initCloneObject = __webpack_require__(69),
	    isArguments = __webpack_require__(25),
	    isArray = __webpack_require__(7),
	    isArrayLikeObject = __webpack_require__(73),
	    isBuffer = __webpack_require__(26),
	    isFunction = __webpack_require__(29),
	    isObject = __webpack_require__(12),
	    isPlainObject = __webpack_require__(43),
	    isTypedArray = __webpack_require__(44),
	    safeGet = __webpack_require__(72),
	    toPlainObject = __webpack_require__(208);
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = safeGet(object, key),
	      srcValue = safeGet(source, key),
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    var isArr = isArray(srcValue),
	        isBuff = !isArr && isBuffer(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      newValue = objValue;
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	module.exports = baseMergeDeep;


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(195),
	    defineProperty = __webpack_require__(67),
	    identity = __webpack_require__(42);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ }),
/* 157 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ }),
/* 158 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(84);
	
	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  return arrayMap(props, function(key) {
	    return object[key];
	  });
	}
	
	module.exports = baseValues;


/***/ }),
/* 160 */
/***/ (function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(157);
	
	/**
	 * Casts `array` to a slice if it's needed.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {number} start The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the cast slice.
	 */
	function castSlice(array, start, end) {
	  var length = array.length;
	  end = end === undefined ? length : end;
	  return (!start && end >= length) ? array : baseSlice(array, start, end);
	}
	
	module.exports = castSlice;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(22);
	
	/**
	 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	 * that is not found in the character symbols.
	 *
	 * @private
	 * @param {Array} strSymbols The string symbols to inspect.
	 * @param {Array} chrSymbols The character symbols to find.
	 * @returns {number} Returns the index of the last unmatched string symbol.
	 */
	function charsEndIndex(strSymbols, chrSymbols) {
	  var index = strSymbols.length;
	
	  while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	  return index;
	}
	
	module.exports = charsEndIndex;


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(22);
	
	/**
	 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	 * that is not found in the character symbols.
	 *
	 * @private
	 * @param {Array} strSymbols The string symbols to inspect.
	 * @param {Array} chrSymbols The character symbols to find.
	 * @returns {number} Returns the index of the first unmatched string symbol.
	 */
	function charsStartIndex(strSymbols, chrSymbols) {
	  var index = -1,
	      length = strSymbols.length;
	
	  while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	  return index;
	}
	
	module.exports = charsStartIndex;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(38);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ }),
/* 165 */
/***/ (function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(52);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(14),
	    getSymbols = __webpack_require__(40);
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(14),
	    getSymbolsIn = __webpack_require__(68);
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ }),
/* 169 */
/***/ (function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(60),
	    getSymbols = __webpack_require__(40),
	    keys = __webpack_require__(15);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(60),
	    getSymbolsIn = __webpack_require__(68),
	    keysIn = __webpack_require__(27);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ }),
/* 172 */
/***/ (function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsZWJ = '\\u200d';
	
	/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	/**
	 * Checks if `string` contains Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	 */
	function hasUnicode(string) {
	  return reHasUnicode.test(string);
	}
	
	module.exports = hasUnicode;


/***/ }),
/* 173 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = new array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(38),
	    cloneDataView = __webpack_require__(164),
	    cloneRegExp = __webpack_require__(165),
	    cloneSymbol = __webpack_require__(166),
	    cloneTypedArray = __webpack_require__(64);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return new Ctor;
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return new Ctor;
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(52),
	    isArguments = __webpack_require__(25),
	    isArray = __webpack_require__(7);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(48),
	    isArrayLike = __webpack_require__(11),
	    isIndex = __webpack_require__(70),
	    isObject = __webpack_require__(12);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(71);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),
/* 178 */
/***/ (function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(134);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ }),
/* 180 */
/***/ (function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ }),
/* 181 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(156),
	    shortOut = __webpack_require__(183);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ }),
/* 183 */
/***/ (function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(47);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ }),
/* 185 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ }),
/* 186 */
/***/ (function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ }),
/* 187 */
/***/ (function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(47),
	    Map = __webpack_require__(82),
	    MapCache = __webpack_require__(83);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ }),
/* 189 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	var asciiToArray = __webpack_require__(138),
	    hasUnicode = __webpack_require__(172),
	    unicodeToArray = __webpack_require__(191);
	
	/**
	 * Converts `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function stringToArray(string) {
	  return hasUnicode(string)
	    ? unicodeToArray(string)
	    : asciiToArray(string);
	}
	
	module.exports = stringToArray;


/***/ }),
/* 191 */
/***/ (function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/**
	 * Converts a Unicode `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function unicodeToArray(string) {
	  return string.match(reUnicode) || [];
	}
	
	module.exports = unicodeToArray;


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(36),
	    copyObject = __webpack_require__(14),
	    createAssigner = __webpack_require__(66),
	    isArrayLike = __webpack_require__(11),
	    isPrototype = __webpack_require__(18),
	    keys = __webpack_require__(15);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns own enumerable string keyed properties of source objects to the
	 * destination object. Source objects are applied from left to right.
	 * Subsequent sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object` and is loosely based on
	 * [`Object.assign`](https://mdn.io/Object/assign).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.10.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assignIn
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * function Bar() {
	 *   this.c = 3;
	 * }
	 *
	 * Foo.prototype.b = 2;
	 * Bar.prototype.d = 4;
	 *
	 * _.assign({ 'a': 0 }, new Foo, new Bar);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var assign = createAssigner(function(object, source) {
	  if (isPrototype(source) || isArrayLike(source)) {
	    copyObject(source, keys(source), object);
	    return;
	  }
	  for (var key in source) {
	    if (hasOwnProperty.call(source, key)) {
	      assignValue(object, key, source[key]);
	    }
	  }
	});
	
	module.exports = assign;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(141);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * This method is like `_.clone` except that it recursively clones `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Lang
	 * @param {*} value The value to recursively clone.
	 * @returns {*} Returns the deep cloned value.
	 * @see _.clone
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var deep = _.cloneDeep(objects);
	 * console.log(deep[0] === objects[0]);
	 * // => false
	 */
	function cloneDeep(value) {
	  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	}
	
	module.exports = cloneDeep;


/***/ }),
/* 194 */
/***/ (function(module, exports) {

	/**
	 * Creates an array with all falsey values removed. The values `false`, `null`,
	 * `0`, `""`, `undefined`, and `NaN` are falsey.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to compact.
	 * @returns {Array} Returns the new array of filtered values.
	 * @example
	 *
	 * _.compact([0, 1, false, 2, '', 3]);
	 * // => [1, 2, 3]
	 */
	function compact(array) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (value) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = compact;


/***/ }),
/* 195 */
/***/ (function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(143),
	    baseFlatten = __webpack_require__(145),
	    baseRest = __webpack_require__(62),
	    isArrayLikeObject = __webpack_require__(73);
	
	/**
	 * Creates an array of `array` values not included in the other given arrays
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons. The order and references of result values are
	 * determined by the first array.
	 *
	 * **Note:** Unlike `_.pullAll`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {...Array} [values] The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 * @see _.without, _.xor
	 * @example
	 *
	 * _.difference([2, 1], [2, 3]);
	 * // => [1]
	 */
	var difference = baseRest(function(array, values) {
	  return isArrayLikeObject(array)
	    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	    : [];
	});
	
	module.exports = difference;


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFunctions = __webpack_require__(147),
	    keys = __webpack_require__(15);
	
	/**
	 * Creates an array of function property names from own enumerable properties
	 * of `object`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to inspect.
	 * @returns {Array} Returns the function names.
	 * @see _.functionsIn
	 * @example
	 *
	 * function Foo() {
	 *   this.a = _.constant('a');
	 *   this.b = _.constant('b');
	 * }
	 *
	 * Foo.prototype.c = _.constant('c');
	 *
	 * _.functions(new Foo);
	 * // => ['a', 'b']
	 */
	function functions(object) {
	  return object == null ? [] : baseFunctions(object, keys(object));
	}
	
	module.exports = functions;


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(22),
	    isArrayLike = __webpack_require__(11),
	    isString = __webpack_require__(75),
	    toInteger = __webpack_require__(206),
	    values = __webpack_require__(210);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Checks if `value` is in `collection`. If `collection` is a string, it's
	 * checked for a substring of `value`, otherwise
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * is used for equality comparisons. If `fromIndex` is negative, it's used as
	 * the offset from the end of `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	 * @returns {boolean} Returns `true` if `value` is found, else `false`.
	 * @example
	 *
	 * _.includes([1, 2, 3], 1);
	 * // => true
	 *
	 * _.includes([1, 2, 3], 1, 2);
	 * // => false
	 *
	 * _.includes({ 'a': 1, 'b': 2 }, 1);
	 * // => true
	 *
	 * _.includes('abcd', 'bc');
	 * // => true
	 */
	function includes(collection, value, fromIndex, guard) {
	  collection = isArrayLike(collection) ? collection : values(collection);
	  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	  var length = collection.length;
	  if (fromIndex < 0) {
	    fromIndex = nativeMax(length + fromIndex, 0);
	  }
	  return isString(collection)
	    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	}
	
	module.exports = includes;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	var isObjectLike = __webpack_require__(6),
	    isPlainObject = __webpack_require__(43);
	
	/**
	 * Checks if `value` is likely a DOM element.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	 * @example
	 *
	 * _.isElement(document.body);
	 * // => true
	 *
	 * _.isElement('<body>');
	 * // => false
	 */
	function isElement(value) {
	  return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	}
	
	module.exports = isElement;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	var baseKeys = __webpack_require__(61),
	    getTag = __webpack_require__(24),
	    isArguments = __webpack_require__(25),
	    isArray = __webpack_require__(7),
	    isArrayLike = __webpack_require__(11),
	    isBuffer = __webpack_require__(26),
	    isPrototype = __webpack_require__(18),
	    isTypedArray = __webpack_require__(44);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if `value` is an empty object, collection, map, or set.
	 *
	 * Objects are considered empty if they have no own enumerable string keyed
	 * properties.
	 *
	 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	 * jQuery-like collections are considered empty if they have a `length` of `0`.
	 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	 * @example
	 *
	 * _.isEmpty(null);
	 * // => true
	 *
	 * _.isEmpty(true);
	 * // => true
	 *
	 * _.isEmpty(1);
	 * // => true
	 *
	 * _.isEmpty([1, 2, 3]);
	 * // => false
	 *
	 * _.isEmpty({ 'a': 1 });
	 * // => false
	 */
	function isEmpty(value) {
	  if (value == null) {
	    return true;
	  }
	  if (isArrayLike(value) &&
	      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	    return !value.length;
	  }
	  var tag = getTag(value);
	  if (tag == mapTag || tag == setTag) {
	    return !value.size;
	  }
	  if (isPrototype(value)) {
	    return !baseKeys(value).length;
	  }
	  for (var key in value) {
	    if (hasOwnProperty.call(value, key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = isEmpty;


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMap = __webpack_require__(149),
	    baseUnary = __webpack_require__(23),
	    nodeUtil = __webpack_require__(41);
	
	/* Node.js helper references. */
	var nodeIsMap = nodeUtil && nodeUtil.isMap;
	
	/**
	 * Checks if `value` is classified as a `Map` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 * @example
	 *
	 * _.isMap(new Map);
	 * // => true
	 *
	 * _.isMap(new WeakMap);
	 * // => false
	 */
	var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	module.exports = isMap;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsSet = __webpack_require__(151),
	    baseUnary = __webpack_require__(23),
	    nodeUtil = __webpack_require__(41);
	
	/* Node.js helper references. */
	var nodeIsSet = nodeUtil && nodeUtil.isSet;
	
	/**
	 * Checks if `value` is classified as a `Set` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 * @example
	 *
	 * _.isSet(new Set);
	 * // => true
	 *
	 * _.isSet(new WeakSet);
	 * // => false
	 */
	var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	module.exports = isSet;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(154),
	    createAssigner = __webpack_require__(66);
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	module.exports = merge;


/***/ }),
/* 204 */
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(207);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(205);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(12),
	    isSymbol = __webpack_require__(99);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(14),
	    keysIn = __webpack_require__(27);
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	module.exports = toPlainObject;


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(234),
	    castSlice = __webpack_require__(161),
	    charsEndIndex = __webpack_require__(162),
	    charsStartIndex = __webpack_require__(163),
	    stringToArray = __webpack_require__(190),
	    toString = __webpack_require__(77);
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/**
	 * Removes leading and trailing whitespace or specified characters from `string`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to trim.
	 * @param {string} [chars=whitespace] The characters to trim.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {string} Returns the trimmed string.
	 * @example
	 *
	 * _.trim('  abc  ');
	 * // => 'abc'
	 *
	 * _.trim('-_-abc-_-', '_-');
	 * // => 'abc'
	 *
	 * _.map(['  foo  ', '  bar  '], _.trim);
	 * // => ['foo', 'bar']
	 */
	function trim(string, chars, guard) {
	  string = toString(string);
	  if (string && (guard || chars === undefined)) {
	    return string.replace(reTrim, '');
	  }
	  if (!string || !(chars = baseToString(chars))) {
	    return string;
	  }
	  var strSymbols = stringToArray(string),
	      chrSymbols = stringToArray(chars),
	      start = charsStartIndex(strSymbols, chrSymbols),
	      end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	  return castSlice(strSymbols, start, end).join('');
	}
	
	module.exports = trim;


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	var baseValues = __webpack_require__(159),
	    keys = __webpack_require__(15);
	
	/**
	 * Creates an array of the own enumerable string keyed property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return object == null ? [] : baseValues(object, keys(object));
	}
	
	module.exports = values;


/***/ }),
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	var SpriteSymbol = __webpack_require__(78);
	var sprite = __webpack_require__(79);
	var symbol = new SpriteSymbol({
	  "id": "goose-logo",
	  "use": "goose-logo-usage",
	  "viewBox": "477.42 233.958 222.89 136.278",
	  "content": "<symbol viewBox=\"477.42 233.958 222.89 136.278\" id=\"goose-logo\">\r\n<path fill=\"#EF404B\" d=\"M659.24,238.17c7.44-1.76,14.99-6.01,22.779-3.37c8.78,1.87,17.95,8.55,18.231,18.24\r\n\tc0.07,25.43-0.03,50.87,0.06,76.3c-3.27-2.63-6.079-6.04-10.18-7.42c-6.44-2.35-13.6-3.97-20.37-2.12\r\n\tc-53.569,16.28-106.97,33.05-160.55,49.31c-7.37,2.361-15.58,0.851-22.16-3.039c-5.18-3.26-9.53-8.711-9.569-15.07\r\n\tc-0.091-25.31,0.029-50.62-0.061-75.93c1.3-0.39,1.9,1.1,2.8,1.75c5.07,5.34,12.59,7.61,19.75,8.2c7.021,0.61,13.691-1.99,20.3-3.91\r\n\tc6.761-2.43,13.86-3.76,20.551-6.39C580.24,262.37,619.81,250.49,659.24,238.17z\" />\r\n<path fill=\"#FFFFFF\" d=\"M641.269,259.51c7.061-1.71,13.771-4.89,20.981-5.84c0.18,3.1,0.19,6.21,0.09,9.31\r\n\tc-2.1,0.81-4.45,1.23-5.83-0.99c-2.21,0.36-4.37,1-6.319,2.11c0.1,4.78,0.119,9.55-0.051,14.33c2.86-0.27,5.5-1.51,8.32-2.03\r\n\tc0.9,2.06,0.28,4.45,0.39,6.64c-2.89,0.98-5.81,1.88-8.64,3.04c0.07,5.38,0.07,10.76,0.01,16.14c2.13-0.31,4.221-0.87,6.231-1.65\r\n\tc0.609-3,2.979-4.78,5.91-5.31c-0.011,3.17,0.319,6.39-0.21,9.54c-0.78,1.26-2.431,1.4-3.67,1.94c-5.79,1.68-11.49,3.62-17.29,5.21\r\n\tc-0.86-4.3,2.72-7.69,2.029-11.94c-0.16-11.04,0.15-22.11-0.14-33.15C641.59,264.66,640.84,262.17,641.269,259.51z\" />\r\n<path fill=\"#FFFFFF\" d=\"M621.42,265.55c3.16-1.05,7.29,0.21,8.46,3.57c1.07,3.56,0.76,7.36,0.54,11.03\r\n\tc-1.74,0.31-3.479,1.24-5.26,0.85c-2.26-1.66-1.28-4.75-2.11-7.06c-2.149-2.18-5.76,0.64-5.72,3.22c0.03,2.58-0.66,5.54,0.67,7.88\r\n\tc3.33,2.89,8.48,3.08,11.26,6.74c2.98,3.7,1.59,8.81,1.9,13.17c0.6,8.56-7.83,15.94-16.17,15.03c-2.56-0.34-4.59-2.6-5.06-5.07\r\n\tc-0.529-3.21-0.34-6.47-0.09-9.69c1.65-0.39,3.29-0.86,4.99-1.06c3.51,1.58-0.11,7.15,3.38,8.47c3.02,0.39,6.24-2.39,5.809-5.52\r\n\tc-0.199-3.11,0.61-6.49-0.659-9.4c-2.63-3.6-8.04-2.86-10.91-6.19c-3.351-3.62-2.25-8.99-2.19-13.47\r\n\tC610.56,271.91,615.48,266.73,621.42,265.55z\" />\r\n<path fill=\"#FFFFFF\" d=\"M588.47,275.58c2.5-0.87,5.46-1.32,7.941-0.1c2.67,1.43,3.72,4.64,3.59,7.52\r\n\tc-0.04,11.02,0.08,22.05-0.06,33.08c-0.341,7.87-8.141,14.29-15.891,13.47c-3.54-0.489-5.609-4.25-5.38-7.6\r\n\tc-0.05-10.96-0.03-21.92,0-32.88C578.46,283,582.92,277.59,588.47,275.58z\" />\r\n<path fill=\"#EF404B\" d=\"M585.65,288.03c-0.551-3.76,2.83-6.41,6.34-6.2c0.8,1.96,1.1,4.07,1,6.19c-0.13,9.69,0.13,19.38-0.11,29.07\r\n\tc0.16,3.55-3.5,6.11-6.81,4.98C585.1,310.77,585.84,299.37,585.65,288.03z\" />\r\n<path fill=\"#FFFFFF\" d=\"M555.41,285.6c2.34-0.85,5-1.22,7.41-0.4c3,1.23,4.35,4.68,4.18,7.75c-0.04,11.05,0.08,22.11-0.06,33.17\r\n\tc-0.37,7.84-8.12,14.239-15.851,13.43c-3.56-0.45-5.649-4.229-5.42-7.579c-0.05-10.98-0.03-21.961,0-32.931\r\n\tC545.48,293,549.9,287.63,555.41,285.6z\" />\r\n<path fill=\"#EF404B\" d=\"M552.65,297.99c-0.53-3.75,2.85-6.4,6.369-6.15c0.75,1.97,1.061,4.07,0.971,6.18\r\n\tc-0.12,9.68,0.13,19.38-0.11,29.06c0.17,3.56-3.51,6.16-6.83,4.949C552.14,320.72,552.81,309.33,552.65,297.99z\" />\r\n<path fill=\"#FFFFFF\" d=\"M511.94,309.98c-0.03-7.53,6.479-14.52,14.06-14.76c3.29,0.01,6.31,2.45,6.95,5.69\r\n\tc0.45,2.73,0.3,5.52,0.38,8.28c-2.13,0.57-5,2.76-6.811,0.5c-1.199-2.23,0.41-6.01-2.539-7.16c-3.36-0.19-5.311,3.51-4.99,6.47\r\n\tc0.149,10.63-0.271,21.279,0.21,31.891c1.39,3.799,6.149,0.83,6.689-2c0.45-3.57,0.471-7.211,0.13-10.781\r\n\tc-2.359-1.659-2.269-4.429-2.09-7.02c2.99-0.91,5.94-2.11,9.11-2.28c0.46,6.74,0.07,13.51,0.22,20.26\r\n\tc-0.06,2.25,0.271,4.56-0.37,6.75c-1.31,0.83-2.529,0.1-3.649-0.6c-3.01,2.779-6.931,5.449-11.24,4.609\r\n\tc-3.62-0.66-6.14-4.21-6.05-7.801C511.88,331.35,511.9,320.66,511.94,309.98z\" />\r\n</symbol>"
	});
	var result = sprite.add(symbol);
	module.exports = symbol

/***/ }),
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(50);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactRouterDom = __webpack_require__(86);
	
	var _cloudinaryReact = __webpack_require__(120);
	
	var _cloudinaryCore = __webpack_require__(19);
	
	var _cloudinaryCore2 = _interopRequireDefault(_cloudinaryCore);
	
	var _ContactModel = __webpack_require__(106);
	
	var _ContactModel2 = _interopRequireDefault(_ContactModel);
	
	var _gooseLogo = __webpack_require__(217);
	
	var _gooseLogo2 = _interopRequireDefault(_gooseLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var cloudinaryCore = new _cloudinaryCore2.default.Cloudinary({ cloud_name: 'wearegoosebclandingpage', secure: true });
	
	var GooseLogo = _react2.default.createElement(
	  'svg',
	  null,
	  _react2.default.createElement('use', { xlinkHref: '#' + _gooseLogo2.default.id })
	);
	
	var MagnessCaseStudyRoute = function (_React$Component) {
	  _inherits(MagnessCaseStudyRoute, _React$Component);
	
	  function MagnessCaseStudyRoute() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MagnessCaseStudyRoute);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = { contactModelActive: false }, _this.handleContactModelClick = function () {
	      _this.setState({ contactModelActive: !_this.state.contactModelActive });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  MagnessCaseStudyRoute.prototype.render = function render() {
	    var _props$data$site$site = this.props.data.site.siteMetadata,
	        contactEmail = _props$data$site$site.contactEmail,
	        title = _props$data$site$site.title,
	        subtitle = _props$data$site$site.subtitle,
	        contactNumber = _props$data$site$site.contactNumber,
	        keywords = _props$data$site$site.keywords,
	        socialLinks = _props$data$site$site.socialLinks;
	
	    return _react2.default.createElement(
	      'section',
	      { className: 'c-caseStudy l-homeServices' },
	      _react2.default.createElement(
	        _cloudinaryReact.CloudinaryContext,
	        { cloudName: 'wearegoosebclandingpage', fetchFormat: 'auto', secure: 'true', width: 'auto', quality: 'auto', dpr: 'auto' },
	        _react2.default.createElement(
	          'div',
	          { className: 'vc-bg-lines dark' },
	          _react2.default.createElement('div', null),
	          _react2.default.createElement('div', null),
	          _react2.default.createElement('div', null),
	          _react2.default.createElement('div', null),
	          _react2.default.createElement('div', null),
	          _react2.default.createElement('div', null),
	          _react2.default.createElement('div', null)
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'c-jobDescription' },
	          _react2.default.createElement(
	            'div',
	            { className: 'u-container u-container--s' },
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'div',
	              { className: 'l-bigCommerceBenefits__badge' },
	              GooseLogo
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'div',
	              { className: 'c-caseStudyIntro l-caseStudyIntro' },
	              _react2.default.createElement(
	                'div',
	                { className: 'l-caseStudyIntro__text' },
	                _react2.default.createElement(
	                  'p',
	                  { className: 'o-tgQuote' },
	                  'Client: Magness Benrow / Platform: BigCommerce'
	                ),
	                _react2.default.createElement(
	                  'h1',
	                  null,
	                  'Making change today, for sustainable growth tomorrow'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'u-intro' },
	                  'How we rescued a NZ retailer from a dying platform, and propelled them into their next phase of growth.'
	                ),
	                ' ',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Before we start, it\u2019s important that you know something about us: we love brazen honesty and a good story. '
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  '(This one\u2019s great)'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'We\u2019ll share as much as we can. But if, by the end of this case study, you still have unanswered questions, please get in touch at ',
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'mailto:info@wearegoose.co.nz' },
	                    'info@wearegoose.co.nz'
	                  ),
	                  '. '
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'l-caseStudyIntro__image' },
	                _react2.default.createElement(_cloudinaryReact.Image, { alt: 'Magness BigCommerce Website', publicId: 'lp-case-mac' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'u-container u-container--xs' },
	              _react2.default.createElement(
	                'h2',
	                { className: 'u-h3' },
	                'Tired of long, self-aggrandising case studies?'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'Here\u2019s the short version:'
	                )
	              ),
	              _react2.default.createElement(
	                'ul',
	                null,
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Magento 1 was reaching end of life, and Magness Benrow needed to move platforms.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'BigCommerce was an ideal fit, and their new online store launched in February 2020.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'The world changed overnight. Hello pandemic. '
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'We developed a flexible, proactive digital strategy in line with New Zealand\u2019s 4 tier alert system.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Magness Benrow experienced unprecedented growth in unprecedented times'
	                  ),
	                  ' (keep reading for the figures).'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'We built an MYOB integration for BigCommerce and automated bulk price updates to help them keep up.'
	                )
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement('br', null)
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'u-container u-container--m c-caseStudy__2x2' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col' },
	                _react2.default.createElement(_cloudinaryReact.Image, { className: 'u-imgFull', alt: 'Magness BigCommerce MYOB', publicId: '75thannv-mb' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'col' },
	                _react2.default.createElement(_cloudinaryReact.Image, { className: 'u-imgFull', alt: 'Magness BigCommerce MYOB', publicId: '75thannv-2-mb' })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'u-container u-container--xs' },
	              _react2.default.createElement(
	                'h3',
	                null,
	                'Our History'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Magness Benrow was one of our very first clients. They\u2019re a retailer with a long history, and famous for their iconic radio ads.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'They\u2019re also a family business. While John, son of the original founder, calls the shots, much of the business is under the care of his children, who we work with directly.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'With such a strong history of brick-and-mortar success, their online store and promotions has not always been the priority.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Our story starts when they were seeking support for their Magento store.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'To understand what happened next, it\u2019s important to first understand how we work with new clients. Our first approach is always to work with what we can.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Often, clients have been recommended \u201Cthe latest technologies\u201D and \u201Ccutting edge strategies\u201D. These approaches often overlook the simple interventions that can have a bigger impact in a shorter time frame. As a result, they\u2019re tired of conflicting advice, being told they just need to improve their page speed score, and just want things to be easier. We don\u2019t blame them.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'We focus on small, incremental change because we know that the implementation of high-return technologies and marketing strategies is not exclusive to the biggest companies (with the biggest budgets). It\'s about taking what you have and working it to your best advantage. '
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'The move to Magento had already been a big step for Magness Benrow, so we spent the early years of our relationship maintaining and improving the environment where we could. '
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'But, with a huge amount of manual processes and ongoing security updates and bug fixes, we\u2019d continually draw their attention back to the big picture: one day, you\u2019ll have to move.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'But, the online store was generating revenue. They were making money. And it was doing its job.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Until Adobe announced that Magento 1 was being retired. The move was on the horizon.'
	              )
	            ),
	            ' ',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'div',
	              { className: 'u-container u-container--xs' },
	              _react2.default.createElement(
	                'h3',
	                null,
	                'The move to ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'BigCommerce'
	                )
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Magness Benrow had been understandably resistant to moving to a new platform. They had experienced what \u2018starting from scratch\u2019 looked like, and didn\u2019t want to go there again.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'But, thanks to our intimate knowledge of their system, we knew we could replicate what they already had - and improve it.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'They wouldn\u2019t be starting from scratch.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'First, we took stock of their old online store. We reviewed the full set of features, how they were using the site, and customer feedback. We really considered what would help them grow in the way we always knew they could.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'We compared a number of platforms and recommended BigCommerce for its flexibility and ease of management. It was 2019, and we didn\u2019t know just how important those factors would be.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'The build was carried out between December 2019 and February 2020 - and we saw an immediate growth in online sales.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Where their previous budget was mostly spent on development, with BigCommerce we could shift that spend to managing more agile and effective promotions. In the Magento environment, every promotion required 2 to 3 days minimum lead time, and access to a senior Magento developer to make the necessary changes.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Now, our clever marketers can quickly set up promotions, within a single business day.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'When the site launched, it launched using a custom Mainfreight shipping integration embedded in the checkout process. By using a newly released shipping API (and being one of the first to do so) we were able to build an app to show live shipping rates from Mainfreight. This means that customers can receive accurate shipping costs, and both Magness Benrow and their customers save money.'
	              ),
	              _react2.default.createElement('hr', { className: 'c-caseStudy--hrspacer' }),
	              _react2.default.createElement(
	                'h4',
	                null,
	                'Timeline'
	              ),
	              _react2.default.createElement(
	                'ul',
	                null,
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'December, 2019 \u2192'
	                  ),
	                  ' Build starts.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'February, 2020 \u2192'
	                  ),
	                  ' Site live\u2026.and New Zealand records it\u2019s first COVID case.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'March, 2020 \u2192'
	                  ),
	                  ' 4 tier alert system announced, lock down starts.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'May, 2020 \u2192'
	                  ),
	                  ' Nationwide lock down lifts.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'March, 2021 \u2192'
	                  ),
	                  ' Magness Benrow records figures showing ',
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'online growth of 358.91% EOFY'
	                  ),
	                  '.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'April, 2021 \u2192'
	                  ),
	                  ' Developed MYOB integration and introduced new automations.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'June, 2021 \u2192'
	                  ),
	                  ' Magness Benrow continues to show ',
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'online growth of 18% compared to last year'
	                  ),
	                  '.'
	                )
	              ),
	              _react2.default.createElement('hr', { className: 'c-caseStudy--hrspacer' }),
	              ' ',
	              _react2.default.createElement('br', null)
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'u-container u-container--m' },
	              _react2.default.createElement(
	                'div',
	                { className: 'col' },
	                _react2.default.createElement(_cloudinaryReact.Image, { className: 'u-imgFull', alt: 'Magness BigCommerce MYOB', publicId: 'covid-banner-mb' })
	              )
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'div',
	              { className: 'u-container u-container--xs' },
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'h3',
	                null,
	                'A COVID-safe strategy'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'We tell our clients that they can shift their problems to us, so they can focus on their next big idea.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'A global pandemic was no exception.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'We proactively delivered a digital and marketing strategy to Magness Benrow to cover the scenarios we could plan for. Once the 4 tier alert system was announced, we made a plan to consider online operations and promotions under tiers 3 and 4, and adjustments depending on whether the stores would be considered essential or non-essential (a status which changed over the course of New Zealand\u2019s national lockdown).'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'As the situation progressed, we were able to quickly respond and move to the most appropriate strategy for that moment in time.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'These strategies focused on how we could take the entire in-store experience online. They prioritised:'
	              ),
	              _react2.default.createElement(
	                'ul',
	                null,
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'The use of a landing page to communicate the store\u2019s status and COVID-safe practices with customers.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Increased use of email marketing.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Live chat.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Strategic homepage design and promotions, including promotion of click and collect.'
	                )
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Of course, it is in our interests to be proactive. We agree to reach specific revenue targets as performance metrics with our clients, and we take on responsibility for the success of their online store. '
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'And that\'s exactly what we did here.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'For the first time, the online store has become a main pillar of the businesses.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Over 2020 - with a new site and responsive digital and marketing strategy - Magness Benrow\u2019s conversion rate increased by 187.04%. ',
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'Their revenue grew by 381% compared to the previous year'
	                ),
	                '.'
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'h3',
	                null,
	                'Growth, automation and integration'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Of course, not every cloud has a silver lining. This part of the story could also be called \u2018expect the unexpected\u2019.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Alongside the huge growth of online sales, one store\u2019s visitation decreased sharply - including for click and collect. That store closed in 2020. But this isn\u2019t a story of job loss. Instead, it\u2019s about a job shift, as the team from that store are now involved in the fulfilment of online store orders. Online sales have replaced - and surpassed - that store\u2019s sales.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Growth at this scale does expose issues with processes.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Magness Benrow were still printing and manually entering all online orders into the MYOB POS system, which was also being used to manage inventory. We developed an integration with MYOB\u2019s POS software to automate this process. This ensures that the orders are entered accurately and provides the business real-time information on their inventory and stock levels. It also saves huge amounts of time and energy, freeing the team up to work on growth-focused projects.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'We also took this opportunity to address one of the other manual processes in the business. Magness Benrow were manually having to update prices for their very regular price adjustments, and every promotion that was run. As they were changing the prices, products weren\u2019t being added to categories to appear correctly in the online store.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'Now they:'
	                )
	              ),
	              _react2.default.createElement(
	                'ol',
	                null,
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Open a secure FTP portal online.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Upload a CSV file.'
	                )
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'And a script developed by our team:'
	                )
	              ),
	              _react2.default.createElement(
	                'ul',
	                null,
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Updates the prices.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  'Sorts the products into categories based on their SKU.'
	                )
	              ),
	              ' ',
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'p',
	                null,
	                'This simple, low cost adjustment, has saved hours across the year, and freed up key staff at peak times. For example, they no longer have to spend their Christmas afternoon loading prices for Boxing Day sales. They can have a nap on the lounge like the rest of us! Taking this phased approach has helped them manage their budget, while still competing with larger competitors.'
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'h3',
	                null,
	                'Our roadmap'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'The growth experienced during the pandemic has held. '
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'This isn\u2019t a one off.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Once the BigCommerce site was live, the growth experienced in 2020 shifted our focus to automations and integrations.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'This will continue to be the focus going forward. We\u2019ll need to keep looking at streamlining systems so the online store can run as efficiently as possible.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'We always take a phased approach, to help our clients manage change, time, and cashflow, and take on the competition.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Now, their biggest competitors are asking, \u201CHow did they do that?\u201D'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'And we say, they found the right wingman.'
	              ),
	              _react2.default.createElement('br', null),
	              _react2.default.createElement('br', null)
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'c-apply' },
	              _react2.default.createElement(
	                'div',
	                { className: 'c-applyBox l-applyBox' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'c-applyBox__content' },
	                  _react2.default.createElement(
	                    'h4',
	                    { className: 'c-applyBox__header u-h3' },
	                    'Need a new wingman?'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'We help retailers succeed online. We can suggest a roadmap to help you make a big impact today, and grow steadily into the future.'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'c-applyBox__text' },
	                    'It all starts with a ',
	                    _react2.default.createElement(
	                      's',
	                      null,
	                      'conversation'
	                    ),
	                    ' coffee (our shout!). ',
	                    _react2.default.createElement(
	                      'a',
	                      { href: 'mailto:info@wearegoose.co.nz' },
	                      'Get in touch.'
	                    ),
	                    ' '
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_ContactModel2.default, { toggleContactModel: this.handleContactModelClick, siteMeta: this.props.data.site.siteMetadata, ContactModelStatus: this.state.contactModelActive })
	      )
	    );
	  };
	
	  return MagnessCaseStudyRoute;
	}(_react2.default.Component);
	
	exports.default = MagnessCaseStudyRoute;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })
]);


// WEBPACK FOOTER //
// component---src-pages-magness-bigcommerce-jsx-5ff77b28fe10e3863242.js